export default {
  "type": "FeatureCollection",
  "features": [
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -76.384,
                37.233
              ],
              [
                -76.389,
                37.221
              ],
              [
                -76.407,
                37.225
              ],
              [
                -76.41,
                37.233
              ],
              [
                -76.384,
                37.233
              ]
            ]
          ],
          [
            [
              [
                -76.673,
                37.37
              ],
              [
                -76.661,
                37.367
              ],
              [
                -76.656,
                37.349
              ],
              [
                -76.644,
                37.338
              ],
              [
                -76.628,
                37.312
              ],
              [
                -76.6,
                37.29
              ],
              [
                -76.584,
                37.283
              ],
              [
                -76.586,
                37.274
              ],
              [
                -76.551,
                37.267
              ],
              [
                -76.551,
                37.264
              ],
              [
                -76.527,
                37.245
              ],
              [
                -76.506,
                37.237
              ],
              [
                -76.491,
                37.227
              ],
              [
                -76.469,
                37.217
              ],
              [
                -76.418,
                37.224
              ],
              [
                -76.42,
                37.214
              ],
              [
                -76.436,
                37.216
              ],
              [
                -76.431,
                37.206
              ],
              [
                -76.396,
                37.212
              ],
              [
                -76.39,
                37.201
              ],
              [
                -76.392,
                37.182
              ],
              [
                -76.406,
                37.192
              ],
              [
                -76.416,
                37.196
              ],
              [
                -76.424,
                37.188
              ],
              [
                -76.409,
                37.183
              ],
              [
                -76.407,
                37.174
              ],
              [
                -76.416,
                37.164
              ],
              [
                -76.426,
                37.162
              ],
              [
                -76.427,
                37.149
              ],
              [
                -76.444,
                37.152
              ],
              [
                -76.447,
                37.145
              ],
              [
                -76.426,
                37.141
              ],
              [
                -76.415,
                37.154
              ],
              [
                -76.409,
                37.149
              ],
              [
                -76.414,
                37.138
              ],
              [
                -76.395,
                37.11
              ],
              [
                -76.402,
                37.095
              ],
              [
                -76.433,
                37.095
              ],
              [
                -76.454,
                37.101
              ],
              [
                -76.466,
                37.108
              ],
              [
                -76.481,
                37.124
              ],
              [
                -76.526,
                37.177
              ],
              [
                -76.565,
                37.22
              ],
              [
                -76.575,
                37.213
              ],
              [
                -76.593,
                37.215
              ],
              [
                -76.596,
                37.232
              ],
              [
                -76.601,
                37.238
              ],
              [
                -76.625,
                37.234
              ],
              [
                -76.651,
                37.239
              ],
              [
                -76.658,
                37.245
              ],
              [
                -76.665,
                37.264
              ],
              [
                -76.68,
                37.266
              ],
              [
                -76.685,
                37.271
              ],
              [
                -76.677,
                37.278
              ],
              [
                -76.682,
                37.293
              ],
              [
                -76.69,
                37.293
              ],
              [
                -76.701,
                37.283
              ],
              [
                -76.715,
                37.282
              ],
              [
                -76.729,
                37.312
              ],
              [
                -76.736,
                37.324
              ],
              [
                -76.736,
                37.332
              ],
              [
                -76.754,
                37.339
              ],
              [
                -76.755,
                37.354
              ],
              [
                -76.742,
                37.371
              ],
              [
                -76.73,
                37.372
              ],
              [
                -76.715,
                37.366
              ],
              [
                -76.688,
                37.37
              ],
              [
                -76.673,
                37.37
              ]
            ]
          ]
        ]
      },
      "properties": {
        "name": "York County",
        "id": "51199",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51199"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -80.737,
              36.882
            ],
            [
              -80.792,
              36.865
            ],
            [
              -80.82,
              36.855
            ],
            [
              -80.843,
              36.85
            ],
            [
              -80.855,
              36.85
            ],
            [
              -81.015,
              36.811
            ],
            [
              -81.036,
              36.814
            ],
            [
              -81.047,
              36.807
            ],
            [
              -81.063,
              36.797
            ],
            [
              -81.086,
              36.787
            ],
            [
              -81.092,
              36.769
            ],
            [
              -81.116,
              36.769
            ],
            [
              -81.144,
              36.766
            ],
            [
              -81.16,
              36.769
            ],
            [
              -81.171,
              36.762
            ],
            [
              -81.184,
              36.764
            ],
            [
              -81.196,
              36.76
            ],
            [
              -81.214,
              36.76
            ],
            [
              -81.233,
              36.763
            ],
            [
              -81.262,
              36.765
            ],
            [
              -81.289,
              36.825
            ],
            [
              -81.3,
              36.843
            ],
            [
              -81.321,
              36.873
            ],
            [
              -81.326,
              36.892
            ],
            [
              -81.336,
              36.906
            ],
            [
              -81.38,
              36.952
            ],
            [
              -81.373,
              36.966
            ],
            [
              -81.356,
              36.964
            ],
            [
              -81.35,
              36.967
            ],
            [
              -81.326,
              36.989
            ],
            [
              -81.284,
              37.02
            ],
            [
              -81.241,
              37.036
            ],
            [
              -81.227,
              37.045
            ],
            [
              -81.206,
              37.045
            ],
            [
              -81.179,
              37.027
            ],
            [
              -81.167,
              37.026
            ],
            [
              -81.131,
              37.037
            ],
            [
              -81.113,
              37.022
            ],
            [
              -81.107,
              37.021
            ],
            [
              -81.023,
              37.049
            ],
            [
              -81.007,
              37.052
            ],
            [
              -80.982,
              37.055
            ],
            [
              -80.915,
              37.074
            ],
            [
              -80.895,
              37.028
            ],
            [
              -80.809,
              36.953
            ],
            [
              -80.802,
              36.942
            ],
            [
              -80.737,
              36.882
            ]
          ]
        ]
      },
      "properties": {
        "name": "Wythe County",
        "id": "51197",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51197"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -82.328,
              36.971
            ],
            [
              -82.299,
              36.906
            ],
            [
              -82.324,
              36.902
            ],
            [
              -82.329,
              36.897
            ],
            [
              -82.347,
              36.9
            ],
            [
              -82.354,
              36.893
            ],
            [
              -82.369,
              36.895
            ],
            [
              -82.399,
              36.881
            ],
            [
              -82.401,
              36.886
            ],
            [
              -82.618,
              36.881
            ],
            [
              -82.635,
              36.878
            ],
            [
              -82.651,
              36.862
            ],
            [
              -82.658,
              36.844
            ],
            [
              -82.678,
              36.834
            ],
            [
              -82.685,
              36.825
            ],
            [
              -82.699,
              36.817
            ],
            [
              -82.729,
              36.829
            ],
            [
              -82.748,
              36.83
            ],
            [
              -82.755,
              36.826
            ],
            [
              -82.77,
              36.806
            ],
            [
              -82.77,
              36.799
            ],
            [
              -82.78,
              36.807
            ],
            [
              -82.835,
              36.848
            ],
            [
              -82.845,
              36.846
            ],
            [
              -82.851,
              36.87
            ],
            [
              -82.863,
              36.877
            ],
            [
              -82.878,
              36.893
            ],
            [
              -82.87,
              36.9
            ],
            [
              -82.873,
              36.91
            ],
            [
              -82.86,
              36.928
            ],
            [
              -82.862,
              36.94
            ],
            [
              -82.856,
              36.953
            ],
            [
              -82.869,
              36.969
            ],
            [
              -82.865,
              36.979
            ],
            [
              -82.839,
              36.986
            ],
            [
              -82.832,
              36.992
            ],
            [
              -82.823,
              37.006
            ],
            [
              -82.782,
              37.01
            ],
            [
              -82.76,
              37.026
            ],
            [
              -82.745,
              37.029
            ],
            [
              -82.738,
              37.043
            ],
            [
              -82.72,
              37.048
            ],
            [
              -82.724,
              37.072
            ],
            [
              -82.715,
              37.082
            ],
            [
              -82.72,
              37.089
            ],
            [
              -82.724,
              37.114
            ],
            [
              -82.721,
              37.121
            ],
            [
              -82.689,
              37.135
            ],
            [
              -82.66,
              37.145
            ],
            [
              -82.655,
              37.149
            ],
            [
              -82.633,
              37.157
            ],
            [
              -82.611,
              37.172
            ],
            [
              -82.552,
              37.204
            ],
            [
              -82.543,
              37.124
            ],
            [
              -82.492,
              37.06
            ],
            [
              -82.494,
              37.051
            ],
            [
              -82.491,
              37.031
            ],
            [
              -82.483,
              37.024
            ],
            [
              -82.468,
              37.023
            ],
            [
              -82.404,
              36.985
            ],
            [
              -82.372,
              36.975
            ],
            [
              -82.366,
              36.97
            ],
            [
              -82.363,
              36.956
            ],
            [
              -82.346,
              36.959
            ],
            [
              -82.328,
              36.971
            ]
          ],
          [
            [
              -82.596,
              36.957
            ],
            [
              -82.604,
              36.952
            ],
            [
              -82.618,
              36.957
            ],
            [
              -82.633,
              36.952
            ],
            [
              -82.656,
              36.928
            ],
            [
              -82.655,
              36.918
            ],
            [
              -82.645,
              36.9
            ],
            [
              -82.637,
              36.904
            ],
            [
              -82.618,
              36.906
            ],
            [
              -82.612,
              36.912
            ],
            [
              -82.621,
              36.923
            ],
            [
              -82.619,
              36.931
            ],
            [
              -82.591,
              36.935
            ],
            [
              -82.596,
              36.957
            ]
          ]
        ]
      },
      "properties": {
        "name": "Wise County",
        "id": "51195",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51195"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.172,
              39.143
            ],
            [
              -78.179,
              39.135
            ],
            [
              -78.198,
              39.142
            ],
            [
              -78.189,
              39.174
            ],
            [
              -78.201,
              39.179
            ],
            [
              -78.196,
              39.193
            ],
            [
              -78.188,
              39.205
            ],
            [
              -78.16,
              39.198
            ],
            [
              -78.137,
              39.184
            ],
            [
              -78.153,
              39.172
            ],
            [
              -78.165,
              39.157
            ],
            [
              -78.172,
              39.143
            ]
          ]
        ]
      },
      "properties": {
        "name": "Winchester City",
        "id": "51840",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51840"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.729,
              37.312
            ],
            [
              -76.715,
              37.282
            ],
            [
              -76.701,
              37.283
            ],
            [
              -76.69,
              37.293
            ],
            [
              -76.682,
              37.293
            ],
            [
              -76.677,
              37.278
            ],
            [
              -76.685,
              37.271
            ],
            [
              -76.68,
              37.266
            ],
            [
              -76.666,
              37.251
            ],
            [
              -76.673,
              37.247
            ],
            [
              -76.706,
              37.248
            ],
            [
              -76.728,
              37.25
            ],
            [
              -76.741,
              37.266
            ],
            [
              -76.738,
              37.28
            ],
            [
              -76.727,
              37.28
            ],
            [
              -76.741,
              37.307
            ],
            [
              -76.729,
              37.312
            ]
          ]
        ]
      },
      "properties": {
        "name": "Williamsburg City",
        "id": "51830",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51830"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.559,
              38.027
            ],
            [
              -76.569,
              38.026
            ],
            [
              -76.588,
              38.008
            ],
            [
              -76.597,
              38.004
            ],
            [
              -76.617,
              38
            ],
            [
              -76.63,
              37.986
            ],
            [
              -76.636,
              37.968
            ],
            [
              -76.65,
              37.971
            ],
            [
              -76.656,
              37.981
            ],
            [
              -76.665,
              37.985
            ],
            [
              -76.687,
              37.983
            ],
            [
              -76.705,
              37.987
            ],
            [
              -76.734,
              38.001
            ],
            [
              -76.751,
              37.996
            ],
            [
              -76.769,
              38.002
            ],
            [
              -76.763,
              38.008
            ],
            [
              -76.765,
              38.019
            ],
            [
              -76.761,
              38.033
            ],
            [
              -76.786,
              38.049
            ],
            [
              -76.798,
              38.059
            ],
            [
              -76.807,
              38.061
            ],
            [
              -76.817,
              38.056
            ],
            [
              -76.862,
              38.101
            ],
            [
              -76.866,
              38.116
            ],
            [
              -76.874,
              38.123
            ],
            [
              -76.89,
              38.122
            ],
            [
              -76.91,
              38.105
            ],
            [
              -76.913,
              38.098
            ],
            [
              -76.937,
              38.086
            ],
            [
              -76.955,
              38.093
            ],
            [
              -76.976,
              38.095
            ],
            [
              -76.985,
              38.102
            ],
            [
              -76.989,
              38.115
            ],
            [
              -77.011,
              38.113
            ],
            [
              -77.015,
              38.105
            ],
            [
              -77.03,
              38.103
            ],
            [
              -77.043,
              38.112
            ],
            [
              -77.048,
              38.119
            ],
            [
              -77.047,
              38.148
            ],
            [
              -77.049,
              38.158
            ],
            [
              -77.067,
              38.165
            ],
            [
              -77.054,
              38.179
            ],
            [
              -77.056,
              38.205
            ],
            [
              -77.053,
              38.26
            ],
            [
              -77.034,
              38.259
            ],
            [
              -77.026,
              38.27
            ],
            [
              -77.016,
              38.27
            ],
            [
              -77.007,
              38.276
            ],
            [
              -76.993,
              38.277
            ],
            [
              -76.981,
              38.275
            ],
            [
              -76.967,
              38.265
            ],
            [
              -76.958,
              38.251
            ],
            [
              -76.973,
              38.248
            ],
            [
              -76.972,
              38.235
            ],
            [
              -76.963,
              38.218
            ],
            [
              -76.981,
              38.216
            ],
            [
              -76.988,
              38.203
            ],
            [
              -76.974,
              38.207
            ],
            [
              -76.959,
              38.205
            ],
            [
              -76.948,
              38.209
            ],
            [
              -76.938,
              38.205
            ],
            [
              -76.916,
              38.2
            ],
            [
              -76.914,
              38.194
            ],
            [
              -76.921,
              38.179
            ],
            [
              -76.909,
              38.181
            ],
            [
              -76.904,
              38.193
            ],
            [
              -76.878,
              38.175
            ],
            [
              -76.86,
              38.172
            ],
            [
              -76.837,
              38.164
            ],
            [
              -76.829,
              38.164
            ],
            [
              -76.805,
              38.17
            ],
            [
              -76.784,
              38.17
            ],
            [
              -76.772,
              38.166
            ],
            [
              -76.762,
              38.149
            ],
            [
              -76.755,
              38.145
            ],
            [
              -76.751,
              38.134
            ],
            [
              -76.731,
              38.133
            ],
            [
              -76.72,
              38.116
            ],
            [
              -76.722,
              38.111
            ],
            [
              -76.749,
              38.11
            ],
            [
              -76.735,
              38.1
            ],
            [
              -76.738,
              38.091
            ],
            [
              -76.734,
              38.078
            ],
            [
              -76.706,
              38.075
            ],
            [
              -76.726,
              38.088
            ],
            [
              -76.726,
              38.101
            ],
            [
              -76.708,
              38.108
            ],
            [
              -76.706,
              38.124
            ],
            [
              -76.718,
              38.137
            ],
            [
              -76.712,
              38.143
            ],
            [
              -76.702,
              38.162
            ],
            [
              -76.69,
              38.161
            ],
            [
              -76.684,
              38.155
            ],
            [
              -76.666,
              38.147
            ],
            [
              -76.659,
              38.137
            ],
            [
              -76.645,
              38.129
            ],
            [
              -76.637,
              38.137
            ],
            [
              -76.643,
              38.151
            ],
            [
              -76.613,
              38.148
            ],
            [
              -76.614,
              38.144
            ],
            [
              -76.606,
              38.131
            ],
            [
              -76.603,
              38.121
            ],
            [
              -76.609,
              38.112
            ],
            [
              -76.598,
              38.105
            ],
            [
              -76.558,
              38.088
            ],
            [
              -76.535,
              38.076
            ],
            [
              -76.529,
              38.058
            ],
            [
              -76.52,
              38.05
            ],
            [
              -76.535,
              38.047
            ],
            [
              -76.546,
              38.063
            ],
            [
              -76.553,
              38.062
            ],
            [
              -76.555,
              38.051
            ],
            [
              -76.55,
              38.037
            ],
            [
              -76.559,
              38.027
            ]
          ]
        ]
      },
      "properties": {
        "name": "Westmoreland County",
        "id": "51193",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51193"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.889,
              38.097
            ],
            [
              -78.876,
              38.092
            ],
            [
              -78.865,
              38.096
            ],
            [
              -78.865,
              38.081
            ],
            [
              -78.855,
              38.075
            ],
            [
              -78.865,
              38.062
            ],
            [
              -78.865,
              38.049
            ],
            [
              -78.883,
              38.053
            ],
            [
              -78.903,
              38.05
            ],
            [
              -78.907,
              38.043
            ],
            [
              -78.922,
              38.032
            ],
            [
              -78.93,
              38.049
            ],
            [
              -78.948,
              38.053
            ],
            [
              -78.951,
              38.069
            ],
            [
              -78.938,
              38.077
            ],
            [
              -78.929,
              38.091
            ],
            [
              -78.903,
              38.098
            ],
            [
              -78.889,
              38.097
            ]
          ]
        ]
      },
      "properties": {
        "name": "Waynesboro City",
        "id": "51820",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51820"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -81.605,
              36.641
            ],
            [
              -81.611,
              36.617
            ],
            [
              -81.62,
              36.612
            ],
            [
              -81.647,
              36.613
            ],
            [
              -81.732,
              36.613
            ],
            [
              -81.862,
              36.615
            ],
            [
              -81.923,
              36.617
            ],
            [
              -81.935,
              36.595
            ],
            [
              -82.036,
              36.596
            ],
            [
              -82.145,
              36.595
            ],
            [
              -82.128,
              36.612
            ],
            [
              -82.106,
              36.629
            ],
            [
              -82.114,
              36.638
            ],
            [
              -82.14,
              36.637
            ],
            [
              -82.158,
              36.63
            ],
            [
              -82.188,
              36.623
            ],
            [
              -82.237,
              36.597
            ],
            [
              -82.293,
              36.596
            ],
            [
              -82.303,
              36.618
            ],
            [
              -82.322,
              36.685
            ],
            [
              -82.333,
              36.712
            ],
            [
              -82.309,
              36.727
            ],
            [
              -82.29,
              36.737
            ],
            [
              -82.19,
              36.774
            ],
            [
              -82.141,
              36.786
            ],
            [
              -82.105,
              36.798
            ],
            [
              -82.116,
              36.817
            ],
            [
              -82.114,
              36.827
            ],
            [
              -82.107,
              36.836
            ],
            [
              -82.065,
              36.857
            ],
            [
              -81.987,
              36.878
            ],
            [
              -81.978,
              36.871
            ],
            [
              -81.947,
              36.868
            ],
            [
              -81.927,
              36.875
            ],
            [
              -81.914,
              36.883
            ],
            [
              -81.89,
              36.889
            ],
            [
              -81.86,
              36.913
            ],
            [
              -81.834,
              36.93
            ],
            [
              -81.7,
              36.786
            ],
            [
              -81.618,
              36.635
            ],
            [
              -81.605,
              36.641
            ]
          ]
        ]
      },
      "properties": {
        "name": "Washington County",
        "id": "51191",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51191"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.152,
              39.037
            ],
            [
              -78.094,
              39.014
            ],
            [
              -78.055,
              39.02
            ],
            [
              -78.005,
              38.982
            ],
            [
              -78.017,
              38.97
            ],
            [
              -78.023,
              38.959
            ],
            [
              -78.034,
              38.951
            ],
            [
              -78.038,
              38.941
            ],
            [
              -78.064,
              38.932
            ],
            [
              -78.074,
              38.909
            ],
            [
              -78.064,
              38.901
            ],
            [
              -78.06,
              38.889
            ],
            [
              -78.076,
              38.882
            ],
            [
              -78.087,
              38.886
            ],
            [
              -78.108,
              38.879
            ],
            [
              -78.117,
              38.886
            ],
            [
              -78.132,
              38.863
            ],
            [
              -78.145,
              38.858
            ],
            [
              -78.169,
              38.836
            ],
            [
              -78.173,
              38.823
            ],
            [
              -78.182,
              38.818
            ],
            [
              -78.184,
              38.8
            ],
            [
              -78.194,
              38.783
            ],
            [
              -78.232,
              38.769
            ],
            [
              -78.236,
              38.764
            ],
            [
              -78.259,
              38.758
            ],
            [
              -78.278,
              38.763
            ],
            [
              -78.283,
              38.761
            ],
            [
              -78.288,
              38.767
            ],
            [
              -78.288,
              38.779
            ],
            [
              -78.297,
              38.785
            ],
            [
              -78.313,
              38.788
            ],
            [
              -78.331,
              38.795
            ],
            [
              -78.34,
              38.805
            ],
            [
              -78.354,
              38.809
            ],
            [
              -78.389,
              38.829
            ],
            [
              -78.334,
              38.881
            ],
            [
              -78.338,
              38.888
            ],
            [
              -78.327,
              38.902
            ],
            [
              -78.319,
              38.92
            ],
            [
              -78.309,
              38.926
            ],
            [
              -78.298,
              38.946
            ],
            [
              -78.336,
              38.977
            ],
            [
              -78.318,
              38.98
            ],
            [
              -78.328,
              38.991
            ],
            [
              -78.33,
              38.999
            ],
            [
              -78.314,
              39.01
            ],
            [
              -78.162,
              39.019
            ],
            [
              -78.159,
              39.029
            ],
            [
              -78.152,
              39.037
            ]
          ]
        ]
      },
      "properties": {
        "name": "Warren County",
        "id": "51187",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51187"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -75.926,
                36.659
              ],
              [
                -75.934,
                36.65
              ],
              [
                -75.933,
                36.637
              ],
              [
                -75.943,
                36.641
              ],
              [
                -75.951,
                36.658
              ],
              [
                -75.941,
                36.66
              ],
              [
                -75.944,
                36.673
              ],
              [
                -75.935,
                36.684
              ],
              [
                -75.926,
                36.659
              ]
            ]
          ],
          [
            [
              [
                -76.122,
                36.55
              ],
              [
                -76.122,
                36.668
              ],
              [
                -76.111,
                36.669
              ],
              [
                -76.103,
                36.675
              ],
              [
                -76.075,
                36.683
              ],
              [
                -76.069,
                36.696
              ],
              [
                -76.088,
                36.714
              ],
              [
                -76.101,
                36.717
              ],
              [
                -76.144,
                36.758
              ],
              [
                -76.191,
                36.767
              ],
              [
                -76.202,
                36.771
              ],
              [
                -76.225,
                36.829
              ],
              [
                -76.222,
                36.837
              ],
              [
                -76.199,
                36.827
              ],
              [
                -76.177,
                36.856
              ],
              [
                -76.189,
                36.865
              ],
              [
                -76.19,
                36.873
              ],
              [
                -76.198,
                36.886
              ],
              [
                -76.188,
                36.905
              ],
              [
                -76.174,
                36.905
              ],
              [
                -76.16,
                36.891
              ],
              [
                -76.156,
                36.882
              ],
              [
                -76.14,
                36.883
              ],
              [
                -76.152,
                36.894
              ],
              [
                -76.157,
                36.906
              ],
              [
                -76.179,
                36.912
              ],
              [
                -76.169,
                36.928
              ],
              [
                -76.144,
                36.926
              ],
              [
                -76.111,
                36.914
              ],
              [
                -76.099,
                36.912
              ],
              [
                -76.098,
                36.905
              ],
              [
                -76.113,
                36.896
              ],
              [
                -76.12,
                36.882
              ],
              [
                -76.108,
                36.875
              ],
              [
                -76.122,
                36.857
              ],
              [
                -76.102,
                36.862
              ],
              [
                -76.094,
                36.88
              ],
              [
                -76.097,
                36.893
              ],
              [
                -76.089,
                36.894
              ],
              [
                -76.073,
                36.878
              ],
              [
                -76.079,
                36.861
              ],
              [
                -76.066,
                36.859
              ],
              [
                -76.064,
                36.871
              ],
              [
                -76.054,
                36.878
              ],
              [
                -76.064,
                36.888
              ],
              [
                -76.066,
                36.901
              ],
              [
                -76.085,
                36.902
              ],
              [
                -76.091,
                36.909
              ],
              [
                -76.082,
                36.915
              ],
              [
                -76.066,
                36.917
              ],
              [
                -76.04,
                36.932
              ],
              [
                -76.021,
                36.933
              ],
              [
                -76.01,
                36.93
              ],
              [
                -75.992,
                36.917
              ],
              [
                -75.986,
                36.894
              ],
              [
                -75.98,
                36.868
              ],
              [
                -75.971,
                36.839
              ],
              [
                -75.965,
                36.81
              ],
              [
                -75.951,
                36.763
              ],
              [
                -75.929,
                36.714
              ],
              [
                -75.925,
                36.702
              ],
              [
                -75.909,
                36.674
              ],
              [
                -75.888,
                36.62
              ],
              [
                -75.879,
                36.604
              ],
              [
                -75.869,
                36.551
              ],
              [
                -75.893,
                36.551
              ],
              [
                -75.898,
                36.568
              ],
              [
                -75.887,
                36.575
              ],
              [
                -75.892,
                36.591
              ],
              [
                -75.891,
                36.603
              ],
              [
                -75.904,
                36.611
              ],
              [
                -75.909,
                36.624
              ],
              [
                -75.916,
                36.665
              ],
              [
                -75.933,
                36.696
              ],
              [
                -75.942,
                36.716
              ],
              [
                -75.953,
                36.721
              ],
              [
                -75.966,
                36.715
              ],
              [
                -75.969,
                36.691
              ],
              [
                -75.974,
                36.675
              ],
              [
                -75.971,
                36.668
              ],
              [
                -75.978,
                36.647
              ],
              [
                -75.989,
                36.638
              ],
              [
                -75.983,
                36.631
              ],
              [
                -75.987,
                36.621
              ],
              [
                -75.981,
                36.587
              ],
              [
                -75.991,
                36.577
              ],
              [
                -75.984,
                36.551
              ],
              [
                -76.013,
                36.551
              ],
              [
                -76.014,
                36.568
              ],
              [
                -76.031,
                36.581
              ],
              [
                -76.037,
                36.581
              ],
              [
                -76.062,
                36.604
              ],
              [
                -76.067,
                36.597
              ],
              [
                -76.053,
                36.589
              ],
              [
                -76.045,
                36.58
              ],
              [
                -76.044,
                36.57
              ],
              [
                -76.035,
                36.562
              ],
              [
                -76.035,
                36.551
              ],
              [
                -76.122,
                36.55
              ]
            ]
          ],
          [
            [
              [
                -75.956,
                36.578
              ],
              [
                -75.969,
                36.559
              ],
              [
                -75.976,
                36.562
              ],
              [
                -75.977,
                36.578
              ],
              [
                -75.956,
                36.578
              ]
            ]
          ],
          [
            [
              [
                -75.921,
                36.565
              ],
              [
                -75.921,
                36.551
              ],
              [
                -75.962,
                36.55
              ],
              [
                -75.961,
                36.557
              ],
              [
                -75.951,
                36.565
              ],
              [
                -75.921,
                36.565
              ]
            ]
          ],
          [
            [
              [
                -76.187,
                36.911
              ],
              [
                -76.185,
                36.932
              ],
              [
                -76.181,
                36.925
              ],
              [
                -76.187,
                36.911
              ]
            ]
          ]
        ]
      },
      "properties": {
        "name": "Virginia Beach City",
        "id": "51810",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51810"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -81.228,
              37.234
            ],
            [
              -81.263,
              37.219
            ],
            [
              -81.286,
              37.216
            ],
            [
              -81.264,
              37.174
            ],
            [
              -81.3,
              37.164
            ],
            [
              -81.331,
              37.15
            ],
            [
              -81.329,
              37.14
            ],
            [
              -81.303,
              37.136
            ],
            [
              -81.295,
              37.131
            ],
            [
              -81.283,
              37.132
            ],
            [
              -81.268,
              37.129
            ],
            [
              -81.261,
              37.122
            ],
            [
              -81.269,
              37.096
            ],
            [
              -81.28,
              37.087
            ],
            [
              -81.322,
              37.069
            ],
            [
              -81.355,
              37.059
            ],
            [
              -81.375,
              37.055
            ],
            [
              -81.399,
              37.058
            ],
            [
              -81.411,
              37.053
            ],
            [
              -81.428,
              37.041
            ],
            [
              -81.462,
              37.036
            ],
            [
              -81.437,
              37.01
            ],
            [
              -81.464,
              36.995
            ],
            [
              -81.473,
              36.999
            ],
            [
              -81.468,
              37.013
            ],
            [
              -81.472,
              37.017
            ],
            [
              -81.497,
              37.013
            ],
            [
              -81.533,
              36.997
            ],
            [
              -81.571,
              36.989
            ],
            [
              -81.588,
              36.982
            ],
            [
              -81.615,
              36.966
            ],
            [
              -81.644,
              36.947
            ],
            [
              -81.684,
              36.932
            ],
            [
              -81.708,
              36.975
            ],
            [
              -81.756,
              36.962
            ],
            [
              -81.778,
              36.96
            ],
            [
              -81.803,
              37.01
            ],
            [
              -81.817,
              37.032
            ],
            [
              -81.851,
              37.076
            ],
            [
              -81.875,
              37.097
            ],
            [
              -81.885,
              37.104
            ],
            [
              -81.896,
              37.116
            ],
            [
              -81.904,
              37.142
            ],
            [
              -81.896,
              37.151
            ],
            [
              -81.869,
              37.155
            ],
            [
              -81.872,
              37.165
            ],
            [
              -81.856,
              37.172
            ],
            [
              -81.846,
              37.173
            ],
            [
              -81.832,
              37.179
            ],
            [
              -81.823,
              37.179
            ],
            [
              -81.789,
              37.189
            ],
            [
              -81.781,
              37.199
            ],
            [
              -81.759,
              37.204
            ],
            [
              -81.756,
              37.218
            ],
            [
              -81.744,
              37.224
            ],
            [
              -81.741,
              37.24
            ],
            [
              -81.722,
              37.237
            ],
            [
              -81.697,
              37.216
            ],
            [
              -81.675,
              37.203
            ],
            [
              -81.56,
              37.208
            ],
            [
              -81.542,
              37.22
            ],
            [
              -81.509,
              37.233
            ],
            [
              -81.496,
              37.256
            ],
            [
              -81.488,
              37.251
            ],
            [
              -81.463,
              37.258
            ],
            [
              -81.45,
              37.268
            ],
            [
              -81.438,
              37.272
            ],
            [
              -81.42,
              37.272
            ],
            [
              -81.409,
              37.283
            ],
            [
              -81.397,
              37.31
            ],
            [
              -81.391,
              37.316
            ],
            [
              -81.371,
              37.323
            ],
            [
              -81.359,
              37.336
            ],
            [
              -81.313,
              37.294
            ],
            [
              -81.228,
              37.234
            ]
          ]
        ]
      },
      "properties": {
        "name": "Tazewell County",
        "id": "51185",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51185"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.953,
              36.944
            ],
            [
              -77.012,
              36.916
            ],
            [
              -77.1,
              36.869
            ],
            [
              -77.155,
              36.841
            ],
            [
              -77.238,
              36.801
            ],
            [
              -77.287,
              36.778
            ],
            [
              -77.342,
              36.754
            ],
            [
              -77.4,
              36.723
            ],
            [
              -77.432,
              36.708
            ],
            [
              -77.444,
              36.713
            ],
            [
              -77.468,
              36.717
            ],
            [
              -77.479,
              36.723
            ],
            [
              -77.492,
              36.721
            ],
            [
              -77.469,
              36.815
            ],
            [
              -77.46,
              36.862
            ],
            [
              -77.474,
              36.861
            ],
            [
              -77.488,
              36.856
            ],
            [
              -77.503,
              36.845
            ],
            [
              -77.528,
              36.852
            ],
            [
              -77.55,
              36.852
            ],
            [
              -77.558,
              36.847
            ],
            [
              -77.581,
              36.854
            ],
            [
              -77.593,
              36.869
            ],
            [
              -77.608,
              36.877
            ],
            [
              -77.62,
              36.878
            ],
            [
              -77.405,
              36.993
            ],
            [
              -77.19,
              37.099
            ],
            [
              -77.155,
              37.108
            ],
            [
              -77.149,
              37.102
            ],
            [
              -77.106,
              37.093
            ],
            [
              -77.082,
              37.085
            ],
            [
              -77.076,
              37.076
            ],
            [
              -77.076,
              37.067
            ],
            [
              -77.049,
              37.062
            ],
            [
              -77.044,
              37.071
            ],
            [
              -77.028,
              37.067
            ],
            [
              -77.014,
              37.058
            ],
            [
              -76.995,
              37.05
            ],
            [
              -76.978,
              37.055
            ],
            [
              -76.966,
              37.053
            ],
            [
              -76.964,
              37.046
            ],
            [
              -76.97,
              37.033
            ],
            [
              -76.966,
              37.027
            ],
            [
              -76.962,
              36.981
            ],
            [
              -76.953,
              36.944
            ]
          ]
        ]
      },
      "properties": {
        "name": "Sussex County",
        "id": "51183",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51183"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.673,
              37.142
            ],
            [
              -76.68,
              37.121
            ],
            [
              -76.676,
              37.109
            ],
            [
              -76.682,
              37.105
            ],
            [
              -76.686,
              37.088
            ],
            [
              -76.693,
              37.083
            ],
            [
              -76.702,
              37.065
            ],
            [
              -76.701,
              37.057
            ],
            [
              -76.724,
              37.05
            ],
            [
              -76.772,
              37.031
            ],
            [
              -76.849,
              36.998
            ],
            [
              -76.953,
              36.944
            ],
            [
              -76.962,
              36.981
            ],
            [
              -76.966,
              37.027
            ],
            [
              -76.97,
              37.033
            ],
            [
              -76.964,
              37.046
            ],
            [
              -76.966,
              37.053
            ],
            [
              -76.978,
              37.055
            ],
            [
              -76.995,
              37.05
            ],
            [
              -77.014,
              37.058
            ],
            [
              -77.028,
              37.067
            ],
            [
              -77.044,
              37.071
            ],
            [
              -77.049,
              37.062
            ],
            [
              -77.076,
              37.067
            ],
            [
              -77.076,
              37.076
            ],
            [
              -77.082,
              37.085
            ],
            [
              -77.106,
              37.093
            ],
            [
              -77.149,
              37.102
            ],
            [
              -77.155,
              37.108
            ],
            [
              -77.094,
              37.168
            ],
            [
              -77.068,
              37.188
            ],
            [
              -77.025,
              37.202
            ],
            [
              -77.014,
              37.213
            ],
            [
              -77.016,
              37.22
            ],
            [
              -77.004,
              37.23
            ],
            [
              -76.984,
              37.24
            ],
            [
              -76.966,
              37.238
            ],
            [
              -76.948,
              37.231
            ],
            [
              -76.905,
              37.203
            ],
            [
              -76.895,
              37.201
            ],
            [
              -76.873,
              37.208
            ],
            [
              -76.817,
              37.206
            ],
            [
              -76.802,
              37.209
            ],
            [
              -76.801,
              37.195
            ],
            [
              -76.792,
              37.192
            ],
            [
              -76.781,
              37.18
            ],
            [
              -76.762,
              37.17
            ],
            [
              -76.747,
              37.151
            ],
            [
              -76.734,
              37.146
            ],
            [
              -76.717,
              37.148
            ],
            [
              -76.71,
              37.155
            ],
            [
              -76.703,
              37.171
            ],
            [
              -76.695,
              37.181
            ],
            [
              -76.692,
              37.193
            ],
            [
              -76.686,
              37.198
            ],
            [
              -76.665,
              37.178
            ],
            [
              -76.67,
              37.169
            ],
            [
              -76.673,
              37.142
            ]
          ]
        ]
      },
      "properties": {
        "name": "Surry County",
        "id": "51181",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51181"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.407,
              36.898
            ],
            [
              -76.409,
              36.883
            ],
            [
              -76.428,
              36.866
            ],
            [
              -76.434,
              36.859
            ],
            [
              -76.461,
              36.815
            ],
            [
              -76.463,
              36.769
            ],
            [
              -76.472,
              36.7
            ],
            [
              -76.491,
              36.55
            ],
            [
              -76.627,
              36.55
            ],
            [
              -76.916,
              36.551
            ],
            [
              -76.932,
              36.56
            ],
            [
              -76.927,
              36.572
            ],
            [
              -76.916,
              36.579
            ],
            [
              -76.91,
              36.61
            ],
            [
              -76.914,
              36.618
            ],
            [
              -76.901,
              36.622
            ],
            [
              -76.893,
              36.634
            ],
            [
              -76.902,
              36.644
            ],
            [
              -76.873,
              36.662
            ],
            [
              -76.841,
              36.685
            ],
            [
              -76.815,
              36.705
            ],
            [
              -76.783,
              36.726
            ],
            [
              -76.75,
              36.75
            ],
            [
              -76.61,
              36.859
            ],
            [
              -76.557,
              36.898
            ],
            [
              -76.541,
              36.912
            ],
            [
              -76.53,
              36.919
            ],
            [
              -76.526,
              36.91
            ],
            [
              -76.516,
              36.912
            ],
            [
              -76.504,
              36.91
            ],
            [
              -76.491,
              36.921
            ],
            [
              -76.484,
              36.919
            ],
            [
              -76.486,
              36.895
            ],
            [
              -76.511,
              36.888
            ],
            [
              -76.512,
              36.879
            ],
            [
              -76.519,
              36.877
            ],
            [
              -76.53,
              36.865
            ],
            [
              -76.532,
              36.854
            ],
            [
              -76.539,
              36.854
            ],
            [
              -76.549,
              36.844
            ],
            [
              -76.56,
              36.842
            ],
            [
              -76.563,
              36.831
            ],
            [
              -76.558,
              36.817
            ],
            [
              -76.563,
              36.798
            ],
            [
              -76.556,
              36.797
            ],
            [
              -76.556,
              36.81
            ],
            [
              -76.548,
              36.822
            ],
            [
              -76.55,
              36.834
            ],
            [
              -76.527,
              36.839
            ],
            [
              -76.515,
              36.847
            ],
            [
              -76.516,
              36.857
            ],
            [
              -76.507,
              36.859
            ],
            [
              -76.506,
              36.87
            ],
            [
              -76.492,
              36.867
            ],
            [
              -76.489,
              36.881
            ],
            [
              -76.456,
              36.886
            ],
            [
              -76.452,
              36.902
            ],
            [
              -76.439,
              36.906
            ],
            [
              -76.407,
              36.898
            ]
          ]
        ]
      },
      "properties": {
        "name": "Suffolk City",
        "id": "51800",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51800"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.035,
              38.197
            ],
            [
              -79.012,
              38.183
            ],
            [
              -79.023,
              38.176
            ],
            [
              -79.013,
              38.166
            ],
            [
              -79.019,
              38.144
            ],
            [
              -79.026,
              38.134
            ],
            [
              -79.048,
              38.121
            ],
            [
              -79.072,
              38.132
            ],
            [
              -79.079,
              38.129
            ],
            [
              -79.096,
              38.133
            ],
            [
              -79.109,
              38.14
            ],
            [
              -79.112,
              38.158
            ],
            [
              -79.095,
              38.188
            ],
            [
              -79.079,
              38.186
            ],
            [
              -79.05,
              38.187
            ],
            [
              -79.035,
              38.197
            ]
          ]
        ]
      },
      "properties": {
        "name": "Staunton City",
        "id": "51790",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51790"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.298,
              38.504
            ],
            [
              -77.309,
              38.49
            ],
            [
              -77.319,
              38.461
            ],
            [
              -77.32,
              38.433
            ],
            [
              -77.312,
              38.404
            ],
            [
              -77.316,
              38.396
            ],
            [
              -77.328,
              38.406
            ],
            [
              -77.337,
              38.422
            ],
            [
              -77.347,
              38.43
            ],
            [
              -77.371,
              38.442
            ],
            [
              -77.368,
              38.432
            ],
            [
              -77.358,
              38.43
            ],
            [
              -77.356,
              38.418
            ],
            [
              -77.339,
              38.399
            ],
            [
              -77.321,
              38.389
            ],
            [
              -77.298,
              38.373
            ],
            [
              -77.286,
              38.356
            ],
            [
              -77.297,
              38.353
            ],
            [
              -77.325,
              38.35
            ],
            [
              -77.336,
              38.357
            ],
            [
              -77.347,
              38.351
            ],
            [
              -77.359,
              38.354
            ],
            [
              -77.36,
              38.346
            ],
            [
              -77.346,
              38.343
            ],
            [
              -77.337,
              38.346
            ],
            [
              -77.323,
              38.34
            ],
            [
              -77.328,
              38.336
            ],
            [
              -77.327,
              38.321
            ],
            [
              -77.351,
              38.303
            ],
            [
              -77.341,
              38.287
            ],
            [
              -77.347,
              38.279
            ],
            [
              -77.346,
              38.262
            ],
            [
              -77.329,
              38.253
            ],
            [
              -77.328,
              38.245
            ],
            [
              -77.345,
              38.252
            ],
            [
              -77.36,
              38.243
            ],
            [
              -77.367,
              38.244
            ],
            [
              -77.381,
              38.249
            ],
            [
              -77.387,
              38.245
            ],
            [
              -77.407,
              38.255
            ],
            [
              -77.419,
              38.257
            ],
            [
              -77.426,
              38.268
            ],
            [
              -77.437,
              38.275
            ],
            [
              -77.448,
              38.287
            ],
            [
              -77.464,
              38.315
            ],
            [
              -77.48,
              38.317
            ],
            [
              -77.504,
              38.327
            ],
            [
              -77.528,
              38.32
            ],
            [
              -77.529,
              38.309
            ],
            [
              -77.542,
              38.316
            ],
            [
              -77.545,
              38.325
            ],
            [
              -77.561,
              38.335
            ],
            [
              -77.568,
              38.336
            ],
            [
              -77.571,
              38.349
            ],
            [
              -77.586,
              38.346
            ],
            [
              -77.599,
              38.334
            ],
            [
              -77.607,
              38.339
            ],
            [
              -77.603,
              38.347
            ],
            [
              -77.618,
              38.369
            ],
            [
              -77.619,
              38.383
            ],
            [
              -77.633,
              38.399
            ],
            [
              -77.634,
              38.409
            ],
            [
              -77.634,
              38.419
            ],
            [
              -77.629,
              38.438
            ],
            [
              -77.631,
              38.458
            ],
            [
              -77.617,
              38.475
            ],
            [
              -77.584,
              38.509
            ],
            [
              -77.527,
              38.555
            ],
            [
              -77.501,
              38.578
            ],
            [
              -77.493,
              38.588
            ],
            [
              -77.476,
              38.59
            ],
            [
              -77.466,
              38.581
            ],
            [
              -77.45,
              38.581
            ],
            [
              -77.433,
              38.567
            ],
            [
              -77.403,
              38.548
            ],
            [
              -77.381,
              38.526
            ],
            [
              -77.356,
              38.517
            ],
            [
              -77.331,
              38.51
            ],
            [
              -77.313,
              38.501
            ],
            [
              -77.298,
              38.504
            ]
          ]
        ]
      },
      "properties": {
        "name": "Stafford County",
        "id": "51179",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51179"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.618,
              38.369
            ],
            [
              -77.603,
              38.347
            ],
            [
              -77.607,
              38.339
            ],
            [
              -77.599,
              38.334
            ],
            [
              -77.586,
              38.346
            ],
            [
              -77.571,
              38.349
            ],
            [
              -77.568,
              38.336
            ],
            [
              -77.561,
              38.335
            ],
            [
              -77.545,
              38.325
            ],
            [
              -77.542,
              38.316
            ],
            [
              -77.529,
              38.309
            ],
            [
              -77.515,
              38.305
            ],
            [
              -77.507,
              38.292
            ],
            [
              -77.512,
              38.28
            ],
            [
              -77.493,
              38.279
            ],
            [
              -77.495,
              38.274
            ],
            [
              -77.473,
              38.27
            ],
            [
              -77.466,
              38.279
            ],
            [
              -77.457,
              38.271
            ],
            [
              -77.45,
              38.275
            ],
            [
              -77.448,
              38.287
            ],
            [
              -77.437,
              38.275
            ],
            [
              -77.426,
              38.268
            ],
            [
              -77.419,
              38.257
            ],
            [
              -77.407,
              38.255
            ],
            [
              -77.387,
              38.245
            ],
            [
              -77.381,
              38.249
            ],
            [
              -77.367,
              38.244
            ],
            [
              -77.64,
              37.995
            ],
            [
              -77.643,
              37.992
            ],
            [
              -77.658,
              37.992
            ],
            [
              -77.672,
              38.004
            ],
            [
              -77.688,
              38.008
            ],
            [
              -77.711,
              38.013
            ],
            [
              -77.73,
              38.031
            ],
            [
              -77.739,
              38.032
            ],
            [
              -77.748,
              38.026
            ],
            [
              -77.746,
              38.049
            ],
            [
              -77.759,
              38.049
            ],
            [
              -77.782,
              38.063
            ],
            [
              -77.782,
              38.072
            ],
            [
              -77.792,
              38.078
            ],
            [
              -77.808,
              38.078
            ],
            [
              -77.816,
              38.087
            ],
            [
              -77.838,
              38.106
            ],
            [
              -77.855,
              38.101
            ],
            [
              -77.863,
              38.106
            ],
            [
              -77.889,
              38.112
            ],
            [
              -77.901,
              38.109
            ],
            [
              -77.914,
              38.116
            ],
            [
              -77.937,
              38.116
            ],
            [
              -77.944,
              38.119
            ],
            [
              -77.96,
              38.119
            ],
            [
              -77.76,
              38.296
            ],
            [
              -77.727,
              38.325
            ],
            [
              -77.717,
              38.337
            ],
            [
              -77.716,
              38.345
            ],
            [
              -77.704,
              38.362
            ],
            [
              -77.697,
              38.357
            ],
            [
              -77.679,
              38.36
            ],
            [
              -77.673,
              38.37
            ],
            [
              -77.649,
              38.378
            ],
            [
              -77.63,
              38.367
            ],
            [
              -77.618,
              38.369
            ]
          ]
        ]
      },
      "properties": {
        "name": "Spotsylvania County",
        "id": "51177",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51177"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.93,
              36.707
            ],
            [
              -76.946,
              36.71
            ],
            [
              -76.96,
              36.702
            ],
            [
              -76.955,
              36.69
            ],
            [
              -76.967,
              36.687
            ],
            [
              -76.965,
              36.679
            ],
            [
              -76.95,
              36.678
            ],
            [
              -76.947,
              36.674
            ],
            [
              -76.962,
              36.667
            ],
            [
              -76.942,
              36.662
            ],
            [
              -76.91,
              36.648
            ],
            [
              -76.902,
              36.644
            ],
            [
              -76.893,
              36.634
            ],
            [
              -76.901,
              36.622
            ],
            [
              -76.914,
              36.618
            ],
            [
              -76.91,
              36.61
            ],
            [
              -76.916,
              36.579
            ],
            [
              -76.927,
              36.572
            ],
            [
              -76.932,
              36.56
            ],
            [
              -76.916,
              36.551
            ],
            [
              -76.917,
              36.544
            ],
            [
              -77.158,
              36.545
            ],
            [
              -77.305,
              36.546
            ],
            [
              -77.333,
              36.56
            ],
            [
              -77.34,
              36.552
            ],
            [
              -77.351,
              36.554
            ],
            [
              -77.362,
              36.572
            ],
            [
              -77.359,
              36.584
            ],
            [
              -77.362,
              36.601
            ],
            [
              -77.372,
              36.61
            ],
            [
              -77.371,
              36.616
            ],
            [
              -77.378,
              36.633
            ],
            [
              -77.389,
              36.642
            ],
            [
              -77.416,
              36.654
            ],
            [
              -77.438,
              36.656
            ],
            [
              -77.449,
              36.652
            ],
            [
              -77.461,
              36.653
            ],
            [
              -77.477,
              36.662
            ],
            [
              -77.48,
              36.669
            ],
            [
              -77.503,
              36.672
            ],
            [
              -77.432,
              36.708
            ],
            [
              -77.4,
              36.723
            ],
            [
              -77.342,
              36.754
            ],
            [
              -77.287,
              36.778
            ],
            [
              -77.238,
              36.801
            ],
            [
              -77.155,
              36.841
            ],
            [
              -77.1,
              36.869
            ],
            [
              -77.012,
              36.916
            ],
            [
              -76.953,
              36.944
            ],
            [
              -76.849,
              36.998
            ],
            [
              -76.86,
              36.954
            ],
            [
              -76.848,
              36.941
            ],
            [
              -76.836,
              36.919
            ],
            [
              -76.825,
              36.919
            ],
            [
              -76.818,
              36.902
            ],
            [
              -76.829,
              36.889
            ],
            [
              -76.825,
              36.881
            ],
            [
              -76.84,
              36.867
            ],
            [
              -76.844,
              36.858
            ],
            [
              -76.853,
              36.852
            ],
            [
              -76.854,
              36.845
            ],
            [
              -76.864,
              36.834
            ],
            [
              -76.861,
              36.825
            ],
            [
              -76.871,
              36.807
            ],
            [
              -76.866,
              36.799
            ],
            [
              -76.872,
              36.787
            ],
            [
              -76.892,
              36.777
            ],
            [
              -76.892,
              36.763
            ],
            [
              -76.901,
              36.759
            ],
            [
              -76.899,
              36.746
            ],
            [
              -76.917,
              36.733
            ],
            [
              -76.916,
              36.724
            ],
            [
              -76.928,
              36.715
            ],
            [
              -76.93,
              36.707
            ]
          ]
        ]
      },
      "properties": {
        "name": "Southampton County",
        "id": "51175",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51175"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -81.437,
              37.01
            ],
            [
              -81.38,
              36.952
            ],
            [
              -81.336,
              36.906
            ],
            [
              -81.326,
              36.892
            ],
            [
              -81.321,
              36.873
            ],
            [
              -81.3,
              36.843
            ],
            [
              -81.289,
              36.825
            ],
            [
              -81.262,
              36.765
            ],
            [
              -81.291,
              36.755
            ],
            [
              -81.309,
              36.751
            ],
            [
              -81.366,
              36.743
            ],
            [
              -81.385,
              36.739
            ],
            [
              -81.406,
              36.732
            ],
            [
              -81.432,
              36.72
            ],
            [
              -81.456,
              36.719
            ],
            [
              -81.485,
              36.712
            ],
            [
              -81.506,
              36.711
            ],
            [
              -81.519,
              36.705
            ],
            [
              -81.545,
              36.703
            ],
            [
              -81.545,
              36.698
            ],
            [
              -81.53,
              36.689
            ],
            [
              -81.539,
              36.661
            ],
            [
              -81.545,
              36.659
            ],
            [
              -81.567,
              36.658
            ],
            [
              -81.582,
              36.647
            ],
            [
              -81.605,
              36.641
            ],
            [
              -81.618,
              36.635
            ],
            [
              -81.7,
              36.786
            ],
            [
              -81.834,
              36.93
            ],
            [
              -81.809,
              36.95
            ],
            [
              -81.778,
              36.96
            ],
            [
              -81.756,
              36.962
            ],
            [
              -81.708,
              36.975
            ],
            [
              -81.684,
              36.932
            ],
            [
              -81.644,
              36.947
            ],
            [
              -81.615,
              36.966
            ],
            [
              -81.588,
              36.982
            ],
            [
              -81.571,
              36.989
            ],
            [
              -81.533,
              36.997
            ],
            [
              -81.497,
              37.013
            ],
            [
              -81.472,
              37.017
            ],
            [
              -81.468,
              37.013
            ],
            [
              -81.473,
              36.999
            ],
            [
              -81.464,
              36.995
            ],
            [
              -81.437,
              37.01
            ]
          ]
        ]
      },
      "properties": {
        "name": "Smyth County",
        "id": "51173",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51173"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.314,
              39.01
            ],
            [
              -78.33,
              38.999
            ],
            [
              -78.328,
              38.991
            ],
            [
              -78.318,
              38.98
            ],
            [
              -78.336,
              38.977
            ],
            [
              -78.298,
              38.946
            ],
            [
              -78.309,
              38.926
            ],
            [
              -78.319,
              38.92
            ],
            [
              -78.327,
              38.902
            ],
            [
              -78.338,
              38.888
            ],
            [
              -78.334,
              38.881
            ],
            [
              -78.389,
              38.829
            ],
            [
              -78.405,
              38.814
            ],
            [
              -78.459,
              38.762
            ],
            [
              -78.471,
              38.753
            ],
            [
              -78.496,
              38.74
            ],
            [
              -78.512,
              38.726
            ],
            [
              -78.547,
              38.74
            ],
            [
              -78.584,
              38.694
            ],
            [
              -78.6,
              38.669
            ],
            [
              -78.611,
              38.643
            ],
            [
              -78.624,
              38.623
            ],
            [
              -78.642,
              38.605
            ],
            [
              -78.866,
              38.763
            ],
            [
              -78.859,
              38.778
            ],
            [
              -78.839,
              38.807
            ],
            [
              -78.828,
              38.82
            ],
            [
              -78.811,
              38.848
            ],
            [
              -78.804,
              38.864
            ],
            [
              -78.787,
              38.886
            ],
            [
              -78.777,
              38.896
            ],
            [
              -78.76,
              38.903
            ],
            [
              -78.745,
              38.921
            ],
            [
              -78.723,
              38.932
            ],
            [
              -78.715,
              38.929
            ],
            [
              -78.719,
              38.906
            ],
            [
              -78.687,
              38.924
            ],
            [
              -78.676,
              38.927
            ],
            [
              -78.661,
              38.945
            ],
            [
              -78.647,
              38.965
            ],
            [
              -78.638,
              38.969
            ],
            [
              -78.628,
              38.981
            ],
            [
              -78.613,
              38.976
            ],
            [
              -78.601,
              38.966
            ],
            [
              -78.57,
              39.002
            ],
            [
              -78.552,
              39.019
            ],
            [
              -78.572,
              39.033
            ],
            [
              -78.542,
              39.06
            ],
            [
              -78.45,
              39.028
            ],
            [
              -78.446,
              39.035
            ],
            [
              -78.444,
              39.054
            ],
            [
              -78.431,
              39.066
            ],
            [
              -78.42,
              39.08
            ],
            [
              -78.401,
              39.092
            ],
            [
              -78.389,
              39.096
            ],
            [
              -78.375,
              39.093
            ],
            [
              -78.335,
              39.101
            ],
            [
              -78.333,
              39.085
            ],
            [
              -78.327,
              39.074
            ],
            [
              -78.338,
              39.072
            ],
            [
              -78.343,
              39.057
            ],
            [
              -78.309,
              39.034
            ],
            [
              -78.316,
              39.03
            ],
            [
              -78.314,
              39.01
            ]
          ]
        ]
      },
      "properties": {
        "name": "Shenandoah County",
        "id": "51171",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51171"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -82.333,
              36.712
            ],
            [
              -82.322,
              36.685
            ],
            [
              -82.303,
              36.618
            ],
            [
              -82.293,
              36.596
            ],
            [
              -82.497,
              36.595
            ],
            [
              -82.76,
              36.594
            ],
            [
              -82.985,
              36.594
            ],
            [
              -82.945,
              36.679
            ],
            [
              -82.888,
              36.707
            ],
            [
              -82.844,
              36.721
            ],
            [
              -82.829,
              36.728
            ],
            [
              -82.824,
              36.735
            ],
            [
              -82.829,
              36.747
            ],
            [
              -82.805,
              36.775
            ],
            [
              -82.792,
              36.78
            ],
            [
              -82.787,
              36.787
            ],
            [
              -82.77,
              36.799
            ],
            [
              -82.77,
              36.806
            ],
            [
              -82.755,
              36.826
            ],
            [
              -82.748,
              36.83
            ],
            [
              -82.729,
              36.829
            ],
            [
              -82.699,
              36.817
            ],
            [
              -82.685,
              36.825
            ],
            [
              -82.678,
              36.834
            ],
            [
              -82.658,
              36.844
            ],
            [
              -82.651,
              36.862
            ],
            [
              -82.635,
              36.878
            ],
            [
              -82.618,
              36.881
            ],
            [
              -82.401,
              36.886
            ],
            [
              -82.399,
              36.881
            ],
            [
              -82.408,
              36.878
            ],
            [
              -82.391,
              36.843
            ],
            [
              -82.357,
              36.78
            ],
            [
              -82.337,
              36.722
            ],
            [
              -82.333,
              36.712
            ]
          ]
        ]
      },
      "properties": {
        "name": "Scott County",
        "id": "51169",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51169"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -80.033,
              37.263
            ],
            [
              -80.042,
              37.262
            ],
            [
              -80.05,
              37.252
            ],
            [
              -80.065,
              37.26
            ],
            [
              -80.075,
              37.256
            ],
            [
              -80.079,
              37.269
            ],
            [
              -80.089,
              37.282
            ],
            [
              -80.105,
              37.278
            ],
            [
              -80.12,
              37.287
            ],
            [
              -80.081,
              37.298
            ],
            [
              -80.061,
              37.311
            ],
            [
              -80.034,
              37.324
            ],
            [
              -80.029,
              37.311
            ],
            [
              -80.019,
              37.303
            ],
            [
              -80.022,
              37.282
            ],
            [
              -80.013,
              37.281
            ],
            [
              -80.018,
              37.264
            ],
            [
              -80.033,
              37.263
            ]
          ]
        ]
      },
      "properties": {
        "name": "Salem City",
        "id": "51775",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51775"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -81.778,
              36.96
            ],
            [
              -81.809,
              36.95
            ],
            [
              -81.834,
              36.93
            ],
            [
              -81.86,
              36.913
            ],
            [
              -81.89,
              36.889
            ],
            [
              -81.914,
              36.883
            ],
            [
              -81.927,
              36.875
            ],
            [
              -81.947,
              36.868
            ],
            [
              -81.978,
              36.871
            ],
            [
              -81.987,
              36.878
            ],
            [
              -82.065,
              36.857
            ],
            [
              -82.107,
              36.836
            ],
            [
              -82.114,
              36.827
            ],
            [
              -82.116,
              36.817
            ],
            [
              -82.105,
              36.798
            ],
            [
              -82.141,
              36.786
            ],
            [
              -82.19,
              36.774
            ],
            [
              -82.29,
              36.737
            ],
            [
              -82.309,
              36.727
            ],
            [
              -82.333,
              36.712
            ],
            [
              -82.337,
              36.722
            ],
            [
              -82.357,
              36.78
            ],
            [
              -82.391,
              36.843
            ],
            [
              -82.408,
              36.878
            ],
            [
              -82.399,
              36.881
            ],
            [
              -82.369,
              36.895
            ],
            [
              -82.354,
              36.893
            ],
            [
              -82.347,
              36.9
            ],
            [
              -82.329,
              36.897
            ],
            [
              -82.324,
              36.902
            ],
            [
              -82.299,
              36.906
            ],
            [
              -82.328,
              36.971
            ],
            [
              -82.302,
              36.986
            ],
            [
              -82.286,
              36.998
            ],
            [
              -82.274,
              37.001
            ],
            [
              -82.262,
              36.989
            ],
            [
              -82.243,
              36.995
            ],
            [
              -82.24,
              37.002
            ],
            [
              -82.2,
              37.029
            ],
            [
              -82.186,
              37.028
            ],
            [
              -82.169,
              37.04
            ],
            [
              -82.158,
              37.038
            ],
            [
              -82.149,
              37.041
            ],
            [
              -82.134,
              37.043
            ],
            [
              -82.113,
              37.04
            ],
            [
              -82.102,
              37.051
            ],
            [
              -82.075,
              37.039
            ],
            [
              -82.064,
              37.045
            ],
            [
              -82.049,
              37.046
            ],
            [
              -82.036,
              37.053
            ],
            [
              -82.03,
              37.064
            ],
            [
              -82.019,
              37.069
            ],
            [
              -82.02,
              37.087
            ],
            [
              -82.008,
              37.117
            ],
            [
              -81.992,
              37.125
            ],
            [
              -81.977,
              37.119
            ],
            [
              -81.961,
              37.127
            ],
            [
              -81.946,
              37.131
            ],
            [
              -81.935,
              37.129
            ],
            [
              -81.914,
              37.134
            ],
            [
              -81.904,
              37.142
            ],
            [
              -81.896,
              37.116
            ],
            [
              -81.885,
              37.104
            ],
            [
              -81.875,
              37.097
            ],
            [
              -81.851,
              37.076
            ],
            [
              -81.817,
              37.032
            ],
            [
              -81.803,
              37.01
            ],
            [
              -81.778,
              36.96
            ]
          ]
        ]
      },
      "properties": {
        "name": "Russell County",
        "id": "51167",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51167"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.866,
              38.763
            ],
            [
              -78.642,
              38.605
            ],
            [
              -78.653,
              38.594
            ],
            [
              -78.66,
              38.581
            ],
            [
              -78.67,
              38.547
            ],
            [
              -78.686,
              38.52
            ],
            [
              -78.682,
              38.513
            ],
            [
              -78.685,
              38.504
            ],
            [
              -78.679,
              38.499
            ],
            [
              -78.658,
              38.493
            ],
            [
              -78.628,
              38.495
            ],
            [
              -78.625,
              38.483
            ],
            [
              -78.616,
              38.477
            ],
            [
              -78.617,
              38.469
            ],
            [
              -78.604,
              38.459
            ],
            [
              -78.579,
              38.455
            ],
            [
              -78.567,
              38.448
            ],
            [
              -78.553,
              38.446
            ],
            [
              -78.548,
              38.431
            ],
            [
              -78.534,
              38.433
            ],
            [
              -78.487,
              38.422
            ],
            [
              -78.501,
              38.402
            ],
            [
              -78.51,
              38.395
            ],
            [
              -78.525,
              38.37
            ],
            [
              -78.539,
              38.364
            ],
            [
              -78.551,
              38.353
            ],
            [
              -78.556,
              38.339
            ],
            [
              -78.59,
              38.324
            ],
            [
              -78.605,
              38.309
            ],
            [
              -78.624,
              38.304
            ],
            [
              -78.635,
              38.294
            ],
            [
              -78.65,
              38.293
            ],
            [
              -78.659,
              38.278
            ],
            [
              -78.664,
              38.265
            ],
            [
              -78.655,
              38.258
            ],
            [
              -78.669,
              38.249
            ],
            [
              -78.68,
              38.255
            ],
            [
              -78.699,
              38.247
            ],
            [
              -78.713,
              38.245
            ],
            [
              -78.72,
              38.235
            ],
            [
              -78.729,
              38.233
            ],
            [
              -78.732,
              38.225
            ],
            [
              -78.743,
              38.219
            ],
            [
              -78.751,
              38.208
            ],
            [
              -78.811,
              38.249
            ],
            [
              -78.861,
              38.282
            ],
            [
              -78.889,
              38.305
            ],
            [
              -78.896,
              38.307
            ],
            [
              -78.912,
              38.306
            ],
            [
              -78.922,
              38.31
            ],
            [
              -79.106,
              38.415
            ],
            [
              -79.222,
              38.481
            ],
            [
              -79.206,
              38.5
            ],
            [
              -79.208,
              38.512
            ],
            [
              -79.205,
              38.521
            ],
            [
              -79.191,
              38.544
            ],
            [
              -79.163,
              38.583
            ],
            [
              -79.155,
              38.61
            ],
            [
              -79.135,
              38.644
            ],
            [
              -79.125,
              38.656
            ],
            [
              -79.112,
              38.659
            ],
            [
              -79.105,
              38.655
            ],
            [
              -79.093,
              38.659
            ],
            [
              -79.085,
              38.686
            ],
            [
              -79.09,
              38.702
            ],
            [
              -79.08,
              38.734
            ],
            [
              -79.061,
              38.757
            ],
            [
              -79.052,
              38.777
            ],
            [
              -79.055,
              38.787
            ],
            [
              -79.043,
              38.792
            ],
            [
              -79.028,
              38.792
            ],
            [
              -79.023,
              38.812
            ],
            [
              -79.006,
              38.824
            ],
            [
              -78.997,
              38.84
            ],
            [
              -78.995,
              38.851
            ],
            [
              -78.866,
              38.763
            ]
          ],
          [
            [
              -78.876,
              38.486
            ],
            [
              -78.891,
              38.457
            ],
            [
              -78.901,
              38.459
            ],
            [
              -78.917,
              38.437
            ],
            [
              -78.908,
              38.435
            ],
            [
              -78.904,
              38.414
            ],
            [
              -78.918,
              38.396
            ],
            [
              -78.914,
              38.39
            ],
            [
              -78.889,
              38.393
            ],
            [
              -78.882,
              38.412
            ],
            [
              -78.851,
              38.413
            ],
            [
              -78.829,
              38.42
            ],
            [
              -78.824,
              38.44
            ],
            [
              -78.833,
              38.444
            ],
            [
              -78.834,
              38.455
            ],
            [
              -78.846,
              38.461
            ],
            [
              -78.857,
              38.475
            ],
            [
              -78.876,
              38.486
            ]
          ]
        ]
      },
      "properties": {
        "name": "Rockingham County",
        "id": "51165",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51165"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.172,
              37.804
            ],
            [
              -79.2,
              37.791
            ],
            [
              -79.213,
              37.796
            ],
            [
              -79.23,
              37.814
            ],
            [
              -79.245,
              37.809
            ],
            [
              -79.256,
              37.797
            ],
            [
              -79.273,
              37.794
            ],
            [
              -79.272,
              37.779
            ],
            [
              -79.284,
              37.764
            ],
            [
              -79.297,
              37.752
            ],
            [
              -79.304,
              37.741
            ],
            [
              -79.304,
              37.729
            ],
            [
              -79.318,
              37.717
            ],
            [
              -79.321,
              37.7
            ],
            [
              -79.34,
              37.68
            ],
            [
              -79.339,
              37.664
            ],
            [
              -79.353,
              37.66
            ],
            [
              -79.36,
              37.652
            ],
            [
              -79.379,
              37.644
            ],
            [
              -79.399,
              37.63
            ],
            [
              -79.42,
              37.626
            ],
            [
              -79.432,
              37.615
            ],
            [
              -79.442,
              37.619
            ],
            [
              -79.454,
              37.609
            ],
            [
              -79.454,
              37.6
            ],
            [
              -79.445,
              37.58
            ],
            [
              -79.434,
              37.578
            ],
            [
              -79.438,
              37.569
            ],
            [
              -79.456,
              37.561
            ],
            [
              -79.5,
              37.536
            ],
            [
              -79.579,
              37.582
            ],
            [
              -79.571,
              37.599
            ],
            [
              -79.683,
              37.666
            ],
            [
              -79.675,
              37.675
            ],
            [
              -79.668,
              37.699
            ],
            [
              -79.675,
              37.704
            ],
            [
              -79.684,
              37.74
            ],
            [
              -79.679,
              37.745
            ],
            [
              -79.674,
              37.764
            ],
            [
              -79.663,
              37.777
            ],
            [
              -79.645,
              37.813
            ],
            [
              -79.633,
              37.82
            ],
            [
              -79.623,
              37.833
            ],
            [
              -79.617,
              37.851
            ],
            [
              -79.607,
              37.86
            ],
            [
              -79.627,
              37.875
            ],
            [
              -79.648,
              37.874
            ],
            [
              -79.637,
              37.889
            ],
            [
              -79.627,
              37.912
            ],
            [
              -79.612,
              37.932
            ],
            [
              -79.574,
              37.961
            ],
            [
              -79.555,
              37.982
            ],
            [
              -79.511,
              38.035
            ],
            [
              -79.523,
              38.042
            ],
            [
              -79.502,
              38.059
            ],
            [
              -79.48,
              38.087
            ],
            [
              -79.42,
              38.051
            ],
            [
              -79.321,
              37.995
            ],
            [
              -79.2,
              37.929
            ],
            [
              -79.167,
              37.902
            ],
            [
              -79.157,
              37.892
            ],
            [
              -79.15,
              37.881
            ],
            [
              -79.148,
              37.868
            ],
            [
              -79.142,
              37.86
            ],
            [
              -79.158,
              37.844
            ],
            [
              -79.157,
              37.826
            ],
            [
              -79.172,
              37.804
            ]
          ],
          [
            [
              -79.361,
              37.751
            ],
            [
              -79.372,
              37.746
            ],
            [
              -79.378,
              37.727
            ],
            [
              -79.375,
              37.712
            ],
            [
              -79.383,
              37.706
            ],
            [
              -79.373,
              37.697
            ],
            [
              -79.36,
              37.703
            ],
            [
              -79.339,
              37.732
            ],
            [
              -79.333,
              37.738
            ],
            [
              -79.329,
              37.76
            ],
            [
              -79.343,
              37.762
            ],
            [
              -79.349,
              37.755
            ],
            [
              -79.361,
              37.751
            ]
          ],
          [
            [
              -79.461,
              37.775
            ],
            [
              -79.453,
              37.766
            ],
            [
              -79.415,
              37.791
            ],
            [
              -79.442,
              37.801
            ],
            [
              -79.454,
              37.796
            ],
            [
              -79.462,
              37.788
            ],
            [
              -79.455,
              37.782
            ],
            [
              -79.461,
              37.775
            ]
          ]
        ]
      },
      "properties": {
        "name": "Rockbridge County",
        "id": "51163",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA",
      },
      "id": "51163"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.849,
              37.31
            ],
            [
              -79.843,
              37.299
            ],
            [
              -79.853,
              37.29
            ],
            [
              -79.85,
              37.278
            ],
            [
              -79.858,
              37.262
            ],
            [
              -79.845,
              37.252
            ],
            [
              -79.848,
              37.24
            ],
            [
              -79.843,
              37.231
            ],
            [
              -79.848,
              37.225
            ],
            [
              -79.856,
              37.216
            ],
            [
              -79.877,
              37.214
            ],
            [
              -79.894,
              37.2
            ],
            [
              -79.897,
              37.184
            ],
            [
              -79.911,
              37.179
            ],
            [
              -79.918,
              37.166
            ],
            [
              -79.948,
              37.15
            ],
            [
              -79.96,
              37.139
            ],
            [
              -79.967,
              37.138
            ],
            [
              -79.978,
              37.143
            ],
            [
              -79.992,
              37.147
            ],
            [
              -80.007,
              37.16
            ],
            [
              -80.012,
              37.173
            ],
            [
              -80.034,
              37.176
            ],
            [
              -80.051,
              37.168
            ],
            [
              -80.069,
              37.167
            ],
            [
              -80.08,
              37.162
            ],
            [
              -80.094,
              37.16
            ],
            [
              -80.098,
              37.152
            ],
            [
              -80.119,
              37.131
            ],
            [
              -80.129,
              37.128
            ],
            [
              -80.151,
              37.128
            ],
            [
              -80.152,
              37.119
            ],
            [
              -80.159,
              37.111
            ],
            [
              -80.173,
              37.116
            ],
            [
              -80.176,
              37.125
            ],
            [
              -80.195,
              37.235
            ],
            [
              -80.258,
              37.306
            ],
            [
              -80.263,
              37.342
            ],
            [
              -80.242,
              37.359
            ],
            [
              -80.214,
              37.371
            ],
            [
              -80.204,
              37.379
            ],
            [
              -80.159,
              37.382
            ],
            [
              -80.121,
              37.399
            ],
            [
              -80.086,
              37.418
            ],
            [
              -79.962,
              37.371
            ],
            [
              -79.865,
              37.329
            ],
            [
              -79.849,
              37.31
            ]
          ],
          [
            [
              -80.034,
              37.324
            ],
            [
              -80.061,
              37.311
            ],
            [
              -80.081,
              37.298
            ],
            [
              -80.12,
              37.287
            ],
            [
              -80.105,
              37.278
            ],
            [
              -80.089,
              37.282
            ],
            [
              -80.079,
              37.269
            ],
            [
              -80.075,
              37.256
            ],
            [
              -80.065,
              37.26
            ],
            [
              -80.05,
              37.252
            ],
            [
              -80.042,
              37.262
            ],
            [
              -80.033,
              37.263
            ],
            [
              -80.038,
              37.254
            ],
            [
              -80.029,
              37.243
            ],
            [
              -80.004,
              37.249
            ],
            [
              -79.997,
              37.243
            ],
            [
              -79.972,
              37.23
            ],
            [
              -79.967,
              37.219
            ],
            [
              -79.952,
              37.211
            ],
            [
              -79.945,
              37.214
            ],
            [
              -79.959,
              37.226
            ],
            [
              -79.947,
              37.231
            ],
            [
              -79.927,
              37.223
            ],
            [
              -79.922,
              37.241
            ],
            [
              -79.909,
              37.244
            ],
            [
              -79.901,
              37.255
            ],
            [
              -79.909,
              37.261
            ],
            [
              -79.904,
              37.271
            ],
            [
              -79.906,
              37.284
            ],
            [
              -79.883,
              37.284
            ],
            [
              -79.879,
              37.292
            ],
            [
              -79.883,
              37.302
            ],
            [
              -79.901,
              37.319
            ],
            [
              -79.919,
              37.321
            ],
            [
              -79.958,
              37.321
            ],
            [
              -79.969,
              37.339
            ],
            [
              -80,
              37.321
            ],
            [
              -80.034,
              37.324
            ]
          ]
        ]
      },
      "properties": {
        "name": "Roanoke County",
        "id": "51161",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51161"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -80.033,
              37.263
            ],
            [
              -80.018,
              37.264
            ],
            [
              -80.013,
              37.281
            ],
            [
              -80.022,
              37.282
            ],
            [
              -80.019,
              37.303
            ],
            [
              -80.029,
              37.311
            ],
            [
              -80.034,
              37.324
            ],
            [
              -80,
              37.321
            ],
            [
              -79.969,
              37.339
            ],
            [
              -79.958,
              37.321
            ],
            [
              -79.919,
              37.321
            ],
            [
              -79.901,
              37.319
            ],
            [
              -79.883,
              37.302
            ],
            [
              -79.879,
              37.292
            ],
            [
              -79.883,
              37.284
            ],
            [
              -79.906,
              37.284
            ],
            [
              -79.904,
              37.271
            ],
            [
              -79.909,
              37.261
            ],
            [
              -79.901,
              37.255
            ],
            [
              -79.909,
              37.244
            ],
            [
              -79.922,
              37.241
            ],
            [
              -79.927,
              37.223
            ],
            [
              -79.947,
              37.231
            ],
            [
              -79.959,
              37.226
            ],
            [
              -79.945,
              37.214
            ],
            [
              -79.952,
              37.211
            ],
            [
              -79.967,
              37.219
            ],
            [
              -79.972,
              37.23
            ],
            [
              -79.997,
              37.243
            ],
            [
              -80.004,
              37.249
            ],
            [
              -80.029,
              37.243
            ],
            [
              -80.038,
              37.254
            ],
            [
              -80.033,
              37.263
            ]
          ]
        ]
      },
      "properties": {
        "name": "Roanoke City",
        "id": "51770",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51770"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.636,
              37.968
            ],
            [
              -76.631,
              37.969
            ],
            [
              -76.62,
              37.95
            ],
            [
              -76.597,
              37.95
            ],
            [
              -76.578,
              37.938
            ],
            [
              -76.564,
              37.935
            ],
            [
              -76.557,
              37.93
            ],
            [
              -76.547,
              37.907
            ],
            [
              -76.543,
              37.886
            ],
            [
              -76.55,
              37.872
            ],
            [
              -76.543,
              37.862
            ],
            [
              -76.518,
              37.853
            ],
            [
              -76.511,
              37.84
            ],
            [
              -76.519,
              37.836
            ],
            [
              -76.568,
              37.836
            ],
            [
              -76.587,
              37.824
            ],
            [
              -76.585,
              37.813
            ],
            [
              -76.622,
              37.806
            ],
            [
              -76.631,
              37.814
            ],
            [
              -76.644,
              37.809
            ],
            [
              -76.652,
              37.797
            ],
            [
              -76.66,
              37.808
            ],
            [
              -76.671,
              37.813
            ],
            [
              -76.677,
              37.823
            ],
            [
              -76.662,
              37.836
            ],
            [
              -76.663,
              37.842
            ],
            [
              -76.689,
              37.823
            ],
            [
              -76.703,
              37.824
            ],
            [
              -76.718,
              37.836
            ],
            [
              -76.731,
              37.838
            ],
            [
              -76.732,
              37.85
            ],
            [
              -76.743,
              37.857
            ],
            [
              -76.748,
              37.872
            ],
            [
              -76.731,
              37.889
            ],
            [
              -76.748,
              37.89
            ],
            [
              -76.753,
              37.878
            ],
            [
              -76.765,
              37.88
            ],
            [
              -76.768,
              37.895
            ],
            [
              -76.781,
              37.915
            ],
            [
              -76.803,
              37.93
            ],
            [
              -76.814,
              37.929
            ],
            [
              -76.824,
              37.939
            ],
            [
              -76.838,
              37.937
            ],
            [
              -76.843,
              37.945
            ],
            [
              -76.853,
              37.952
            ],
            [
              -76.85,
              37.963
            ],
            [
              -76.855,
              37.972
            ],
            [
              -76.848,
              37.984
            ],
            [
              -76.855,
              37.987
            ],
            [
              -76.867,
              37.979
            ],
            [
              -76.873,
              37.989
            ],
            [
              -76.891,
              37.991
            ],
            [
              -76.899,
              38.006
            ],
            [
              -76.905,
              38.033
            ],
            [
              -76.91,
              38.047
            ],
            [
              -76.909,
              38.053
            ],
            [
              -76.918,
              38.074
            ],
            [
              -76.937,
              38.086
            ],
            [
              -76.913,
              38.098
            ],
            [
              -76.91,
              38.105
            ],
            [
              -76.89,
              38.122
            ],
            [
              -76.874,
              38.123
            ],
            [
              -76.866,
              38.116
            ],
            [
              -76.862,
              38.101
            ],
            [
              -76.817,
              38.056
            ],
            [
              -76.807,
              38.061
            ],
            [
              -76.798,
              38.059
            ],
            [
              -76.786,
              38.049
            ],
            [
              -76.761,
              38.033
            ],
            [
              -76.765,
              38.019
            ],
            [
              -76.763,
              38.008
            ],
            [
              -76.769,
              38.002
            ],
            [
              -76.751,
              37.996
            ],
            [
              -76.734,
              38.001
            ],
            [
              -76.705,
              37.987
            ],
            [
              -76.687,
              37.983
            ],
            [
              -76.665,
              37.985
            ],
            [
              -76.656,
              37.981
            ],
            [
              -76.65,
              37.971
            ],
            [
              -76.636,
              37.968
            ]
          ]
        ]
      },
      "properties": {
        "name": "Richmond County",
        "id": "51159",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51159"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.42,
              37.448
            ],
            [
              -77.434,
              37.457
            ],
            [
              -77.46,
              37.464
            ],
            [
              -77.487,
              37.459
            ],
            [
              -77.51,
              37.47
            ],
            [
              -77.527,
              37.506
            ],
            [
              -77.528,
              37.532
            ],
            [
              -77.545,
              37.528
            ],
            [
              -77.553,
              37.542
            ],
            [
              -77.573,
              37.533
            ],
            [
              -77.595,
              37.533
            ],
            [
              -77.602,
              37.545
            ],
            [
              -77.595,
              37.556
            ],
            [
              -77.579,
              37.559
            ],
            [
              -77.56,
              37.555
            ],
            [
              -77.545,
              37.561
            ],
            [
              -77.53,
              37.56
            ],
            [
              -77.527,
              37.568
            ],
            [
              -77.547,
              37.572
            ],
            [
              -77.533,
              37.593
            ],
            [
              -77.5,
              37.575
            ],
            [
              -77.494,
              37.582
            ],
            [
              -77.482,
              37.573
            ],
            [
              -77.473,
              37.579
            ],
            [
              -77.479,
              37.588
            ],
            [
              -77.478,
              37.599
            ],
            [
              -77.448,
              37.603
            ],
            [
              -77.438,
              37.599
            ],
            [
              -77.439,
              37.586
            ],
            [
              -77.431,
              37.581
            ],
            [
              -77.414,
              37.58
            ],
            [
              -77.408,
              37.558
            ],
            [
              -77.395,
              37.55
            ],
            [
              -77.386,
              37.535
            ],
            [
              -77.394,
              37.506
            ],
            [
              -77.417,
              37.514
            ],
            [
              -77.422,
              37.496
            ],
            [
              -77.422,
              37.472
            ],
            [
              -77.418,
              37.457
            ],
            [
              -77.42,
              37.448
            ]
          ]
        ]
      },
      "properties": {
        "name": "Richmond City",
        "id": "51760",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51760"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.931,
              38.699
            ],
            [
              -78.03,
              38.64
            ],
            [
              -78.084,
              38.604
            ],
            [
              -78.177,
              38.522
            ],
            [
              -78.211,
              38.532
            ],
            [
              -78.217,
              38.537
            ],
            [
              -78.234,
              38.536
            ],
            [
              -78.339,
              38.628
            ],
            [
              -78.325,
              38.633
            ],
            [
              -78.314,
              38.65
            ],
            [
              -78.318,
              38.667
            ],
            [
              -78.325,
              38.675
            ],
            [
              -78.315,
              38.685
            ],
            [
              -78.318,
              38.702
            ],
            [
              -78.332,
              38.705
            ],
            [
              -78.323,
              38.723
            ],
            [
              -78.321,
              38.739
            ],
            [
              -78.307,
              38.742
            ],
            [
              -78.302,
              38.753
            ],
            [
              -78.291,
              38.752
            ],
            [
              -78.283,
              38.761
            ],
            [
              -78.278,
              38.763
            ],
            [
              -78.259,
              38.758
            ],
            [
              -78.236,
              38.764
            ],
            [
              -78.232,
              38.769
            ],
            [
              -78.194,
              38.783
            ],
            [
              -78.184,
              38.8
            ],
            [
              -78.182,
              38.818
            ],
            [
              -78.173,
              38.823
            ],
            [
              -78.169,
              38.836
            ],
            [
              -78.145,
              38.858
            ],
            [
              -78.132,
              38.863
            ],
            [
              -78.117,
              38.847
            ],
            [
              -78.104,
              38.84
            ],
            [
              -78.097,
              38.829
            ],
            [
              -78.074,
              38.821
            ],
            [
              -78.052,
              38.806
            ],
            [
              -78.05,
              38.801
            ],
            [
              -78.028,
              38.796
            ],
            [
              -78.029,
              38.786
            ],
            [
              -78.021,
              38.779
            ],
            [
              -78.027,
              38.761
            ],
            [
              -78.016,
              38.75
            ],
            [
              -78.017,
              38.742
            ],
            [
              -78.005,
              38.721
            ],
            [
              -77.992,
              38.712
            ],
            [
              -77.965,
              38.7
            ],
            [
              -77.945,
              38.697
            ],
            [
              -77.931,
              38.699
            ]
          ]
        ]
      },
      "properties": {
        "name": "Rappahannock County",
        "id": "51157",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51157"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -80.583,
              37.09
            ],
            [
              -80.597,
              37.112
            ],
            [
              -80.593,
              37.129
            ],
            [
              -80.564,
              37.145
            ],
            [
              -80.547,
              37.147
            ],
            [
              -80.535,
              37.138
            ],
            [
              -80.53,
              37.145
            ],
            [
              -80.519,
              37.151
            ],
            [
              -80.509,
              37.148
            ],
            [
              -80.506,
              37.136
            ],
            [
              -80.519,
              37.124
            ],
            [
              -80.555,
              37.118
            ],
            [
              -80.554,
              37.102
            ],
            [
              -80.583,
              37.09
            ]
          ]
        ]
      },
      "properties": {
        "name": "Radford City",
        "id": "51750",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51750"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -80.53,
              37.145
            ],
            [
              -80.535,
              37.138
            ],
            [
              -80.547,
              37.147
            ],
            [
              -80.564,
              37.145
            ],
            [
              -80.593,
              37.129
            ],
            [
              -80.597,
              37.112
            ],
            [
              -80.583,
              37.09
            ],
            [
              -80.576,
              37.078
            ],
            [
              -80.558,
              37.073
            ],
            [
              -80.549,
              37.063
            ],
            [
              -80.55,
              37.052
            ],
            [
              -80.562,
              37.048
            ],
            [
              -80.554,
              37.032
            ],
            [
              -80.557,
              37.015
            ],
            [
              -80.542,
              36.986
            ],
            [
              -80.535,
              36.977
            ],
            [
              -80.564,
              36.968
            ],
            [
              -80.572,
              36.96
            ],
            [
              -80.595,
              36.946
            ],
            [
              -80.63,
              36.936
            ],
            [
              -80.634,
              36.932
            ],
            [
              -80.652,
              36.923
            ],
            [
              -80.669,
              36.911
            ],
            [
              -80.683,
              36.91
            ],
            [
              -80.683,
              36.896
            ],
            [
              -80.698,
              36.885
            ],
            [
              -80.699,
              36.879
            ],
            [
              -80.733,
              36.884
            ],
            [
              -80.737,
              36.882
            ],
            [
              -80.802,
              36.942
            ],
            [
              -80.809,
              36.953
            ],
            [
              -80.895,
              37.028
            ],
            [
              -80.915,
              37.074
            ],
            [
              -80.933,
              37.116
            ],
            [
              -80.907,
              37.12
            ],
            [
              -80.891,
              37.126
            ],
            [
              -80.856,
              37.148
            ],
            [
              -80.829,
              37.162
            ],
            [
              -80.804,
              37.179
            ],
            [
              -80.779,
              37.189
            ],
            [
              -80.705,
              37.209
            ],
            [
              -80.672,
              37.224
            ],
            [
              -80.622,
              37.242
            ],
            [
              -80.607,
              37.247
            ],
            [
              -80.606,
              37.241
            ],
            [
              -80.615,
              37.232
            ],
            [
              -80.613,
              37.212
            ],
            [
              -80.6,
              37.201
            ],
            [
              -80.594,
              37.186
            ],
            [
              -80.585,
              37.183
            ],
            [
              -80.57,
              37.194
            ],
            [
              -80.546,
              37.203
            ],
            [
              -80.528,
              37.206
            ],
            [
              -80.515,
              37.202
            ],
            [
              -80.517,
              37.194
            ],
            [
              -80.529,
              37.192
            ],
            [
              -80.544,
              37.194
            ],
            [
              -80.556,
              37.19
            ],
            [
              -80.568,
              37.178
            ],
            [
              -80.552,
              37.156
            ],
            [
              -80.535,
              37.157
            ],
            [
              -80.53,
              37.145
            ]
          ]
        ]
      },
      "properties": {
        "name": "Pulaski County",
        "id": "51155",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51155"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.657,
              38.944
            ],
            [
              -77.638,
              38.942
            ],
            [
              -77.619,
              38.932
            ],
            [
              -77.602,
              38.907
            ],
            [
              -77.584,
              38.893
            ],
            [
              -77.552,
              38.885
            ],
            [
              -77.55,
              38.88
            ],
            [
              -77.55,
              38.857
            ],
            [
              -77.537,
              38.848
            ],
            [
              -77.532,
              38.839
            ],
            [
              -77.52,
              38.838
            ],
            [
              -77.508,
              38.841
            ],
            [
              -77.505,
              38.817
            ],
            [
              -77.492,
              38.811
            ],
            [
              -77.492,
              38.797
            ],
            [
              -77.464,
              38.796
            ],
            [
              -77.45,
              38.802
            ],
            [
              -77.44,
              38.8
            ],
            [
              -77.431,
              38.781
            ],
            [
              -77.417,
              38.774
            ],
            [
              -77.41,
              38.755
            ],
            [
              -77.394,
              38.749
            ],
            [
              -77.38,
              38.734
            ],
            [
              -77.383,
              38.721
            ],
            [
              -77.368,
              38.711
            ],
            [
              -77.36,
              38.724
            ],
            [
              -77.332,
              38.716
            ],
            [
              -77.325,
              38.711
            ],
            [
              -77.326,
              38.7
            ],
            [
              -77.302,
              38.706
            ],
            [
              -77.273,
              38.69
            ],
            [
              -77.255,
              38.679
            ],
            [
              -77.236,
              38.661
            ],
            [
              -77.227,
              38.65
            ],
            [
              -77.227,
              38.642
            ],
            [
              -77.241,
              38.639
            ],
            [
              -77.251,
              38.628
            ],
            [
              -77.245,
              38.619
            ],
            [
              -77.25,
              38.602
            ],
            [
              -77.248,
              38.592
            ],
            [
              -77.263,
              38.578
            ],
            [
              -77.257,
              38.561
            ],
            [
              -77.283,
              38.541
            ],
            [
              -77.301,
              38.554
            ],
            [
              -77.303,
              38.544
            ],
            [
              -77.297,
              38.541
            ],
            [
              -77.284,
              38.523
            ],
            [
              -77.298,
              38.504
            ],
            [
              -77.313,
              38.501
            ],
            [
              -77.331,
              38.51
            ],
            [
              -77.356,
              38.517
            ],
            [
              -77.381,
              38.526
            ],
            [
              -77.403,
              38.548
            ],
            [
              -77.433,
              38.567
            ],
            [
              -77.45,
              38.581
            ],
            [
              -77.466,
              38.581
            ],
            [
              -77.476,
              38.59
            ],
            [
              -77.493,
              38.588
            ],
            [
              -77.501,
              38.578
            ],
            [
              -77.527,
              38.555
            ],
            [
              -77.534,
              38.561
            ],
            [
              -77.538,
              38.571
            ],
            [
              -77.659,
              38.748
            ],
            [
              -77.716,
              38.829
            ],
            [
              -77.717,
              38.856
            ],
            [
              -77.704,
              38.872
            ],
            [
              -77.703,
              38.887
            ],
            [
              -77.688,
              38.875
            ],
            [
              -77.679,
              38.898
            ],
            [
              -77.657,
              38.944
            ]
          ],
          [
            [
              -77.448,
              38.761
            ],
            [
              -77.44,
              38.757
            ],
            [
              -77.431,
              38.772
            ],
            [
              -77.44,
              38.783
            ],
            [
              -77.474,
              38.788
            ],
            [
              -77.476,
              38.781
            ],
            [
              -77.489,
              38.768
            ],
            [
              -77.504,
              38.76
            ],
            [
              -77.514,
              38.747
            ],
            [
              -77.523,
              38.742
            ],
            [
              -77.527,
              38.734
            ],
            [
              -77.524,
              38.718
            ],
            [
              -77.505,
              38.707
            ],
            [
              -77.501,
              38.712
            ],
            [
              -77.513,
              38.737
            ],
            [
              -77.508,
              38.74
            ],
            [
              -77.471,
              38.727
            ],
            [
              -77.454,
              38.736
            ],
            [
              -77.448,
              38.761
            ]
          ]
        ]
      },
      "properties": {
        "name": "Prince William County",
        "id": "51153",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51153"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.016,
              37.22
            ],
            [
              -77.014,
              37.213
            ],
            [
              -77.025,
              37.202
            ],
            [
              -77.068,
              37.188
            ],
            [
              -77.094,
              37.168
            ],
            [
              -77.155,
              37.108
            ],
            [
              -77.19,
              37.099
            ],
            [
              -77.405,
              36.993
            ],
            [
              -77.398,
              37.047
            ],
            [
              -77.399,
              37.169
            ],
            [
              -77.4,
              37.171
            ],
            [
              -77.383,
              37.177
            ],
            [
              -77.366,
              37.172
            ],
            [
              -77.346,
              37.174
            ],
            [
              -77.343,
              37.19
            ],
            [
              -77.33,
              37.197
            ],
            [
              -77.345,
              37.214
            ],
            [
              -77.363,
              37.24
            ],
            [
              -77.377,
              37.245
            ],
            [
              -77.375,
              37.264
            ],
            [
              -77.368,
              37.273
            ],
            [
              -77.358,
              37.28
            ],
            [
              -77.351,
              37.312
            ],
            [
              -77.337,
              37.314
            ],
            [
              -77.329,
              37.289
            ],
            [
              -77.331,
              37.257
            ],
            [
              -77.322,
              37.265
            ],
            [
              -77.311,
              37.266
            ],
            [
              -77.285,
              37.274
            ],
            [
              -77.254,
              37.291
            ],
            [
              -77.247,
              37.297
            ],
            [
              -77.232,
              37.301
            ],
            [
              -77.22,
              37.312
            ],
            [
              -77.207,
              37.306
            ],
            [
              -77.202,
              37.291
            ],
            [
              -77.184,
              37.287
            ],
            [
              -77.142,
              37.302
            ],
            [
              -77.131,
              37.298
            ],
            [
              -77.107,
              37.302
            ],
            [
              -77.096,
              37.311
            ],
            [
              -77.089,
              37.291
            ],
            [
              -77.087,
              37.274
            ],
            [
              -77.068,
              37.266
            ],
            [
              -77.053,
              37.266
            ],
            [
              -77.042,
              37.282
            ],
            [
              -77.033,
              37.291
            ],
            [
              -77.015,
              37.298
            ],
            [
              -76.997,
              37.299
            ],
            [
              -77,
              37.285
            ],
            [
              -76.992,
              37.271
            ],
            [
              -76.985,
              37.247
            ],
            [
              -77.002,
              37.242
            ],
            [
              -77.011,
              37.235
            ],
            [
              -77.016,
              37.22
            ]
          ]
        ]
      },
      "properties": {
        "name": "Prince George County",
        "id": "51149",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51149"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.468,
              37.342
            ],
            [
              -78.457,
              37.337
            ],
            [
              -78.429,
              37.332
            ],
            [
              -78.396,
              37.307
            ],
            [
              -78.386,
              37.31
            ],
            [
              -78.366,
              37.31
            ],
            [
              -78.358,
              37.304
            ],
            [
              -78.349,
              37.318
            ],
            [
              -78.335,
              37.316
            ],
            [
              -78.328,
              37.309
            ],
            [
              -78.319,
              37.312
            ],
            [
              -78.298,
              37.328
            ],
            [
              -78.283,
              37.345
            ],
            [
              -78.264,
              37.358
            ],
            [
              -78.251,
              37.359
            ],
            [
              -78.239,
              37.367
            ],
            [
              -78.239,
              37.295
            ],
            [
              -78.241,
              37.12
            ],
            [
              -78.27,
              37.114
            ],
            [
              -78.278,
              37.106
            ],
            [
              -78.304,
              37.101
            ],
            [
              -78.321,
              37.105
            ],
            [
              -78.367,
              37.105
            ],
            [
              -78.379,
              37.1
            ],
            [
              -78.385,
              37.092
            ],
            [
              -78.405,
              37.086
            ],
            [
              -78.447,
              37.079
            ],
            [
              -78.463,
              37.084
            ],
            [
              -78.481,
              37.087
            ],
            [
              -78.491,
              37.093
            ],
            [
              -78.507,
              37.111
            ],
            [
              -78.512,
              37.131
            ],
            [
              -78.517,
              37.136
            ],
            [
              -78.553,
              37.152
            ],
            [
              -78.563,
              37.153
            ],
            [
              -78.586,
              37.141
            ],
            [
              -78.622,
              37.161
            ],
            [
              -78.639,
              37.173
            ],
            [
              -78.64,
              37.184
            ],
            [
              -78.649,
              37.193
            ],
            [
              -78.679,
              37.197
            ],
            [
              -78.69,
              37.192
            ],
            [
              -78.695,
              37.2
            ],
            [
              -78.694,
              37.212
            ],
            [
              -78.686,
              37.243
            ],
            [
              -78.685,
              37.252
            ],
            [
              -78.684,
              37.259
            ],
            [
              -78.659,
              37.282
            ],
            [
              -78.646,
              37.305
            ],
            [
              -78.624,
              37.326
            ],
            [
              -78.611,
              37.33
            ],
            [
              -78.609,
              37.338
            ],
            [
              -78.597,
              37.342
            ],
            [
              -78.594,
              37.348
            ],
            [
              -78.603,
              37.354
            ],
            [
              -78.591,
              37.4
            ],
            [
              -78.584,
              37.392
            ],
            [
              -78.585,
              37.385
            ],
            [
              -78.572,
              37.379
            ],
            [
              -78.561,
              37.369
            ],
            [
              -78.558,
              37.356
            ],
            [
              -78.539,
              37.353
            ],
            [
              -78.523,
              37.344
            ],
            [
              -78.513,
              37.335
            ],
            [
              -78.479,
              37.338
            ],
            [
              -78.468,
              37.342
            ]
          ]
        ]
      },
      "properties": {
        "name": "Prince Edward County",
        "id": "51147",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51147"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.656,
              37.566
            ],
            [
              -77.799,
              37.461
            ],
            [
              -77.801,
              37.446
            ],
            [
              -77.81,
              37.428
            ],
            [
              -77.822,
              37.423
            ],
            [
              -77.838,
              37.423
            ],
            [
              -77.849,
              37.418
            ],
            [
              -77.858,
              37.419
            ],
            [
              -77.858,
              37.432
            ],
            [
              -77.868,
              37.442
            ],
            [
              -77.869,
              37.456
            ],
            [
              -77.876,
              37.459
            ],
            [
              -77.887,
              37.451
            ],
            [
              -77.898,
              37.458
            ],
            [
              -77.896,
              37.476
            ],
            [
              -77.913,
              37.476
            ],
            [
              -77.93,
              37.482
            ],
            [
              -77.939,
              37.477
            ],
            [
              -77.969,
              37.486
            ],
            [
              -77.99,
              37.488
            ],
            [
              -78.001,
              37.498
            ],
            [
              -78.011,
              37.497
            ],
            [
              -78.024,
              37.485
            ],
            [
              -78.029,
              37.475
            ],
            [
              -78.05,
              37.472
            ],
            [
              -78.065,
              37.451
            ],
            [
              -78.077,
              37.455
            ],
            [
              -78.092,
              37.453
            ],
            [
              -78.099,
              37.438
            ],
            [
              -78.11,
              37.448
            ],
            [
              -78.125,
              37.445
            ],
            [
              -78.132,
              37.456
            ],
            [
              -78.081,
              37.652
            ],
            [
              -78.076,
              37.655
            ],
            [
              -78.065,
              37.648
            ],
            [
              -78.045,
              37.643
            ],
            [
              -78.016,
              37.643
            ],
            [
              -77.993,
              37.631
            ],
            [
              -77.977,
              37.624
            ],
            [
              -77.959,
              37.626
            ],
            [
              -77.949,
              37.63
            ],
            [
              -77.945,
              37.644
            ],
            [
              -77.957,
              37.663
            ],
            [
              -77.948,
              37.678
            ],
            [
              -77.926,
              37.691
            ],
            [
              -77.91,
              37.69
            ],
            [
              -77.9,
              37.672
            ],
            [
              -77.874,
              37.658
            ],
            [
              -77.853,
              37.644
            ],
            [
              -77.833,
              37.636
            ],
            [
              -77.822,
              37.625
            ],
            [
              -77.821,
              37.61
            ],
            [
              -77.812,
              37.607
            ],
            [
              -77.796,
              37.613
            ],
            [
              -77.763,
              37.612
            ],
            [
              -77.749,
              37.601
            ],
            [
              -77.732,
              37.59
            ],
            [
              -77.708,
              37.59
            ],
            [
              -77.656,
              37.566
            ]
          ]
        ]
      },
      "properties": {
        "name": "Powhatan County",
        "id": "51145",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51145"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -76.388,
                36.848
              ],
              [
                -76.398,
                36.866
              ],
              [
                -76.428,
                36.866
              ],
              [
                -76.409,
                36.883
              ],
              [
                -76.407,
                36.898
              ],
              [
                -76.392,
                36.897
              ],
              [
                -76.381,
                36.907
              ],
              [
                -76.374,
                36.926
              ],
              [
                -76.349,
                36.923
              ],
              [
                -76.346,
                36.9
              ],
              [
                -76.343,
                36.892
              ],
              [
                -76.352,
                36.88
              ],
              [
                -76.34,
                36.864
              ],
              [
                -76.343,
                36.857
              ],
              [
                -76.362,
                36.858
              ],
              [
                -76.364,
                36.847
              ],
              [
                -76.376,
                36.842
              ],
              [
                -76.388,
                36.848
              ]
            ]
          ],
          [
            [
              [
                -76.297,
                36.843
              ],
              [
                -76.298,
                36.838
              ],
              [
                -76.29,
                36.823
              ],
              [
                -76.292,
                36.8
              ],
              [
                -76.302,
                36.799
              ],
              [
                -76.336,
                36.792
              ],
              [
                -76.376,
                36.786
              ],
              [
                -76.387,
                36.8
              ],
              [
                -76.405,
                36.818
              ],
              [
                -76.403,
                36.82
              ],
              [
                -76.395,
                36.821
              ],
              [
                -76.387,
                36.835
              ],
              [
                -76.363,
                36.836
              ],
              [
                -76.359,
                36.845
              ],
              [
                -76.334,
                36.857
              ],
              [
                -76.318,
                36.855
              ],
              [
                -76.317,
                36.846
              ],
              [
                -76.302,
                36.848
              ],
              [
                -76.297,
                36.843
              ]
            ]
          ]
        ]
      },
      "properties": {
        "name": "Portsmouth City",
        "id": "51740",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51740"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.378,
              37.112
            ],
            [
              -76.395,
              37.11
            ],
            [
              -76.414,
              37.138
            ],
            [
              -76.409,
              37.149
            ],
            [
              -76.4,
              37.167
            ],
            [
              -76.381,
              37.165
            ],
            [
              -76.374,
              37.158
            ],
            [
              -76.382,
              37.144
            ],
            [
              -76.364,
              37.147
            ],
            [
              -76.367,
              37.155
            ],
            [
              -76.351,
              37.164
            ],
            [
              -76.351,
              37.172
            ],
            [
              -76.337,
              37.167
            ],
            [
              -76.341,
              37.161
            ],
            [
              -76.336,
              37.147
            ],
            [
              -76.315,
              37.129
            ],
            [
              -76.313,
              37.141
            ],
            [
              -76.294,
              37.13
            ],
            [
              -76.285,
              37.122
            ],
            [
              -76.292,
              37.114
            ],
            [
              -76.315,
              37.111
            ],
            [
              -76.321,
              37.113
            ],
            [
              -76.342,
              37.106
            ],
            [
              -76.358,
              37.12
            ],
            [
              -76.377,
              37.118
            ],
            [
              -76.378,
              37.112
            ]
          ]
        ]
      },
      "properties": {
        "name": "Poquoson City",
        "id": "51735",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51735"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.092,
              37.061
            ],
            [
              -79.219,
              36.542
            ],
            [
              -79.322,
              36.54
            ],
            [
              -79.343,
              36.541
            ],
            [
              -79.351,
              36.548
            ],
            [
              -79.342,
              36.562
            ],
            [
              -79.32,
              36.574
            ],
            [
              -79.305,
              36.57
            ],
            [
              -79.304,
              36.582
            ],
            [
              -79.33,
              36.583
            ],
            [
              -79.331,
              36.602
            ],
            [
              -79.349,
              36.599
            ],
            [
              -79.354,
              36.609
            ],
            [
              -79.365,
              36.608
            ],
            [
              -79.37,
              36.635
            ],
            [
              -79.378,
              36.634
            ],
            [
              -79.393,
              36.642
            ],
            [
              -79.402,
              36.643
            ],
            [
              -79.406,
              36.63
            ],
            [
              -79.423,
              36.603
            ],
            [
              -79.431,
              36.599
            ],
            [
              -79.439,
              36.608
            ],
            [
              -79.445,
              36.607
            ],
            [
              -79.484,
              36.616
            ],
            [
              -79.499,
              36.618
            ],
            [
              -79.519,
              36.604
            ],
            [
              -79.495,
              36.584
            ],
            [
              -79.48,
              36.585
            ],
            [
              -79.457,
              36.578
            ],
            [
              -79.46,
              36.568
            ],
            [
              -79.471,
              36.558
            ],
            [
              -79.47,
              36.54
            ],
            [
              -79.511,
              36.539
            ],
            [
              -79.715,
              36.541
            ],
            [
              -79.704,
              36.596
            ],
            [
              -79.665,
              36.744
            ],
            [
              -79.641,
              36.856
            ],
            [
              -79.596,
              37.045
            ],
            [
              -79.579,
              37.038
            ],
            [
              -79.561,
              37.037
            ],
            [
              -79.56,
              37.045
            ],
            [
              -79.541,
              37.052
            ],
            [
              -79.537,
              37.045
            ],
            [
              -79.51,
              37.031
            ],
            [
              -79.504,
              37.03
            ],
            [
              -79.489,
              37.018
            ],
            [
              -79.483,
              37.009
            ],
            [
              -79.466,
              37.018
            ],
            [
              -79.462,
              37.025
            ],
            [
              -79.481,
              37.037
            ],
            [
              -79.481,
              37.048
            ],
            [
              -79.489,
              37.058
            ],
            [
              -79.486,
              37.067
            ],
            [
              -79.475,
              37.066
            ],
            [
              -79.458,
              37.06
            ],
            [
              -79.441,
              37.06
            ],
            [
              -79.427,
              37.064
            ],
            [
              -79.416,
              37.064
            ],
            [
              -79.404,
              37.068
            ],
            [
              -79.401,
              37.074
            ],
            [
              -79.401,
              37.095
            ],
            [
              -79.375,
              37.102
            ],
            [
              -79.368,
              37.11
            ],
            [
              -79.379,
              37.116
            ],
            [
              -79.377,
              37.124
            ],
            [
              -79.363,
              37.122
            ],
            [
              -79.347,
              37.127
            ],
            [
              -79.336,
              37.136
            ],
            [
              -79.329,
              37.128
            ],
            [
              -79.3,
              37.109
            ],
            [
              -79.293,
              37.107
            ],
            [
              -79.275,
              37.11
            ],
            [
              -79.267,
              37.124
            ],
            [
              -79.254,
              37.134
            ],
            [
              -79.234,
              37.118
            ],
            [
              -79.234,
              37.103
            ],
            [
              -79.221,
              37.101
            ],
            [
              -79.223,
              37.113
            ],
            [
              -79.218,
              37.12
            ],
            [
              -79.21,
              37.12
            ],
            [
              -79.203,
              37.111
            ],
            [
              -79.207,
              37.077
            ],
            [
              -79.203,
              37.065
            ],
            [
              -79.195,
              37.063
            ],
            [
              -79.185,
              37.075
            ],
            [
              -79.174,
              37.065
            ],
            [
              -79.163,
              37.066
            ],
            [
              -79.137,
              37.081
            ],
            [
              -79.12,
              37.079
            ],
            [
              -79.112,
              37.065
            ],
            [
              -79.092,
              37.061
            ]
          ]
        ]
      },
      "properties": {
        "name": "Pittsylvania County",
        "id": "51143",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51143"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.4,
              37.171
            ],
            [
              -77.422,
              37.165
            ],
            [
              -77.423,
              37.181
            ],
            [
              -77.446,
              37.188
            ],
            [
              -77.447,
              37.223
            ],
            [
              -77.433,
              37.226
            ],
            [
              -77.416,
              37.233
            ],
            [
              -77.402,
              37.239
            ],
            [
              -77.386,
              37.238
            ],
            [
              -77.377,
              37.245
            ],
            [
              -77.363,
              37.24
            ],
            [
              -77.345,
              37.214
            ],
            [
              -77.33,
              37.197
            ],
            [
              -77.343,
              37.19
            ],
            [
              -77.346,
              37.174
            ],
            [
              -77.366,
              37.172
            ],
            [
              -77.383,
              37.177
            ],
            [
              -77.4,
              37.171
            ]
          ]
        ]
      },
      "properties": {
        "name": "Petersburg City",
        "id": "51730",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51730"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -80.235,
              36.872
            ],
            [
              -80.208,
              36.866
            ],
            [
              -80.125,
              36.851
            ],
            [
              -80.099,
              36.846
            ],
            [
              -80.085,
              36.849
            ],
            [
              -80.067,
              36.841
            ],
            [
              -80.072,
              36.823
            ],
            [
              -80.042,
              36.799
            ],
            [
              -80.041,
              36.794
            ],
            [
              -80.062,
              36.794
            ],
            [
              -80.08,
              36.791
            ],
            [
              -80.093,
              36.776
            ],
            [
              -80.086,
              36.762
            ],
            [
              -80.093,
              36.746
            ],
            [
              -80.096,
              36.728
            ],
            [
              -80.093,
              36.715
            ],
            [
              -80.086,
              36.704
            ],
            [
              -80.078,
              36.686
            ],
            [
              -80.067,
              36.667
            ],
            [
              -80.058,
              36.658
            ],
            [
              -80.058,
              36.637
            ],
            [
              -80.05,
              36.607
            ],
            [
              -80.054,
              36.543
            ],
            [
              -80.278,
              36.543
            ],
            [
              -80.439,
              36.55
            ],
            [
              -80.612,
              36.557
            ],
            [
              -80.615,
              36.589
            ],
            [
              -80.623,
              36.591
            ],
            [
              -80.626,
              36.606
            ],
            [
              -80.619,
              36.612
            ],
            [
              -80.622,
              36.62
            ],
            [
              -80.604,
              36.638
            ],
            [
              -80.604,
              36.649
            ],
            [
              -80.59,
              36.658
            ],
            [
              -80.571,
              36.658
            ],
            [
              -80.552,
              36.652
            ],
            [
              -80.549,
              36.644
            ],
            [
              -80.54,
              36.641
            ],
            [
              -80.529,
              36.646
            ],
            [
              -80.526,
              36.655
            ],
            [
              -80.514,
              36.651
            ],
            [
              -80.505,
              36.656
            ],
            [
              -80.494,
              36.653
            ],
            [
              -80.489,
              36.662
            ],
            [
              -80.466,
              36.674
            ],
            [
              -80.461,
              36.692
            ],
            [
              -80.454,
              36.701
            ],
            [
              -80.464,
              36.71
            ],
            [
              -80.461,
              36.725
            ],
            [
              -80.453,
              36.733
            ],
            [
              -80.459,
              36.738
            ],
            [
              -80.444,
              36.748
            ],
            [
              -80.431,
              36.743
            ],
            [
              -80.399,
              36.742
            ],
            [
              -80.393,
              36.748
            ],
            [
              -80.398,
              36.756
            ],
            [
              -80.397,
              36.764
            ],
            [
              -80.388,
              36.77
            ],
            [
              -80.392,
              36.776
            ],
            [
              -80.385,
              36.784
            ],
            [
              -80.392,
              36.792
            ],
            [
              -80.377,
              36.803
            ],
            [
              -80.362,
              36.803
            ],
            [
              -80.347,
              36.812
            ],
            [
              -80.344,
              36.832
            ],
            [
              -80.329,
              36.831
            ],
            [
              -80.318,
              36.844
            ],
            [
              -80.303,
              36.844
            ],
            [
              -80.285,
              36.859
            ],
            [
              -80.255,
              36.864
            ],
            [
              -80.254,
              36.871
            ],
            [
              -80.235,
              36.872
            ]
          ]
        ]
      },
      "properties": {
        "name": "Patrick County",
        "id": "51141",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51141"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.339,
              38.628
            ],
            [
              -78.362,
              38.611
            ],
            [
              -78.369,
              38.6
            ],
            [
              -78.382,
              38.591
            ],
            [
              -78.387,
              38.578
            ],
            [
              -78.38,
              38.564
            ],
            [
              -78.405,
              38.555
            ],
            [
              -78.42,
              38.537
            ],
            [
              -78.44,
              38.53
            ],
            [
              -78.437,
              38.522
            ],
            [
              -78.443,
              38.515
            ],
            [
              -78.441,
              38.496
            ],
            [
              -78.45,
              38.481
            ],
            [
              -78.46,
              38.466
            ],
            [
              -78.462,
              38.455
            ],
            [
              -78.478,
              38.444
            ],
            [
              -78.476,
              38.435
            ],
            [
              -78.487,
              38.422
            ],
            [
              -78.534,
              38.433
            ],
            [
              -78.548,
              38.431
            ],
            [
              -78.553,
              38.446
            ],
            [
              -78.567,
              38.448
            ],
            [
              -78.579,
              38.455
            ],
            [
              -78.604,
              38.459
            ],
            [
              -78.617,
              38.469
            ],
            [
              -78.616,
              38.477
            ],
            [
              -78.625,
              38.483
            ],
            [
              -78.628,
              38.495
            ],
            [
              -78.658,
              38.493
            ],
            [
              -78.679,
              38.499
            ],
            [
              -78.685,
              38.504
            ],
            [
              -78.682,
              38.513
            ],
            [
              -78.686,
              38.52
            ],
            [
              -78.67,
              38.547
            ],
            [
              -78.66,
              38.581
            ],
            [
              -78.653,
              38.594
            ],
            [
              -78.642,
              38.605
            ],
            [
              -78.624,
              38.623
            ],
            [
              -78.611,
              38.643
            ],
            [
              -78.6,
              38.669
            ],
            [
              -78.584,
              38.694
            ],
            [
              -78.547,
              38.74
            ],
            [
              -78.512,
              38.726
            ],
            [
              -78.496,
              38.74
            ],
            [
              -78.471,
              38.753
            ],
            [
              -78.459,
              38.762
            ],
            [
              -78.405,
              38.814
            ],
            [
              -78.389,
              38.829
            ],
            [
              -78.354,
              38.809
            ],
            [
              -78.34,
              38.805
            ],
            [
              -78.331,
              38.795
            ],
            [
              -78.313,
              38.788
            ],
            [
              -78.297,
              38.785
            ],
            [
              -78.288,
              38.779
            ],
            [
              -78.288,
              38.767
            ],
            [
              -78.283,
              38.761
            ],
            [
              -78.291,
              38.752
            ],
            [
              -78.302,
              38.753
            ],
            [
              -78.307,
              38.742
            ],
            [
              -78.321,
              38.739
            ],
            [
              -78.323,
              38.723
            ],
            [
              -78.332,
              38.705
            ],
            [
              -78.318,
              38.702
            ],
            [
              -78.315,
              38.685
            ],
            [
              -78.325,
              38.675
            ],
            [
              -78.318,
              38.667
            ],
            [
              -78.314,
              38.65
            ],
            [
              -78.325,
              38.633
            ],
            [
              -78.339,
              38.628
            ]
          ]
        ]
      },
      "properties": {
        "name": "Page County",
        "id": "51139",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51139"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.704,
              38.362
            ],
            [
              -77.716,
              38.345
            ],
            [
              -77.717,
              38.337
            ],
            [
              -77.727,
              38.325
            ],
            [
              -77.76,
              38.296
            ],
            [
              -77.96,
              38.119
            ],
            [
              -77.985,
              38.123
            ],
            [
              -77.998,
              38.136
            ],
            [
              -78.024,
              38.14
            ],
            [
              -78.039,
              38.136
            ],
            [
              -78.077,
              38.143
            ],
            [
              -78.094,
              38.152
            ],
            [
              -78.113,
              38.15
            ],
            [
              -78.119,
              38.142
            ],
            [
              -78.135,
              38.141
            ],
            [
              -78.144,
              38.145
            ],
            [
              -78.152,
              38.138
            ],
            [
              -78.169,
              38.134
            ],
            [
              -78.191,
              38.134
            ],
            [
              -78.208,
              38.131
            ],
            [
              -78.336,
              38.178
            ],
            [
              -78.369,
              38.186
            ],
            [
              -78.289,
              38.272
            ],
            [
              -78.267,
              38.26
            ],
            [
              -78.27,
              38.252
            ],
            [
              -78.249,
              38.234
            ],
            [
              -78.22,
              38.234
            ],
            [
              -78.217,
              38.242
            ],
            [
              -78.193,
              38.247
            ],
            [
              -78.182,
              38.26
            ],
            [
              -78.18,
              38.27
            ],
            [
              -78.159,
              38.268
            ],
            [
              -78.159,
              38.282
            ],
            [
              -78.152,
              38.285
            ],
            [
              -78.126,
              38.283
            ],
            [
              -78.123,
              38.29
            ],
            [
              -78.112,
              38.294
            ],
            [
              -78.099,
              38.306
            ],
            [
              -78.097,
              38.314
            ],
            [
              -78.084,
              38.317
            ],
            [
              -78.069,
              38.312
            ],
            [
              -78.059,
              38.318
            ],
            [
              -78.042,
              38.314
            ],
            [
              -78.035,
              38.328
            ],
            [
              -78.019,
              38.336
            ],
            [
              -78.008,
              38.344
            ],
            [
              -77.99,
              38.35
            ],
            [
              -77.978,
              38.347
            ],
            [
              -77.976,
              38.358
            ],
            [
              -77.96,
              38.356
            ],
            [
              -77.949,
              38.362
            ],
            [
              -77.921,
              38.367
            ],
            [
              -77.907,
              38.383
            ],
            [
              -77.89,
              38.39
            ],
            [
              -77.881,
              38.38
            ],
            [
              -77.86,
              38.384
            ],
            [
              -77.849,
              38.383
            ],
            [
              -77.84,
              38.377
            ],
            [
              -77.829,
              38.383
            ],
            [
              -77.808,
              38.379
            ],
            [
              -77.782,
              38.366
            ],
            [
              -77.787,
              38.378
            ],
            [
              -77.778,
              38.39
            ],
            [
              -77.764,
              38.391
            ],
            [
              -77.747,
              38.383
            ],
            [
              -77.747,
              38.378
            ],
            [
              -77.721,
              38.37
            ],
            [
              -77.704,
              38.362
            ]
          ]
        ]
      },
      "properties": {
        "name": "Orange County",
        "id": "51137",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51137"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.894,
              36.989
            ],
            [
              -77.913,
              36.985
            ],
            [
              -77.945,
              36.987
            ],
            [
              -77.957,
              36.991
            ],
            [
              -77.97,
              36.989
            ],
            [
              -77.98,
              37
            ],
            [
              -77.999,
              37.017
            ],
            [
              -78.009,
              37.018
            ],
            [
              -78.017,
              37.021
            ],
            [
              -78.055,
              37.013
            ],
            [
              -78.072,
              37.013
            ],
            [
              -78.087,
              37.016
            ],
            [
              -78.102,
              37.027
            ],
            [
              -78.111,
              37.025
            ],
            [
              -78.118,
              37.038
            ],
            [
              -78.148,
              37.043
            ],
            [
              -78.162,
              37.06
            ],
            [
              -78.18,
              37.075
            ],
            [
              -78.202,
              37.079
            ],
            [
              -78.241,
              37.12
            ],
            [
              -78.239,
              37.295
            ],
            [
              -77.802,
              37.19
            ],
            [
              -77.807,
              37.179
            ],
            [
              -77.822,
              37.168
            ],
            [
              -77.842,
              37.169
            ],
            [
              -77.86,
              37.162
            ],
            [
              -77.871,
              37.152
            ],
            [
              -77.883,
              37.146
            ],
            [
              -77.9,
              37.145
            ],
            [
              -77.9,
              37.117
            ],
            [
              -77.894,
              36.989
            ]
          ]
        ]
      },
      "properties": {
        "name": "Nottoway County",
        "id": "51135",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51135"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -82.596,
              36.957
            ],
            [
              -82.591,
              36.935
            ],
            [
              -82.619,
              36.931
            ],
            [
              -82.621,
              36.923
            ],
            [
              -82.612,
              36.912
            ],
            [
              -82.618,
              36.906
            ],
            [
              -82.637,
              36.904
            ],
            [
              -82.645,
              36.9
            ],
            [
              -82.655,
              36.918
            ],
            [
              -82.656,
              36.928
            ],
            [
              -82.633,
              36.952
            ],
            [
              -82.618,
              36.957
            ],
            [
              -82.604,
              36.952
            ],
            [
              -82.596,
              36.957
            ]
          ]
        ]
      },
      "properties": {
        "name": "Norton City",
        "id": "51720",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51720"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.355,
              37.701
            ],
            [
              -76.361,
              37.708
            ],
            [
              -76.377,
              37.715
            ],
            [
              -76.367,
              37.727
            ],
            [
              -76.363,
              37.74
            ],
            [
              -76.364,
              37.757
            ],
            [
              -76.368,
              37.774
            ],
            [
              -76.386,
              37.78
            ],
            [
              -76.401,
              37.782
            ],
            [
              -76.413,
              37.792
            ],
            [
              -76.429,
              37.828
            ],
            [
              -76.444,
              37.823
            ],
            [
              -76.459,
              37.821
            ],
            [
              -76.468,
              37.824
            ],
            [
              -76.479,
              37.838
            ],
            [
              -76.497,
              37.841
            ],
            [
              -76.511,
              37.84
            ],
            [
              -76.518,
              37.853
            ],
            [
              -76.543,
              37.862
            ],
            [
              -76.55,
              37.872
            ],
            [
              -76.543,
              37.886
            ],
            [
              -76.547,
              37.907
            ],
            [
              -76.557,
              37.93
            ],
            [
              -76.564,
              37.935
            ],
            [
              -76.578,
              37.938
            ],
            [
              -76.597,
              37.95
            ],
            [
              -76.62,
              37.95
            ],
            [
              -76.631,
              37.969
            ],
            [
              -76.636,
              37.968
            ],
            [
              -76.63,
              37.986
            ],
            [
              -76.617,
              38
            ],
            [
              -76.597,
              38.004
            ],
            [
              -76.588,
              38.008
            ],
            [
              -76.569,
              38.026
            ],
            [
              -76.559,
              38.027
            ],
            [
              -76.544,
              38.027
            ],
            [
              -76.553,
              38.007
            ],
            [
              -76.54,
              37.995
            ],
            [
              -76.533,
              37.995
            ],
            [
              -76.535,
              38.025
            ],
            [
              -76.524,
              38.024
            ],
            [
              -76.513,
              38.028
            ],
            [
              -76.492,
              38.02
            ],
            [
              -76.475,
              38.017
            ],
            [
              -76.464,
              38.008
            ],
            [
              -76.49,
              37.999
            ],
            [
              -76.498,
              37.993
            ],
            [
              -76.493,
              37.985
            ],
            [
              -76.474,
              37.991
            ],
            [
              -76.471,
              37.974
            ],
            [
              -76.478,
              37.975
            ],
            [
              -76.484,
              37.963
            ],
            [
              -76.49,
              37.961
            ],
            [
              -76.477,
              37.947
            ],
            [
              -76.475,
              37.963
            ],
            [
              -76.458,
              37.97
            ],
            [
              -76.454,
              37.979
            ],
            [
              -76.462,
              37.985
            ],
            [
              -76.442,
              37.989
            ],
            [
              -76.434,
              37.975
            ],
            [
              -76.426,
              37.976
            ],
            [
              -76.411,
              37.963
            ],
            [
              -76.391,
              37.959
            ],
            [
              -76.401,
              37.949
            ],
            [
              -76.397,
              37.943
            ],
            [
              -76.386,
              37.942
            ],
            [
              -76.389,
              37.928
            ],
            [
              -76.382,
              37.926
            ],
            [
              -76.375,
              37.934
            ],
            [
              -76.38,
              37.948
            ],
            [
              -76.379,
              37.959
            ],
            [
              -76.361,
              37.954
            ],
            [
              -76.353,
              37.942
            ],
            [
              -76.347,
              37.949
            ],
            [
              -76.325,
              37.939
            ],
            [
              -76.258,
              37.908
            ],
            [
              -76.257,
              37.898
            ],
            [
              -76.284,
              37.899
            ],
            [
              -76.295,
              37.902
            ],
            [
              -76.296,
              37.912
            ],
            [
              -76.312,
              37.917
            ],
            [
              -76.312,
              37.902
            ],
            [
              -76.294,
              37.894
            ],
            [
              -76.295,
              37.884
            ],
            [
              -76.276,
              37.884
            ],
            [
              -76.253,
              37.895
            ],
            [
              -76.236,
              37.889
            ],
            [
              -76.245,
              37.866
            ],
            [
              -76.249,
              37.843
            ],
            [
              -76.254,
              37.829
            ],
            [
              -76.277,
              37.815
            ],
            [
              -76.282,
              37.821
            ],
            [
              -76.27,
              37.829
            ],
            [
              -76.274,
              37.835
            ],
            [
              -76.27,
              37.846
            ],
            [
              -76.277,
              37.855
            ],
            [
              -76.289,
              37.853
            ],
            [
              -76.284,
              37.834
            ],
            [
              -76.317,
              37.849
            ],
            [
              -76.313,
              37.858
            ],
            [
              -76.338,
              37.855
            ],
            [
              -76.359,
              37.861
            ],
            [
              -76.363,
              37.869
            ],
            [
              -76.386,
              37.882
            ],
            [
              -76.408,
              37.878
            ],
            [
              -76.43,
              37.88
            ],
            [
              -76.442,
              37.875
            ],
            [
              -76.407,
              37.87
            ],
            [
              -76.382,
              37.863
            ],
            [
              -76.385,
              37.856
            ],
            [
              -76.398,
              37.855
            ],
            [
              -76.396,
              37.848
            ],
            [
              -76.368,
              37.853
            ],
            [
              -76.36,
              37.843
            ],
            [
              -76.336,
              37.849
            ],
            [
              -76.328,
              37.843
            ],
            [
              -76.333,
              37.836
            ],
            [
              -76.323,
              37.832
            ],
            [
              -76.33,
              37.824
            ],
            [
              -76.321,
              37.817
            ],
            [
              -76.31,
              37.82
            ],
            [
              -76.312,
              37.803
            ],
            [
              -76.337,
              37.805
            ],
            [
              -76.351,
              37.811
            ],
            [
              -76.356,
              37.801
            ],
            [
              -76.342,
              37.801
            ],
            [
              -76.341,
              37.795
            ],
            [
              -76.311,
              37.796
            ],
            [
              -76.29,
              37.793
            ],
            [
              -76.285,
              37.784
            ],
            [
              -76.306,
              37.784
            ],
            [
              -76.316,
              37.776
            ],
            [
              -76.321,
              37.767
            ],
            [
              -76.312,
              37.762
            ],
            [
              -76.313,
              37.755
            ],
            [
              -76.301,
              37.745
            ],
            [
              -76.313,
              37.742
            ],
            [
              -76.331,
              37.76
            ],
            [
              -76.333,
              37.775
            ],
            [
              -76.342,
              37.777
            ],
            [
              -76.343,
              37.762
            ],
            [
              -76.34,
              37.75
            ],
            [
              -76.328,
              37.744
            ],
            [
              -76.334,
              37.737
            ],
            [
              -76.32,
              37.724
            ],
            [
              -76.311,
              37.726
            ],
            [
              -76.299,
              37.701
            ],
            [
              -76.315,
              37.688
            ],
            [
              -76.324,
              37.695
            ],
            [
              -76.355,
              37.701
            ]
          ]
        ]
      },
      "properties": {
        "name": "Northumberland County",
        "id": "51133",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51133"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -75.848,
                37.555
              ],
              [
                -75.836,
                37.555
              ],
              [
                -75.79,
                37.531
              ],
              [
                -75.795,
                37.523
              ],
              [
                -75.808,
                37.515
              ],
              [
                -75.799,
                37.507
              ],
              [
                -75.798,
                37.49
              ],
              [
                -75.811,
                37.481
              ],
              [
                -75.812,
                37.47
              ],
              [
                -75.822,
                37.458
              ],
              [
                -75.822,
                37.45
              ],
              [
                -75.812,
                37.446
              ],
              [
                -75.82,
                37.434
              ],
              [
                -75.803,
                37.416
              ],
              [
                -75.791,
                37.412
              ],
              [
                -75.797,
                37.403
              ],
              [
                -75.807,
                37.401
              ],
              [
                -75.825,
                37.407
              ],
              [
                -75.822,
                37.419
              ],
              [
                -75.836,
                37.417
              ],
              [
                -75.856,
                37.395
              ],
              [
                -75.868,
                37.392
              ],
              [
                -75.869,
                37.378
              ],
              [
                -75.888,
                37.362
              ],
              [
                -75.897,
                37.367
              ],
              [
                -75.903,
                37.353
              ],
              [
                -75.899,
                37.348
              ],
              [
                -75.908,
                37.34
              ],
              [
                -75.907,
                37.325
              ],
              [
                -75.92,
                37.304
              ],
              [
                -75.922,
                37.296
              ],
              [
                -75.915,
                37.292
              ],
              [
                -75.923,
                37.267
              ],
              [
                -75.93,
                37.253
              ],
              [
                -75.925,
                37.239
              ],
              [
                -75.926,
                37.229
              ],
              [
                -75.917,
                37.212
              ],
              [
                -75.931,
                37.214
              ],
              [
                -75.931,
                37.199
              ],
              [
                -75.938,
                37.186
              ],
              [
                -75.938,
                37.158
              ],
              [
                -75.931,
                37.143
              ],
              [
                -75.954,
                37.122
              ],
              [
                -75.971,
                37.126
              ],
              [
                -75.975,
                37.16
              ],
              [
                -75.986,
                37.18
              ],
              [
                -76.013,
                37.209
              ],
              [
                -76.008,
                37.226
              ],
              [
                -76.011,
                37.233
              ],
              [
                -75.993,
                37.235
              ],
              [
                -75.979,
                37.245
              ],
              [
                -76.001,
                37.257
              ],
              [
                -76.001,
                37.243
              ],
              [
                -76.015,
                37.247
              ],
              [
                -76.021,
                37.26
              ],
              [
                -76.028,
                37.266
              ],
              [
                -76.016,
                37.287
              ],
              [
                -76.004,
                37.292
              ],
              [
                -76.014,
                37.297
              ],
              [
                -76.007,
                37.306
              ],
              [
                -75.99,
                37.317
              ],
              [
                -75.983,
                37.317
              ],
              [
                -75.981,
                37.338
              ],
              [
                -75.997,
                37.343
              ],
              [
                -76.001,
                37.329
              ],
              [
                -76.021,
                37.308
              ],
              [
                -76.025,
                37.31
              ],
              [
                -76.019,
                37.335
              ],
              [
                -76.012,
                37.344
              ],
              [
                -75.999,
                37.355
              ],
              [
                -75.989,
                37.368
              ],
              [
                -75.979,
                37.365
              ],
              [
                -75.974,
                37.371
              ],
              [
                -75.988,
                37.377
              ],
              [
                -75.991,
                37.388
              ],
              [
                -75.972,
                37.391
              ],
              [
                -75.966,
                37.395
              ],
              [
                -75.956,
                37.389
              ],
              [
                -75.949,
                37.392
              ],
              [
                -75.972,
                37.405
              ],
              [
                -75.962,
                37.42
              ],
              [
                -75.944,
                37.418
              ],
              [
                -75.939,
                37.426
              ],
              [
                -75.951,
                37.431
              ],
              [
                -75.94,
                37.438
              ],
              [
                -75.947,
                37.444
              ],
              [
                -75.956,
                37.434
              ],
              [
                -75.978,
                37.424
              ],
              [
                -75.988,
                37.417
              ],
              [
                -75.987,
                37.437
              ],
              [
                -75.977,
                37.453
              ],
              [
                -75.96,
                37.468
              ],
              [
                -75.953,
                37.469
              ],
              [
                -75.942,
                37.462
              ],
              [
                -75.931,
                37.465
              ],
              [
                -75.916,
                37.459
              ],
              [
                -75.913,
                37.466
              ],
              [
                -75.931,
                37.473
              ],
              [
                -75.928,
                37.484
              ],
              [
                -75.91,
                37.482
              ],
              [
                -75.891,
                37.489
              ],
              [
                -75.918,
                37.492
              ],
              [
                -75.9,
                37.5
              ],
              [
                -75.901,
                37.511
              ],
              [
                -75.891,
                37.524
              ],
              [
                -75.896,
                37.528
              ],
              [
                -75.917,
                37.512
              ],
              [
                -75.92,
                37.504
              ],
              [
                -75.93,
                37.5
              ],
              [
                -75.932,
                37.493
              ],
              [
                -75.951,
                37.482
              ],
              [
                -75.965,
                37.48
              ],
              [
                -75.959,
                37.497
              ],
              [
                -75.96,
                37.512
              ],
              [
                -75.945,
                37.531
              ],
              [
                -75.932,
                37.555
              ],
              [
                -75.898,
                37.555
              ],
              [
                -75.892,
                37.55
              ],
              [
                -75.848,
                37.555
              ]
            ]
          ],
          [
            [
              [
                -75.776,
                37.304
              ],
              [
                -75.765,
                37.321
              ],
              [
                -75.755,
                37.326
              ],
              [
                -75.751,
                37.34
              ],
              [
                -75.738,
                37.35
              ],
              [
                -75.721,
                37.35
              ],
              [
                -75.743,
                37.336
              ],
              [
                -75.756,
                37.319
              ],
              [
                -75.776,
                37.304
              ]
            ]
          ],
          [
            [
              [
                -75.828,
                37.403
              ],
              [
                -75.83,
                37.39
              ],
              [
                -75.847,
                37.401
              ],
              [
                -75.838,
                37.412
              ],
              [
                -75.828,
                37.415
              ],
              [
                -75.828,
                37.403
              ]
            ]
          ],
          [
            [
              [
                -75.834,
                37.173
              ],
              [
                -75.855,
                37.153
              ],
              [
                -75.855,
                37.174
              ],
              [
                -75.842,
                37.176
              ],
              [
                -75.834,
                37.173
              ]
            ]
          ],
          [
            [
              [
                -75.788,
                37.395
              ],
              [
                -75.791,
                37.389
              ],
              [
                -75.803,
                37.387
              ],
              [
                -75.805,
                37.397
              ],
              [
                -75.788,
                37.395
              ]
            ]
          ],
          [
            [
              [
                -75.847,
                37.356
              ],
              [
                -75.858,
                37.352
              ],
              [
                -75.85,
                37.327
              ],
              [
                -75.857,
                37.32
              ],
              [
                -75.865,
                37.303
              ],
              [
                -75.876,
                37.305
              ],
              [
                -75.894,
                37.302
              ],
              [
                -75.899,
                37.308
              ],
              [
                -75.893,
                37.315
              ],
              [
                -75.889,
                37.328
              ],
              [
                -75.88,
                37.334
              ],
              [
                -75.872,
                37.361
              ],
              [
                -75.856,
                37.377
              ],
              [
                -75.846,
                37.363
              ],
              [
                -75.847,
                37.356
              ]
            ]
          ],
          [
            [
              [
                -75.965,
                37.096
              ],
              [
                -75.982,
                37.1
              ],
              [
                -75.977,
                37.109
              ],
              [
                -75.959,
                37.099
              ],
              [
                -75.965,
                37.096
              ]
            ]
          ],
          [
            [
              [
                -75.802,
                37.328
              ],
              [
                -75.812,
                37.335
              ],
              [
                -75.793,
                37.346
              ],
              [
                -75.802,
                37.328
              ]
            ]
          ],
          [
            [
              [
                -75.668,
                37.457
              ],
              [
                -75.672,
                37.449
              ],
              [
                -75.669,
                37.44
              ],
              [
                -75.692,
                37.417
              ],
              [
                -75.71,
                37.385
              ],
              [
                -75.718,
                37.389
              ],
              [
                -75.714,
                37.401
              ],
              [
                -75.698,
                37.434
              ],
              [
                -75.689,
                37.442
              ],
              [
                -75.693,
                37.453
              ],
              [
                -75.668,
                37.457
              ]
            ]
          ],
          [
            [
              [
                -75.834,
                37.273
              ],
              [
                -75.849,
                37.281
              ],
              [
                -75.841,
                37.291
              ],
              [
                -75.831,
                37.287
              ],
              [
                -75.834,
                37.273
              ]
            ]
          ],
          [
            [
              [
                -75.8,
                37.236
              ],
              [
                -75.798,
                37.222
              ],
              [
                -75.823,
                37.219
              ],
              [
                -75.835,
                37.214
              ],
              [
                -75.845,
                37.221
              ],
              [
                -75.836,
                37.231
              ],
              [
                -75.81,
                37.23
              ],
              [
                -75.8,
                37.236
              ]
            ]
          ],
          [
            [
              [
                -75.89,
                37.231
              ],
              [
                -75.884,
                37.217
              ],
              [
                -75.876,
                37.215
              ],
              [
                -75.877,
                37.206
              ],
              [
                -75.871,
                37.201
              ],
              [
                -75.881,
                37.186
              ],
              [
                -75.888,
                37.169
              ],
              [
                -75.898,
                37.191
              ],
              [
                -75.907,
                37.16
              ],
              [
                -75.913,
                37.179
              ],
              [
                -75.906,
                37.192
              ],
              [
                -75.9,
                37.212
              ],
              [
                -75.908,
                37.23
              ],
              [
                -75.92,
                37.23
              ],
              [
                -75.921,
                37.244
              ],
              [
                -75.911,
                37.251
              ],
              [
                -75.897,
                37.271
              ],
              [
                -75.892,
                37.284
              ],
              [
                -75.882,
                37.292
              ],
              [
                -75.859,
                37.297
              ],
              [
                -75.862,
                37.285
              ],
              [
                -75.854,
                37.271
              ],
              [
                -75.859,
                37.262
              ],
              [
                -75.874,
                37.261
              ],
              [
                -75.881,
                37.255
              ],
              [
                -75.89,
                37.231
              ]
            ]
          ],
          [
            [
              [
                -75.79,
                37.288
              ],
              [
                -75.793,
                37.281
              ],
              [
                -75.789,
                37.264
              ],
              [
                -75.794,
                37.251
              ],
              [
                -75.803,
                37.253
              ],
              [
                -75.808,
                37.264
              ],
              [
                -75.803,
                37.277
              ],
              [
                -75.804,
                37.285
              ],
              [
                -75.79,
                37.288
              ]
            ]
          ],
          [
            [
              [
                -75.829,
                37.198
              ],
              [
                -75.85,
                37.187
              ],
              [
                -75.853,
                37.178
              ],
              [
                -75.865,
                37.184
              ],
              [
                -75.856,
                37.202
              ],
              [
                -75.845,
                37.198
              ],
              [
                -75.842,
                37.205
              ],
              [
                -75.824,
                37.208
              ],
              [
                -75.829,
                37.198
              ]
            ]
          ],
          [
            [
              [
                -75.878,
                37.136
              ],
              [
                -75.885,
                37.127
              ],
              [
                -75.905,
                37.114
              ],
              [
                -75.92,
                37.112
              ],
              [
                -75.909,
                37.135
              ],
              [
                -75.893,
                37.135
              ],
              [
                -75.875,
                37.149
              ],
              [
                -75.867,
                37.144
              ],
              [
                -75.878,
                37.136
              ]
            ]
          ],
          [
            [
              [
                -75.902,
                37.277
              ],
              [
                -75.91,
                37.29
              ],
              [
                -75.903,
                37.293
              ],
              [
                -75.902,
                37.277
              ]
            ]
          ]
        ]
      },
      "properties": {
        "name": "Northampton County",
        "id": "51131",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51131"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.185,
              36.932
            ],
            [
              -76.187,
              36.911
            ],
            [
              -76.204,
              36.912
            ],
            [
              -76.204,
              36.901
            ],
            [
              -76.188,
              36.905
            ],
            [
              -76.198,
              36.886
            ],
            [
              -76.19,
              36.873
            ],
            [
              -76.189,
              36.865
            ],
            [
              -76.177,
              36.856
            ],
            [
              -76.199,
              36.827
            ],
            [
              -76.222,
              36.837
            ],
            [
              -76.234,
              36.838
            ],
            [
              -76.246,
              36.833
            ],
            [
              -76.258,
              36.821
            ],
            [
              -76.275,
              36.828
            ],
            [
              -76.29,
              36.823
            ],
            [
              -76.298,
              36.838
            ],
            [
              -76.297,
              36.843
            ],
            [
              -76.294,
              36.84
            ],
            [
              -76.27,
              36.837
            ],
            [
              -76.247,
              36.842
            ],
            [
              -76.282,
              36.846
            ],
            [
              -76.299,
              36.856
            ],
            [
              -76.306,
              36.865
            ],
            [
              -76.324,
              36.874
            ],
            [
              -76.313,
              36.892
            ],
            [
              -76.313,
              36.904
            ],
            [
              -76.294,
              36.9
            ],
            [
              -76.292,
              36.892
            ],
            [
              -76.274,
              36.884
            ],
            [
              -76.269,
              36.9
            ],
            [
              -76.285,
              36.897
            ],
            [
              -76.284,
              36.908
            ],
            [
              -76.296,
              36.907
            ],
            [
              -76.3,
              36.914
            ],
            [
              -76.312,
              36.915
            ],
            [
              -76.325,
              36.91
            ],
            [
              -76.332,
              36.915
            ],
            [
              -76.335,
              36.927
            ],
            [
              -76.335,
              36.943
            ],
            [
              -76.332,
              36.968
            ],
            [
              -76.322,
              36.96
            ],
            [
              -76.298,
              36.955
            ],
            [
              -76.296,
              36.949
            ],
            [
              -76.277,
              36.95
            ],
            [
              -76.271,
              36.961
            ],
            [
              -76.291,
              36.962
            ],
            [
              -76.302,
              36.971
            ],
            [
              -76.279,
              36.969
            ],
            [
              -76.263,
              36.964
            ],
            [
              -76.233,
              36.943
            ],
            [
              -76.209,
              36.936
            ],
            [
              -76.185,
              36.932
            ]
          ]
        ]
      },
      "properties": {
        "name": "Norfolk City",
        "id": "51710",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51710"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.433,
              37.095
            ],
            [
              -76.451,
              37.077
            ],
            [
              -76.447,
              37.068
            ],
            [
              -76.45,
              37.057
            ],
            [
              -76.449,
              37.038
            ],
            [
              -76.44,
              37.023
            ],
            [
              -76.43,
              37.026
            ],
            [
              -76.409,
              36.994
            ],
            [
              -76.397,
              37.001
            ],
            [
              -76.387,
              36.994
            ],
            [
              -76.41,
              36.972
            ],
            [
              -76.414,
              36.964
            ],
            [
              -76.425,
              36.965
            ],
            [
              -76.435,
              36.974
            ],
            [
              -76.447,
              36.991
            ],
            [
              -76.447,
              37.006
            ],
            [
              -76.457,
              37.014
            ],
            [
              -76.462,
              37.025
            ],
            [
              -76.482,
              37.039
            ],
            [
              -76.496,
              37.045
            ],
            [
              -76.521,
              37.058
            ],
            [
              -76.528,
              37.067
            ],
            [
              -76.52,
              37.088
            ],
            [
              -76.532,
              37.082
            ],
            [
              -76.542,
              37.086
            ],
            [
              -76.561,
              37.113
            ],
            [
              -76.57,
              37.109
            ],
            [
              -76.551,
              37.08
            ],
            [
              -76.568,
              37.08
            ],
            [
              -76.578,
              37.094
            ],
            [
              -76.6,
              37.113
            ],
            [
              -76.612,
              37.115
            ],
            [
              -76.619,
              37.12
            ],
            [
              -76.624,
              37.132
            ],
            [
              -76.619,
              37.144
            ],
            [
              -76.606,
              37.157
            ],
            [
              -76.606,
              37.169
            ],
            [
              -76.599,
              37.178
            ],
            [
              -76.582,
              37.183
            ],
            [
              -76.578,
              37.19
            ],
            [
              -76.592,
              37.21
            ],
            [
              -76.593,
              37.215
            ],
            [
              -76.575,
              37.213
            ],
            [
              -76.565,
              37.22
            ],
            [
              -76.526,
              37.177
            ],
            [
              -76.481,
              37.124
            ],
            [
              -76.466,
              37.108
            ],
            [
              -76.454,
              37.101
            ],
            [
              -76.433,
              37.095
            ]
          ]
        ]
      },
      "properties": {
        "name": "Newport News City",
        "id": "51700",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51700"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.026,
              37.587
            ],
            [
              -77.026,
              37.575
            ],
            [
              -77.012,
              37.566
            ],
            [
              -77.002,
              37.565
            ],
            [
              -76.988,
              37.558
            ],
            [
              -76.976,
              37.569
            ],
            [
              -76.98,
              37.582
            ],
            [
              -76.966,
              37.579
            ],
            [
              -76.964,
              37.567
            ],
            [
              -76.978,
              37.553
            ],
            [
              -76.976,
              37.544
            ],
            [
              -76.95,
              37.531
            ],
            [
              -76.94,
              37.534
            ],
            [
              -76.93,
              37.558
            ],
            [
              -76.914,
              37.564
            ],
            [
              -76.905,
              37.549
            ],
            [
              -76.888,
              37.546
            ],
            [
              -76.873,
              37.556
            ],
            [
              -76.873,
              37.577
            ],
            [
              -76.861,
              37.576
            ],
            [
              -76.862,
              37.564
            ],
            [
              -76.868,
              37.551
            ],
            [
              -76.882,
              37.536
            ],
            [
              -76.878,
              37.527
            ],
            [
              -76.852,
              37.523
            ],
            [
              -76.837,
              37.538
            ],
            [
              -76.83,
              37.548
            ],
            [
              -76.816,
              37.55
            ],
            [
              -76.812,
              37.534
            ],
            [
              -76.804,
              37.524
            ],
            [
              -76.808,
              37.514
            ],
            [
              -76.807,
              37.5
            ],
            [
              -76.767,
              37.485
            ],
            [
              -76.761,
              37.469
            ],
            [
              -76.755,
              37.462
            ],
            [
              -76.763,
              37.455
            ],
            [
              -76.76,
              37.448
            ],
            [
              -76.77,
              37.437
            ],
            [
              -76.792,
              37.44
            ],
            [
              -76.819,
              37.452
            ],
            [
              -76.861,
              37.451
            ],
            [
              -76.865,
              37.445
            ],
            [
              -76.879,
              37.442
            ],
            [
              -76.894,
              37.429
            ],
            [
              -76.891,
              37.421
            ],
            [
              -76.893,
              37.404
            ],
            [
              -76.898,
              37.397
            ],
            [
              -76.89,
              37.389
            ],
            [
              -76.9,
              37.385
            ],
            [
              -76.904,
              37.378
            ],
            [
              -76.917,
              37.387
            ],
            [
              -76.906,
              37.395
            ],
            [
              -76.926,
              37.401
            ],
            [
              -76.934,
              37.389
            ],
            [
              -76.943,
              37.385
            ],
            [
              -76.946,
              37.398
            ],
            [
              -76.935,
              37.403
            ],
            [
              -76.94,
              37.411
            ],
            [
              -76.95,
              37.407
            ],
            [
              -76.965,
              37.408
            ],
            [
              -76.969,
              37.419
            ],
            [
              -76.981,
              37.421
            ],
            [
              -76.998,
              37.419
            ],
            [
              -77.005,
              37.413
            ],
            [
              -77.019,
              37.416
            ],
            [
              -77.026,
              37.429
            ],
            [
              -77.06,
              37.431
            ],
            [
              -77.07,
              37.441
            ],
            [
              -77.094,
              37.443
            ],
            [
              -77.107,
              37.454
            ],
            [
              -77.116,
              37.456
            ],
            [
              -77.128,
              37.473
            ],
            [
              -77.139,
              37.473
            ],
            [
              -77.159,
              37.487
            ],
            [
              -77.17,
              37.484
            ],
            [
              -77.179,
              37.493
            ],
            [
              -77.189,
              37.499
            ],
            [
              -77.193,
              37.509
            ],
            [
              -77.204,
              37.513
            ],
            [
              -77.218,
              37.531
            ],
            [
              -77.226,
              37.536
            ],
            [
              -77.243,
              37.539
            ],
            [
              -77.237,
              37.547
            ],
            [
              -77.218,
              37.555
            ],
            [
              -77.208,
              37.569
            ],
            [
              -77.173,
              37.596
            ],
            [
              -77.145,
              37.592
            ],
            [
              -77.14,
              37.595
            ],
            [
              -77.133,
              37.613
            ],
            [
              -77.138,
              37.619
            ],
            [
              -77.13,
              37.631
            ],
            [
              -77.118,
              37.624
            ],
            [
              -77.105,
              37.624
            ],
            [
              -77.097,
              37.617
            ],
            [
              -77.089,
              37.618
            ],
            [
              -77.091,
              37.604
            ],
            [
              -77.079,
              37.596
            ],
            [
              -77.068,
              37.604
            ],
            [
              -77.046,
              37.594
            ],
            [
              -77.039,
              37.587
            ],
            [
              -77.026,
              37.587
            ]
          ]
        ]
      },
      "properties": {
        "name": "New Kent County",
        "id": "51127",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51127"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.839,
              38.046
            ],
            [
              -78.749,
              37.896
            ],
            [
              -78.703,
              37.826
            ],
            [
              -78.687,
              37.789
            ],
            [
              -78.682,
              37.782
            ],
            [
              -78.692,
              37.777
            ],
            [
              -78.679,
              37.771
            ],
            [
              -78.669,
              37.761
            ],
            [
              -78.683,
              37.759
            ],
            [
              -78.691,
              37.748
            ],
            [
              -78.672,
              37.729
            ],
            [
              -78.652,
              37.729
            ],
            [
              -78.663,
              37.71
            ],
            [
              -78.663,
              37.701
            ],
            [
              -78.651,
              37.687
            ],
            [
              -78.659,
              37.68
            ],
            [
              -78.67,
              37.681
            ],
            [
              -78.677,
              37.691
            ],
            [
              -78.692,
              37.698
            ],
            [
              -78.702,
              37.695
            ],
            [
              -78.699,
              37.676
            ],
            [
              -78.717,
              37.671
            ],
            [
              -78.726,
              37.66
            ],
            [
              -78.724,
              37.642
            ],
            [
              -78.736,
              37.636
            ],
            [
              -78.779,
              37.639
            ],
            [
              -78.803,
              37.644
            ],
            [
              -78.819,
              37.638
            ],
            [
              -78.83,
              37.628
            ],
            [
              -78.825,
              37.617
            ],
            [
              -78.816,
              37.608
            ],
            [
              -78.82,
              37.6
            ],
            [
              -78.838,
              37.591
            ],
            [
              -78.837,
              37.583
            ],
            [
              -78.824,
              37.57
            ],
            [
              -78.829,
              37.558
            ],
            [
              -78.833,
              37.553
            ],
            [
              -78.833,
              37.538
            ],
            [
              -78.843,
              37.536
            ],
            [
              -78.86,
              37.545
            ],
            [
              -78.875,
              37.543
            ],
            [
              -78.88,
              37.547
            ],
            [
              -78.893,
              37.546
            ],
            [
              -78.908,
              37.552
            ],
            [
              -78.949,
              37.65
            ],
            [
              -78.96,
              37.662
            ],
            [
              -78.962,
              37.677
            ],
            [
              -78.972,
              37.684
            ],
            [
              -78.983,
              37.687
            ],
            [
              -78.988,
              37.695
            ],
            [
              -78.999,
              37.701
            ],
            [
              -79.019,
              37.707
            ],
            [
              -79.029,
              37.706
            ],
            [
              -79.042,
              37.713
            ],
            [
              -79.066,
              37.718
            ],
            [
              -79.068,
              37.732
            ],
            [
              -79.067,
              37.751
            ],
            [
              -79.07,
              37.76
            ],
            [
              -79.067,
              37.775
            ],
            [
              -79.071,
              37.78
            ],
            [
              -79.089,
              37.789
            ],
            [
              -79.11,
              37.789
            ],
            [
              -79.117,
              37.792
            ],
            [
              -79.12,
              37.802
            ],
            [
              -79.139,
              37.816
            ],
            [
              -79.172,
              37.804
            ],
            [
              -79.157,
              37.826
            ],
            [
              -79.158,
              37.844
            ],
            [
              -79.142,
              37.86
            ],
            [
              -79.148,
              37.868
            ],
            [
              -79.15,
              37.881
            ],
            [
              -79.157,
              37.892
            ],
            [
              -79.118,
              37.903
            ],
            [
              -79.099,
              37.905
            ],
            [
              -79.087,
              37.913
            ],
            [
              -79.074,
              37.916
            ],
            [
              -79.052,
              37.915
            ],
            [
              -79.05,
              37.9
            ],
            [
              -79.045,
              37.896
            ],
            [
              -79.009,
              37.886
            ],
            [
              -78.999,
              37.889
            ],
            [
              -78.968,
              37.917
            ],
            [
              -78.948,
              37.938
            ],
            [
              -78.927,
              37.941
            ],
            [
              -78.921,
              37.946
            ],
            [
              -78.906,
              37.946
            ],
            [
              -78.891,
              37.975
            ],
            [
              -78.902,
              37.976
            ],
            [
              -78.903,
              37.989
            ],
            [
              -78.89,
              37.996
            ],
            [
              -78.882,
              38.008
            ],
            [
              -78.882,
              38.022
            ],
            [
              -78.875,
              38.029
            ],
            [
              -78.858,
              38.031
            ],
            [
              -78.839,
              38.046
            ]
          ]
        ]
      },
      "properties": {
        "name": "Nelson County",
        "id": "51125",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51125"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -80.176,
              37.125
            ],
            [
              -80.224,
              37.103
            ],
            [
              -80.231,
              37.097
            ],
            [
              -80.276,
              37.082
            ],
            [
              -80.293,
              37.073
            ],
            [
              -80.344,
              37.028
            ],
            [
              -80.356,
              37.02
            ],
            [
              -80.383,
              37.019
            ],
            [
              -80.392,
              37.009
            ],
            [
              -80.401,
              37.011
            ],
            [
              -80.409,
              37.019
            ],
            [
              -80.419,
              37.017
            ],
            [
              -80.41,
              37.006
            ],
            [
              -80.422,
              37.003
            ],
            [
              -80.424,
              37.011
            ],
            [
              -80.434,
              37.016
            ],
            [
              -80.443,
              37.009
            ],
            [
              -80.448,
              37.02
            ],
            [
              -80.471,
              37.003
            ],
            [
              -80.475,
              36.994
            ],
            [
              -80.496,
              36.985
            ],
            [
              -80.509,
              37.005
            ],
            [
              -80.519,
              37.009
            ],
            [
              -80.518,
              36.994
            ],
            [
              -80.535,
              36.977
            ],
            [
              -80.542,
              36.986
            ],
            [
              -80.557,
              37.015
            ],
            [
              -80.554,
              37.032
            ],
            [
              -80.562,
              37.048
            ],
            [
              -80.55,
              37.052
            ],
            [
              -80.549,
              37.063
            ],
            [
              -80.558,
              37.073
            ],
            [
              -80.576,
              37.078
            ],
            [
              -80.583,
              37.09
            ],
            [
              -80.554,
              37.102
            ],
            [
              -80.555,
              37.118
            ],
            [
              -80.519,
              37.124
            ],
            [
              -80.506,
              37.136
            ],
            [
              -80.509,
              37.148
            ],
            [
              -80.519,
              37.151
            ],
            [
              -80.53,
              37.145
            ],
            [
              -80.535,
              37.157
            ],
            [
              -80.552,
              37.156
            ],
            [
              -80.568,
              37.178
            ],
            [
              -80.556,
              37.19
            ],
            [
              -80.544,
              37.194
            ],
            [
              -80.529,
              37.192
            ],
            [
              -80.517,
              37.194
            ],
            [
              -80.515,
              37.202
            ],
            [
              -80.528,
              37.206
            ],
            [
              -80.546,
              37.203
            ],
            [
              -80.57,
              37.194
            ],
            [
              -80.585,
              37.183
            ],
            [
              -80.594,
              37.186
            ],
            [
              -80.6,
              37.201
            ],
            [
              -80.613,
              37.212
            ],
            [
              -80.615,
              37.232
            ],
            [
              -80.606,
              37.241
            ],
            [
              -80.607,
              37.247
            ],
            [
              -80.555,
              37.261
            ],
            [
              -80.53,
              37.263
            ],
            [
              -80.505,
              37.273
            ],
            [
              -80.476,
              37.29
            ],
            [
              -80.448,
              37.309
            ],
            [
              -80.428,
              37.319
            ],
            [
              -80.403,
              37.33
            ],
            [
              -80.356,
              37.348
            ],
            [
              -80.334,
              37.361
            ],
            [
              -80.263,
              37.342
            ],
            [
              -80.258,
              37.306
            ],
            [
              -80.195,
              37.235
            ],
            [
              -80.176,
              37.125
            ]
          ]
        ]
      },
      "properties": {
        "name": "Montgomery County",
        "id": "51121",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51121"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.525,
              37.551
            ],
            [
              -76.551,
              37.57
            ],
            [
              -76.563,
              37.564
            ],
            [
              -76.574,
              37.563
            ],
            [
              -76.582,
              37.576
            ],
            [
              -76.595,
              37.588
            ],
            [
              -76.615,
              37.584
            ],
            [
              -76.628,
              37.591
            ],
            [
              -76.639,
              37.591
            ],
            [
              -76.654,
              37.601
            ],
            [
              -76.685,
              37.621
            ],
            [
              -76.697,
              37.633
            ],
            [
              -76.7,
              37.642
            ],
            [
              -76.708,
              37.647
            ],
            [
              -76.731,
              37.681
            ],
            [
              -76.732,
              37.689
            ],
            [
              -76.747,
              37.701
            ],
            [
              -76.753,
              37.72
            ],
            [
              -76.751,
              37.729
            ],
            [
              -76.755,
              37.739
            ],
            [
              -76.742,
              37.741
            ],
            [
              -76.727,
              37.755
            ],
            [
              -76.717,
              37.759
            ],
            [
              -76.685,
              37.768
            ],
            [
              -76.68,
              37.757
            ],
            [
              -76.669,
              37.753
            ],
            [
              -76.643,
              37.752
            ],
            [
              -76.628,
              37.748
            ],
            [
              -76.621,
              37.733
            ],
            [
              -76.603,
              37.722
            ],
            [
              -76.593,
              37.7
            ],
            [
              -76.59,
              37.685
            ],
            [
              -76.582,
              37.671
            ],
            [
              -76.602,
              37.677
            ],
            [
              -76.61,
              37.685
            ],
            [
              -76.622,
              37.676
            ],
            [
              -76.604,
              37.673
            ],
            [
              -76.58,
              37.662
            ],
            [
              -76.595,
              37.66
            ],
            [
              -76.571,
              37.645
            ],
            [
              -76.539,
              37.616
            ],
            [
              -76.504,
              37.611
            ],
            [
              -76.497,
              37.615
            ],
            [
              -76.457,
              37.613
            ],
            [
              -76.444,
              37.611
            ],
            [
              -76.437,
              37.616
            ],
            [
              -76.428,
              37.61
            ],
            [
              -76.434,
              37.6
            ],
            [
              -76.43,
              37.59
            ],
            [
              -76.412,
              37.583
            ],
            [
              -76.401,
              37.581
            ],
            [
              -76.386,
              37.574
            ],
            [
              -76.374,
              37.575
            ],
            [
              -76.344,
              37.574
            ],
            [
              -76.327,
              37.564
            ],
            [
              -76.319,
              37.567
            ],
            [
              -76.294,
              37.562
            ],
            [
              -76.304,
              37.546
            ],
            [
              -76.333,
              37.54
            ],
            [
              -76.365,
              37.536
            ],
            [
              -76.372,
              37.543
            ],
            [
              -76.396,
              37.536
            ],
            [
              -76.408,
              37.542
            ],
            [
              -76.417,
              37.521
            ],
            [
              -76.43,
              37.529
            ],
            [
              -76.445,
              37.522
            ],
            [
              -76.458,
              37.533
            ],
            [
              -76.471,
              37.542
            ],
            [
              -76.48,
              37.544
            ],
            [
              -76.496,
              37.541
            ],
            [
              -76.503,
              37.549
            ],
            [
              -76.517,
              37.554
            ],
            [
              -76.525,
              37.551
            ]
          ]
        ]
      },
      "properties": {
        "name": "Middlesex County",
        "id": "51119",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51119"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.03,
              36.779
            ],
            [
              -78.049,
              36.546
            ],
            [
              -78.125,
              36.546
            ],
            [
              -78.304,
              36.545
            ],
            [
              -78.403,
              36.542
            ],
            [
              -78.509,
              36.542
            ],
            [
              -78.73,
              36.544
            ],
            [
              -78.737,
              36.554
            ],
            [
              -78.732,
              36.57
            ],
            [
              -78.719,
              36.579
            ],
            [
              -78.715,
              36.594
            ],
            [
              -78.717,
              36.602
            ],
            [
              -78.711,
              36.617
            ],
            [
              -78.712,
              36.631
            ],
            [
              -78.707,
              36.653
            ],
            [
              -78.699,
              36.664
            ],
            [
              -78.7,
              36.68
            ],
            [
              -78.67,
              36.693
            ],
            [
              -78.657,
              36.693
            ],
            [
              -78.644,
              36.688
            ],
            [
              -78.616,
              36.662
            ],
            [
              -78.574,
              36.641
            ],
            [
              -78.563,
              36.638
            ],
            [
              -78.545,
              36.626
            ],
            [
              -78.542,
              36.63
            ],
            [
              -78.554,
              36.64
            ],
            [
              -78.612,
              36.666
            ],
            [
              -78.625,
              36.676
            ],
            [
              -78.646,
              36.7
            ],
            [
              -78.495,
              36.889
            ],
            [
              -78.493,
              36.892
            ],
            [
              -78.461,
              36.875
            ],
            [
              -78.432,
              36.871
            ],
            [
              -78.422,
              36.855
            ],
            [
              -78.402,
              36.859
            ],
            [
              -78.398,
              36.864
            ],
            [
              -78.359,
              36.859
            ],
            [
              -78.349,
              36.845
            ],
            [
              -78.332,
              36.854
            ],
            [
              -78.311,
              36.847
            ],
            [
              -78.29,
              36.829
            ],
            [
              -78.275,
              36.821
            ],
            [
              -78.267,
              36.822
            ],
            [
              -78.245,
              36.815
            ],
            [
              -78.243,
              36.81
            ],
            [
              -78.211,
              36.806
            ],
            [
              -78.181,
              36.805
            ],
            [
              -78.159,
              36.799
            ],
            [
              -78.145,
              36.797
            ],
            [
              -78.118,
              36.789
            ],
            [
              -78.099,
              36.798
            ],
            [
              -78.076,
              36.79
            ],
            [
              -78.056,
              36.778
            ],
            [
              -78.045,
              36.783
            ],
            [
              -78.03,
              36.779
            ]
          ]
        ]
      },
      "properties": {
        "name": "Mecklenburg County",
        "id": "51117",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51117"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -76.262,
                37.491
              ],
              [
                -76.284,
                37.489
              ],
              [
                -76.306,
                37.495
              ],
              [
                -76.3,
                37.507
              ],
              [
                -76.304,
                37.517
              ],
              [
                -76.297,
                37.521
              ],
              [
                -76.28,
                37.515
              ],
              [
                -76.262,
                37.491
              ]
            ]
          ],
          [
            [
              [
                -76.445,
                37.459
              ],
              [
                -76.45,
                37.486
              ],
              [
                -76.439,
                37.508
              ],
              [
                -76.439,
                37.514
              ],
              [
                -76.42,
                37.51
              ],
              [
                -76.407,
                37.519
              ],
              [
                -76.396,
                37.522
              ],
              [
                -76.399,
                37.53
              ],
              [
                -76.378,
                37.527
              ],
              [
                -76.36,
                37.522
              ],
              [
                -76.36,
                37.511
              ],
              [
                -76.351,
                37.505
              ],
              [
                -76.337,
                37.507
              ],
              [
                -76.324,
                37.499
              ],
              [
                -76.321,
                37.485
              ],
              [
                -76.311,
                37.482
              ],
              [
                -76.3,
                37.489
              ],
              [
                -76.289,
                37.479
              ],
              [
                -76.285,
                37.464
              ],
              [
                -76.298,
                37.467
              ],
              [
                -76.318,
                37.465
              ],
              [
                -76.301,
                37.455
              ],
              [
                -76.285,
                37.459
              ],
              [
                -76.281,
                37.448
              ],
              [
                -76.274,
                37.447
              ],
              [
                -76.272,
                37.467
              ],
              [
                -76.262,
                37.458
              ],
              [
                -76.267,
                37.449
              ],
              [
                -76.254,
                37.447
              ],
              [
                -76.255,
                37.463
              ],
              [
                -76.25,
                37.466
              ],
              [
                -76.243,
                37.449
              ],
              [
                -76.249,
                37.432
              ],
              [
                -76.242,
                37.401
              ],
              [
                -76.243,
                37.388
              ],
              [
                -76.254,
                37.384
              ],
              [
                -76.265,
                37.389
              ],
              [
                -76.277,
                37.383
              ],
              [
                -76.259,
                37.377
              ],
              [
                -76.253,
                37.367
              ],
              [
                -76.258,
                37.358
              ],
              [
                -76.27,
                37.37
              ],
              [
                -76.287,
                37.364
              ],
              [
                -76.266,
                37.353
              ],
              [
                -76.273,
                37.335
              ],
              [
                -76.27,
                37.323
              ],
              [
                -76.277,
                37.309
              ],
              [
                -76.284,
                37.326
              ],
              [
                -76.304,
                37.33
              ],
              [
                -76.31,
                37.343
              ],
              [
                -76.32,
                37.347
              ],
              [
                -76.336,
                37.365
              ],
              [
                -76.325,
                37.398
              ],
              [
                -76.334,
                37.4
              ],
              [
                -76.347,
                37.426
              ],
              [
                -76.367,
                37.429
              ],
              [
                -76.36,
                37.42
              ],
              [
                -76.348,
                37.416
              ],
              [
                -76.352,
                37.403
              ],
              [
                -76.341,
                37.394
              ],
              [
                -76.342,
                37.38
              ],
              [
                -76.357,
                37.374
              ],
              [
                -76.391,
                37.394
              ],
              [
                -76.396,
                37.407
              ],
              [
                -76.395,
                37.418
              ],
              [
                -76.39,
                37.425
              ],
              [
                -76.4,
                37.431
              ],
              [
                -76.404,
                37.443
              ],
              [
                -76.413,
                37.438
              ],
              [
                -76.409,
                37.425
              ],
              [
                -76.432,
                37.424
              ],
              [
                -76.437,
                37.441
              ],
              [
                -76.434,
                37.45
              ],
              [
                -76.445,
                37.459
              ]
            ]
          ]
        ]
      },
      "properties": {
        "name": "Mathews County",
        "id": "51115",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51115"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.83,
              36.65
            ],
            [
              -79.844,
              36.646
            ],
            [
              -79.86,
              36.651
            ],
            [
              -79.858,
              36.664
            ],
            [
              -79.894,
              36.674
            ],
            [
              -79.905,
              36.683
            ],
            [
              -79.88,
              36.714
            ],
            [
              -79.836,
              36.708
            ],
            [
              -79.843,
              36.672
            ],
            [
              -79.831,
              36.661
            ],
            [
              -79.83,
              36.65
            ]
          ]
        ]
      },
      "properties": {
        "name": "Martinsville City",
        "id": "51690",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51690"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.448,
              38.761
            ],
            [
              -77.462,
              38.768
            ],
            [
              -77.459,
              38.772
            ],
            [
              -77.476,
              38.781
            ],
            [
              -77.474,
              38.788
            ],
            [
              -77.44,
              38.783
            ],
            [
              -77.431,
              38.772
            ],
            [
              -77.44,
              38.757
            ],
            [
              -77.448,
              38.761
            ]
          ]
        ]
      },
      "properties": {
        "name": "Manassas Park City",
        "id": "51685",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51685"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.476,
              38.781
            ],
            [
              -77.459,
              38.772
            ],
            [
              -77.462,
              38.768
            ],
            [
              -77.448,
              38.761
            ],
            [
              -77.454,
              38.736
            ],
            [
              -77.471,
              38.727
            ],
            [
              -77.508,
              38.74
            ],
            [
              -77.513,
              38.737
            ],
            [
              -77.501,
              38.712
            ],
            [
              -77.505,
              38.707
            ],
            [
              -77.524,
              38.718
            ],
            [
              -77.527,
              38.734
            ],
            [
              -77.523,
              38.742
            ],
            [
              -77.514,
              38.747
            ],
            [
              -77.504,
              38.76
            ],
            [
              -77.489,
              38.768
            ],
            [
              -77.476,
              38.781
            ]
          ]
        ]
      },
      "properties": {
        "name": "Manassas City",
        "id": "51683",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51683"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.097,
              38.314
            ],
            [
              -78.099,
              38.306
            ],
            [
              -78.112,
              38.294
            ],
            [
              -78.123,
              38.29
            ],
            [
              -78.126,
              38.283
            ],
            [
              -78.152,
              38.285
            ],
            [
              -78.159,
              38.282
            ],
            [
              -78.159,
              38.268
            ],
            [
              -78.18,
              38.27
            ],
            [
              -78.182,
              38.26
            ],
            [
              -78.193,
              38.247
            ],
            [
              -78.217,
              38.242
            ],
            [
              -78.22,
              38.234
            ],
            [
              -78.249,
              38.234
            ],
            [
              -78.27,
              38.252
            ],
            [
              -78.267,
              38.26
            ],
            [
              -78.289,
              38.272
            ],
            [
              -78.299,
              38.275
            ],
            [
              -78.305,
              38.27
            ],
            [
              -78.33,
              38.273
            ],
            [
              -78.349,
              38.288
            ],
            [
              -78.362,
              38.295
            ],
            [
              -78.358,
              38.302
            ],
            [
              -78.364,
              38.318
            ],
            [
              -78.377,
              38.318
            ],
            [
              -78.405,
              38.339
            ],
            [
              -78.412,
              38.352
            ],
            [
              -78.429,
              38.366
            ],
            [
              -78.424,
              38.388
            ],
            [
              -78.434,
              38.394
            ],
            [
              -78.438,
              38.408
            ],
            [
              -78.433,
              38.426
            ],
            [
              -78.435,
              38.456
            ],
            [
              -78.447,
              38.465
            ],
            [
              -78.45,
              38.481
            ],
            [
              -78.441,
              38.496
            ],
            [
              -78.443,
              38.515
            ],
            [
              -78.437,
              38.522
            ],
            [
              -78.44,
              38.53
            ],
            [
              -78.42,
              38.537
            ],
            [
              -78.405,
              38.555
            ],
            [
              -78.38,
              38.564
            ],
            [
              -78.387,
              38.578
            ],
            [
              -78.382,
              38.591
            ],
            [
              -78.369,
              38.6
            ],
            [
              -78.362,
              38.611
            ],
            [
              -78.339,
              38.628
            ],
            [
              -78.234,
              38.536
            ],
            [
              -78.132,
              38.447
            ],
            [
              -78.122,
              38.44
            ],
            [
              -78.128,
              38.431
            ],
            [
              -78.117,
              38.418
            ],
            [
              -78.107,
              38.416
            ],
            [
              -78.097,
              38.401
            ],
            [
              -78.096,
              38.393
            ],
            [
              -78.114,
              38.381
            ],
            [
              -78.119,
              38.363
            ],
            [
              -78.108,
              38.346
            ],
            [
              -78.095,
              38.342
            ],
            [
              -78.091,
              38.332
            ],
            [
              -78.098,
              38.328
            ],
            [
              -78.107,
              38.315
            ],
            [
              -78.097,
              38.314
            ]
          ]
        ]
      },
      "properties": {
        "name": "Madison County",
        "id": "51113",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51113"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.085,
              37.396
            ],
            [
              -79.102,
              37.377
            ],
            [
              -79.119,
              37.368
            ],
            [
              -79.135,
              37.376
            ],
            [
              -79.157,
              37.359
            ],
            [
              -79.176,
              37.341
            ],
            [
              -79.195,
              37.344
            ],
            [
              -79.206,
              37.341
            ],
            [
              -79.214,
              37.333
            ],
            [
              -79.255,
              37.351
            ],
            [
              -79.258,
              37.355
            ],
            [
              -79.232,
              37.395
            ],
            [
              -79.254,
              37.406
            ],
            [
              -79.243,
              37.42
            ],
            [
              -79.251,
              37.43
            ],
            [
              -79.268,
              37.431
            ],
            [
              -79.264,
              37.449
            ],
            [
              -79.252,
              37.447
            ],
            [
              -79.242,
              37.451
            ],
            [
              -79.209,
              37.469
            ],
            [
              -79.185,
              37.468
            ],
            [
              -79.179,
              37.455
            ],
            [
              -79.148,
              37.437
            ],
            [
              -79.139,
              37.42
            ],
            [
              -79.127,
              37.404
            ],
            [
              -79.116,
              37.402
            ],
            [
              -79.111,
              37.408
            ],
            [
              -79.102,
              37.407
            ],
            [
              -79.085,
              37.396
            ]
          ]
        ]
      },
      "properties": {
        "name": "Lynchburg City",
        "id": "51680",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51680"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.009,
              37.018
            ],
            [
              -78.03,
              36.779
            ],
            [
              -78.045,
              36.783
            ],
            [
              -78.056,
              36.778
            ],
            [
              -78.076,
              36.79
            ],
            [
              -78.099,
              36.798
            ],
            [
              -78.118,
              36.789
            ],
            [
              -78.145,
              36.797
            ],
            [
              -78.159,
              36.799
            ],
            [
              -78.181,
              36.805
            ],
            [
              -78.211,
              36.806
            ],
            [
              -78.243,
              36.81
            ],
            [
              -78.245,
              36.815
            ],
            [
              -78.267,
              36.822
            ],
            [
              -78.275,
              36.821
            ],
            [
              -78.29,
              36.829
            ],
            [
              -78.311,
              36.847
            ],
            [
              -78.332,
              36.854
            ],
            [
              -78.349,
              36.845
            ],
            [
              -78.359,
              36.859
            ],
            [
              -78.398,
              36.864
            ],
            [
              -78.402,
              36.859
            ],
            [
              -78.422,
              36.855
            ],
            [
              -78.432,
              36.871
            ],
            [
              -78.461,
              36.875
            ],
            [
              -78.493,
              36.892
            ],
            [
              -78.447,
              37.079
            ],
            [
              -78.405,
              37.086
            ],
            [
              -78.385,
              37.092
            ],
            [
              -78.379,
              37.1
            ],
            [
              -78.367,
              37.105
            ],
            [
              -78.321,
              37.105
            ],
            [
              -78.304,
              37.101
            ],
            [
              -78.278,
              37.106
            ],
            [
              -78.27,
              37.114
            ],
            [
              -78.241,
              37.12
            ],
            [
              -78.202,
              37.079
            ],
            [
              -78.18,
              37.075
            ],
            [
              -78.162,
              37.06
            ],
            [
              -78.148,
              37.043
            ],
            [
              -78.118,
              37.038
            ],
            [
              -78.111,
              37.025
            ],
            [
              -78.102,
              37.027
            ],
            [
              -78.087,
              37.016
            ],
            [
              -78.072,
              37.013
            ],
            [
              -78.055,
              37.013
            ],
            [
              -78.017,
              37.021
            ],
            [
              -78.009,
              37.018
            ]
          ]
        ]
      },
      "properties": {
        "name": "Lunenburg County",
        "id": "51111",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51111"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.96,
              38.119
            ],
            [
              -77.944,
              38.119
            ],
            [
              -77.937,
              38.116
            ],
            [
              -77.914,
              38.116
            ],
            [
              -77.901,
              38.109
            ],
            [
              -77.889,
              38.112
            ],
            [
              -77.863,
              38.106
            ],
            [
              -77.855,
              38.101
            ],
            [
              -77.838,
              38.106
            ],
            [
              -77.816,
              38.087
            ],
            [
              -77.808,
              38.078
            ],
            [
              -77.792,
              38.078
            ],
            [
              -77.782,
              38.072
            ],
            [
              -77.782,
              38.063
            ],
            [
              -77.759,
              38.049
            ],
            [
              -77.746,
              38.049
            ],
            [
              -77.748,
              38.026
            ],
            [
              -77.739,
              38.032
            ],
            [
              -77.73,
              38.031
            ],
            [
              -77.711,
              38.013
            ],
            [
              -77.688,
              38.008
            ],
            [
              -77.8,
              37.733
            ],
            [
              -77.833,
              37.754
            ],
            [
              -77.891,
              37.76
            ],
            [
              -77.906,
              37.779
            ],
            [
              -77.917,
              37.807
            ],
            [
              -77.946,
              37.845
            ],
            [
              -77.992,
              37.857
            ],
            [
              -78.006,
              37.875
            ],
            [
              -78.063,
              37.906
            ],
            [
              -78.141,
              37.936
            ],
            [
              -78.17,
              37.951
            ],
            [
              -78.196,
              37.954
            ],
            [
              -78.213,
              37.964
            ],
            [
              -78.221,
              37.976
            ],
            [
              -78.259,
              37.987
            ],
            [
              -78.291,
              37.999
            ],
            [
              -78.306,
              38.007
            ],
            [
              -78.255,
              38.064
            ],
            [
              -78.225,
              38.105
            ],
            [
              -78.208,
              38.131
            ],
            [
              -78.191,
              38.134
            ],
            [
              -78.169,
              38.134
            ],
            [
              -78.152,
              38.138
            ],
            [
              -78.144,
              38.145
            ],
            [
              -78.135,
              38.141
            ],
            [
              -78.119,
              38.142
            ],
            [
              -78.113,
              38.15
            ],
            [
              -78.094,
              38.152
            ],
            [
              -78.077,
              38.143
            ],
            [
              -78.039,
              38.136
            ],
            [
              -78.024,
              38.14
            ],
            [
              -77.998,
              38.136
            ],
            [
              -77.985,
              38.123
            ],
            [
              -77.96,
              38.119
            ]
          ]
        ]
      },
      "properties": {
        "name": "Louisa County",
        "id": "51109",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51109"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.327,
              39.061
            ],
            [
              -77.47,
              38.92
            ],
            [
              -77.537,
              38.848
            ],
            [
              -77.55,
              38.857
            ],
            [
              -77.55,
              38.88
            ],
            [
              -77.552,
              38.885
            ],
            [
              -77.584,
              38.893
            ],
            [
              -77.602,
              38.907
            ],
            [
              -77.619,
              38.932
            ],
            [
              -77.638,
              38.942
            ],
            [
              -77.657,
              38.944
            ],
            [
              -77.961,
              39.015
            ],
            [
              -77.942,
              39.022
            ],
            [
              -77.927,
              39.035
            ],
            [
              -77.899,
              39.054
            ],
            [
              -77.879,
              39.078
            ],
            [
              -77.862,
              39.085
            ],
            [
              -77.856,
              39.094
            ],
            [
              -77.855,
              39.109
            ],
            [
              -77.849,
              39.118
            ],
            [
              -77.833,
              39.127
            ],
            [
              -77.83,
              39.134
            ],
            [
              -77.824,
              39.137
            ],
            [
              -77.818,
              39.157
            ],
            [
              -77.804,
              39.178
            ],
            [
              -77.798,
              39.197
            ],
            [
              -77.789,
              39.219
            ],
            [
              -77.772,
              39.239
            ],
            [
              -77.769,
              39.258
            ],
            [
              -77.76,
              39.267
            ],
            [
              -77.755,
              39.282
            ],
            [
              -77.734,
              39.315
            ],
            [
              -77.72,
              39.325
            ],
            [
              -77.694,
              39.321
            ],
            [
              -77.671,
              39.325
            ],
            [
              -77.661,
              39.318
            ],
            [
              -77.635,
              39.309
            ],
            [
              -77.599,
              39.303
            ],
            [
              -77.57,
              39.308
            ],
            [
              -77.562,
              39.304
            ],
            [
              -77.558,
              39.29
            ],
            [
              -77.538,
              39.266
            ],
            [
              -77.491,
              39.251
            ],
            [
              -77.456,
              39.228
            ],
            [
              -77.456,
              39.222
            ],
            [
              -77.472,
              39.207
            ],
            [
              -77.474,
              39.194
            ],
            [
              -77.483,
              39.187
            ],
            [
              -77.504,
              39.18
            ],
            [
              -77.515,
              39.17
            ],
            [
              -77.525,
              39.143
            ],
            [
              -77.518,
              39.124
            ],
            [
              -77.485,
              39.111
            ],
            [
              -77.47,
              39.095
            ],
            [
              -77.461,
              39.079
            ],
            [
              -77.453,
              39.073
            ],
            [
              -77.407,
              39.068
            ],
            [
              -77.382,
              39.064
            ],
            [
              -77.327,
              39.061
            ]
          ]
        ]
      },
      "properties": {
        "name": "Loudoun County",
        "id": "51107",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": 62
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.461,
              37.775
            ],
            [
              -79.455,
              37.782
            ],
            [
              -79.462,
              37.788
            ],
            [
              -79.454,
              37.796
            ],
            [
              -79.442,
              37.801
            ],
            [
              -79.415,
              37.791
            ],
            [
              -79.453,
              37.766
            ],
            [
              -79.461,
              37.775
            ]
          ]
        ]
      },
      "properties": {
        "name": "Lexington City",
        "id": "51678",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51678"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -82.77,
              36.799
            ],
            [
              -82.787,
              36.787
            ],
            [
              -82.792,
              36.78
            ],
            [
              -82.805,
              36.775
            ],
            [
              -82.829,
              36.747
            ],
            [
              -82.824,
              36.735
            ],
            [
              -82.829,
              36.728
            ],
            [
              -82.844,
              36.721
            ],
            [
              -82.888,
              36.707
            ],
            [
              -82.945,
              36.679
            ],
            [
              -82.985,
              36.594
            ],
            [
              -83.254,
              36.594
            ],
            [
              -83.274,
              36.6
            ],
            [
              -83.472,
              36.598
            ],
            [
              -83.49,
              36.598
            ],
            [
              -83.625,
              36.599
            ],
            [
              -83.648,
              36.601
            ],
            [
              -83.675,
              36.601
            ],
            [
              -83.648,
              36.623
            ],
            [
              -83.627,
              36.628
            ],
            [
              -83.61,
              36.637
            ],
            [
              -83.592,
              36.643
            ],
            [
              -83.58,
              36.642
            ],
            [
              -83.537,
              36.659
            ],
            [
              -83.53,
              36.665
            ],
            [
              -83.499,
              36.671
            ],
            [
              -83.46,
              36.667
            ],
            [
              -83.422,
              36.67
            ],
            [
              -83.397,
              36.679
            ],
            [
              -83.384,
              36.689
            ],
            [
              -83.335,
              36.704
            ],
            [
              -83.265,
              36.721
            ],
            [
              -83.196,
              36.739
            ],
            [
              -83.182,
              36.741
            ],
            [
              -83.141,
              36.742
            ],
            [
              -83.128,
              36.758
            ],
            [
              -83.133,
              36.785
            ],
            [
              -83.116,
              36.792
            ],
            [
              -83.099,
              36.81
            ],
            [
              -83.098,
              36.831
            ],
            [
              -83.088,
              36.839
            ],
            [
              -83.073,
              36.844
            ],
            [
              -83.068,
              36.854
            ],
            [
              -83.052,
              36.853
            ],
            [
              -83.028,
              36.855
            ],
            [
              -83.025,
              36.851
            ],
            [
              -83.007,
              36.847
            ],
            [
              -82.999,
              36.856
            ],
            [
              -82.985,
              36.859
            ],
            [
              -82.962,
              36.861
            ],
            [
              -82.951,
              36.865
            ],
            [
              -82.909,
              36.876
            ],
            [
              -82.893,
              36.881
            ],
            [
              -82.878,
              36.893
            ],
            [
              -82.863,
              36.877
            ],
            [
              -82.851,
              36.87
            ],
            [
              -82.845,
              36.846
            ],
            [
              -82.835,
              36.848
            ],
            [
              -82.78,
              36.807
            ],
            [
              -82.77,
              36.799
            ]
          ]
        ]
      },
      "properties": {
        "name": "Lee County",
        "id": "51105",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51105"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -76.355,
                37.701
              ],
              [
                -76.357,
                37.693
              ],
              [
                -76.329,
                37.684
              ],
              [
                -76.322,
                37.678
              ],
              [
                -76.347,
                37.677
              ],
              [
                -76.335,
                37.661
              ],
              [
                -76.332,
                37.642
              ],
              [
                -76.324,
                37.633
              ],
              [
                -76.309,
                37.64
              ],
              [
                -76.314,
                37.624
              ],
              [
                -76.323,
                37.618
              ],
              [
                -76.332,
                37.618
              ],
              [
                -76.333,
                37.628
              ],
              [
                -76.355,
                37.626
              ],
              [
                -76.351,
                37.614
              ],
              [
                -76.36,
                37.61
              ],
              [
                -76.384,
                37.629
              ],
              [
                -76.407,
                37.63
              ],
              [
                -76.417,
                37.639
              ],
              [
                -76.43,
                37.641
              ],
              [
                -76.436,
                37.647
              ],
              [
                -76.412,
                37.662
              ],
              [
                -76.439,
                37.666
              ],
              [
                -76.439,
                37.659
              ],
              [
                -76.449,
                37.65
              ],
              [
                -76.46,
                37.652
              ],
              [
                -76.458,
                37.661
              ],
              [
                -76.47,
                37.664
              ],
              [
                -76.47,
                37.671
              ],
              [
                -76.454,
                37.679
              ],
              [
                -76.452,
                37.689
              ],
              [
                -76.462,
                37.704
              ],
              [
                -76.441,
                37.711
              ],
              [
                -76.422,
                37.726
              ],
              [
                -76.433,
                37.736
              ],
              [
                -76.44,
                37.723
              ],
              [
                -76.459,
                37.721
              ],
              [
                -76.464,
                37.708
              ],
              [
                -76.47,
                37.706
              ],
              [
                -76.475,
                37.719
              ],
              [
                -76.484,
                37.718
              ],
              [
                -76.498,
                37.73
              ],
              [
                -76.495,
                37.748
              ],
              [
                -76.509,
                37.749
              ],
              [
                -76.516,
                37.732
              ],
              [
                -76.508,
                37.727
              ],
              [
                -76.504,
                37.718
              ],
              [
                -76.488,
                37.715
              ],
              [
                -76.485,
                37.707
              ],
              [
                -76.488,
                37.695
              ],
              [
                -76.478,
                37.683
              ],
              [
                -76.488,
                37.678
              ],
              [
                -76.491,
                37.664
              ],
              [
                -76.499,
                37.667
              ],
              [
                -76.502,
                37.655
              ],
              [
                -76.492,
                37.649
              ],
              [
                -76.502,
                37.643
              ],
              [
                -76.511,
                37.643
              ],
              [
                -76.538,
                37.668
              ],
              [
                -76.539,
                37.7
              ],
              [
                -76.544,
                37.713
              ],
              [
                -76.55,
                37.712
              ],
              [
                -76.562,
                37.722
              ],
              [
                -76.575,
                37.74
              ],
              [
                -76.579,
                37.761
              ],
              [
                -76.585,
                37.769
              ],
              [
                -76.571,
                37.781
              ],
              [
                -76.576,
                37.785
              ],
              [
                -76.592,
                37.773
              ],
              [
                -76.6,
                37.772
              ],
              [
                -76.614,
                37.778
              ],
              [
                -76.633,
                37.795
              ],
              [
                -76.622,
                37.806
              ],
              [
                -76.585,
                37.813
              ],
              [
                -76.587,
                37.824
              ],
              [
                -76.568,
                37.836
              ],
              [
                -76.519,
                37.836
              ],
              [
                -76.511,
                37.84
              ],
              [
                -76.497,
                37.841
              ],
              [
                -76.479,
                37.838
              ],
              [
                -76.468,
                37.824
              ],
              [
                -76.459,
                37.821
              ],
              [
                -76.444,
                37.823
              ],
              [
                -76.429,
                37.828
              ],
              [
                -76.413,
                37.792
              ],
              [
                -76.401,
                37.782
              ],
              [
                -76.386,
                37.78
              ],
              [
                -76.368,
                37.774
              ],
              [
                -76.364,
                37.757
              ],
              [
                -76.363,
                37.74
              ],
              [
                -76.367,
                37.727
              ],
              [
                -76.377,
                37.715
              ],
              [
                -76.361,
                37.708
              ],
              [
                -76.355,
                37.701
              ]
            ]
          ],
          [
            [
              [
                -76.279,
                37.614
              ],
              [
                -76.296,
                37.616
              ],
              [
                -76.294,
                37.628
              ],
              [
                -76.301,
                37.633
              ],
              [
                -76.294,
                37.641
              ],
              [
                -76.274,
                37.619
              ],
              [
                -76.279,
                37.614
              ]
            ]
          ]
        ]
      },
      "properties": {
        "name": "Lancaster County",
        "id": "51103",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51103"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.073,
              37.968
            ],
            [
              -77.066,
              37.96
            ],
            [
              -77.073,
              37.948
            ],
            [
              -77.061,
              37.943
            ],
            [
              -77.049,
              37.928
            ],
            [
              -77.039,
              37.928
            ],
            [
              -77.026,
              37.906
            ],
            [
              -77.032,
              37.893
            ],
            [
              -77.026,
              37.885
            ],
            [
              -77.03,
              37.879
            ],
            [
              -77.044,
              37.878
            ],
            [
              -77.045,
              37.873
            ],
            [
              -77.025,
              37.864
            ],
            [
              -77.017,
              37.843
            ],
            [
              -76.998,
              37.836
            ],
            [
              -76.985,
              37.841
            ],
            [
              -76.973,
              37.83
            ],
            [
              -76.948,
              37.829
            ],
            [
              -76.946,
              37.784
            ],
            [
              -76.937,
              37.791
            ],
            [
              -76.914,
              37.797
            ],
            [
              -76.902,
              37.795
            ],
            [
              -76.88,
              37.783
            ],
            [
              -76.868,
              37.786
            ],
            [
              -76.843,
              37.799
            ],
            [
              -76.816,
              37.794
            ],
            [
              -76.796,
              37.793
            ],
            [
              -76.794,
              37.776
            ],
            [
              -76.76,
              37.751
            ],
            [
              -76.755,
              37.739
            ],
            [
              -76.751,
              37.729
            ],
            [
              -76.753,
              37.72
            ],
            [
              -76.747,
              37.701
            ],
            [
              -76.732,
              37.689
            ],
            [
              -76.731,
              37.681
            ],
            [
              -76.708,
              37.647
            ],
            [
              -76.7,
              37.642
            ],
            [
              -76.697,
              37.633
            ],
            [
              -76.685,
              37.621
            ],
            [
              -76.654,
              37.601
            ],
            [
              -76.665,
              37.568
            ],
            [
              -76.664,
              37.552
            ],
            [
              -76.671,
              37.533
            ],
            [
              -76.668,
              37.519
            ],
            [
              -76.652,
              37.5
            ],
            [
              -76.646,
              37.486
            ],
            [
              -76.655,
              37.467
            ],
            [
              -76.667,
              37.456
            ],
            [
              -76.675,
              37.462
            ],
            [
              -76.688,
              37.451
            ],
            [
              -76.703,
              37.452
            ],
            [
              -76.704,
              37.443
            ],
            [
              -76.721,
              37.453
            ],
            [
              -76.729,
              37.474
            ],
            [
              -76.742,
              37.489
            ],
            [
              -76.759,
              37.503
            ],
            [
              -76.78,
              37.516
            ],
            [
              -76.781,
              37.528
            ],
            [
              -76.788,
              37.542
            ],
            [
              -76.778,
              37.555
            ],
            [
              -76.785,
              37.569
            ],
            [
              -76.798,
              37.573
            ],
            [
              -76.796,
              37.589
            ],
            [
              -76.8,
              37.592
            ],
            [
              -76.819,
              37.591
            ],
            [
              -76.827,
              37.599
            ],
            [
              -76.828,
              37.607
            ],
            [
              -76.843,
              37.62
            ],
            [
              -76.852,
              37.616
            ],
            [
              -76.866,
              37.619
            ],
            [
              -76.87,
              37.624
            ],
            [
              -76.857,
              37.637
            ],
            [
              -76.884,
              37.659
            ],
            [
              -76.899,
              37.656
            ],
            [
              -76.91,
              37.657
            ],
            [
              -76.913,
              37.664
            ],
            [
              -76.908,
              37.673
            ],
            [
              -76.92,
              37.696
            ],
            [
              -76.929,
              37.693
            ],
            [
              -76.956,
              37.69
            ],
            [
              -76.969,
              37.693
            ],
            [
              -76.976,
              37.708
            ],
            [
              -76.996,
              37.709
            ],
            [
              -77.017,
              37.724
            ],
            [
              -77.036,
              37.724
            ],
            [
              -77.057,
              37.748
            ],
            [
              -77.064,
              37.751
            ],
            [
              -77.086,
              37.751
            ],
            [
              -77.088,
              37.757
            ],
            [
              -77.076,
              37.771
            ],
            [
              -77.082,
              37.779
            ],
            [
              -77.104,
              37.783
            ],
            [
              -77.107,
              37.798
            ],
            [
              -77.096,
              37.8
            ],
            [
              -77.099,
              37.811
            ],
            [
              -77.119,
              37.807
            ],
            [
              -77.122,
              37.822
            ],
            [
              -77.128,
              37.826
            ],
            [
              -77.123,
              37.837
            ],
            [
              -77.132,
              37.842
            ],
            [
              -77.14,
              37.855
            ],
            [
              -77.135,
              37.866
            ],
            [
              -77.15,
              37.866
            ],
            [
              -77.153,
              37.882
            ],
            [
              -77.164,
              37.884
            ],
            [
              -77.163,
              37.891
            ],
            [
              -77.18,
              37.892
            ],
            [
              -77.186,
              37.899
            ],
            [
              -77.188,
              37.91
            ],
            [
              -77.181,
              37.935
            ],
            [
              -77.185,
              37.942
            ],
            [
              -77.182,
              37.951
            ],
            [
              -77.169,
              37.965
            ],
            [
              -77.159,
              37.966
            ],
            [
              -77.151,
              37.972
            ],
            [
              -77.115,
              37.972
            ],
            [
              -77.097,
              37.966
            ],
            [
              -77.073,
              37.968
            ]
          ]
        ]
      },
      "properties": {
        "name": "King And Queen County",
        "id": "51097",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51097"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.18,
              37.892
            ],
            [
              -77.163,
              37.891
            ],
            [
              -77.164,
              37.884
            ],
            [
              -77.153,
              37.882
            ],
            [
              -77.15,
              37.866
            ],
            [
              -77.135,
              37.866
            ],
            [
              -77.14,
              37.855
            ],
            [
              -77.132,
              37.842
            ],
            [
              -77.123,
              37.837
            ],
            [
              -77.128,
              37.826
            ],
            [
              -77.122,
              37.822
            ],
            [
              -77.119,
              37.807
            ],
            [
              -77.099,
              37.811
            ],
            [
              -77.096,
              37.8
            ],
            [
              -77.107,
              37.798
            ],
            [
              -77.104,
              37.783
            ],
            [
              -77.082,
              37.779
            ],
            [
              -77.076,
              37.771
            ],
            [
              -77.088,
              37.757
            ],
            [
              -77.086,
              37.751
            ],
            [
              -77.064,
              37.751
            ],
            [
              -77.057,
              37.748
            ],
            [
              -77.036,
              37.724
            ],
            [
              -77.017,
              37.724
            ],
            [
              -76.996,
              37.709
            ],
            [
              -76.976,
              37.708
            ],
            [
              -76.969,
              37.693
            ],
            [
              -76.956,
              37.69
            ],
            [
              -76.929,
              37.693
            ],
            [
              -76.92,
              37.696
            ],
            [
              -76.908,
              37.673
            ],
            [
              -76.913,
              37.664
            ],
            [
              -76.91,
              37.657
            ],
            [
              -76.899,
              37.656
            ],
            [
              -76.884,
              37.659
            ],
            [
              -76.857,
              37.637
            ],
            [
              -76.87,
              37.624
            ],
            [
              -76.866,
              37.619
            ],
            [
              -76.852,
              37.616
            ],
            [
              -76.843,
              37.62
            ],
            [
              -76.828,
              37.607
            ],
            [
              -76.827,
              37.599
            ],
            [
              -76.819,
              37.591
            ],
            [
              -76.8,
              37.592
            ],
            [
              -76.796,
              37.589
            ],
            [
              -76.798,
              37.573
            ],
            [
              -76.785,
              37.569
            ],
            [
              -76.778,
              37.555
            ],
            [
              -76.788,
              37.542
            ],
            [
              -76.802,
              37.534
            ],
            [
              -76.808,
              37.548
            ],
            [
              -76.821,
              37.556
            ],
            [
              -76.835,
              37.553
            ],
            [
              -76.852,
              37.542
            ],
            [
              -76.858,
              37.531
            ],
            [
              -76.869,
              37.539
            ],
            [
              -76.851,
              37.556
            ],
            [
              -76.852,
              37.576
            ],
            [
              -76.86,
              37.587
            ],
            [
              -76.875,
              37.587
            ],
            [
              -76.887,
              37.581
            ],
            [
              -76.881,
              37.565
            ],
            [
              -76.883,
              37.557
            ],
            [
              -76.893,
              37.557
            ],
            [
              -76.9,
              37.564
            ],
            [
              -76.9,
              37.573
            ],
            [
              -76.91,
              37.576
            ],
            [
              -76.939,
              37.566
            ],
            [
              -76.957,
              37.555
            ],
            [
              -76.955,
              37.571
            ],
            [
              -76.963,
              37.587
            ],
            [
              -76.969,
              37.59
            ],
            [
              -76.991,
              37.586
            ],
            [
              -76.993,
              37.573
            ],
            [
              -77.011,
              37.576
            ],
            [
              -77.005,
              37.593
            ],
            [
              -77.02,
              37.596
            ],
            [
              -77.026,
              37.587
            ],
            [
              -77.039,
              37.587
            ],
            [
              -77.046,
              37.594
            ],
            [
              -77.068,
              37.604
            ],
            [
              -77.079,
              37.596
            ],
            [
              -77.091,
              37.604
            ],
            [
              -77.089,
              37.618
            ],
            [
              -77.097,
              37.617
            ],
            [
              -77.105,
              37.624
            ],
            [
              -77.118,
              37.624
            ],
            [
              -77.13,
              37.631
            ],
            [
              -77.127,
              37.638
            ],
            [
              -77.109,
              37.654
            ],
            [
              -77.112,
              37.664
            ],
            [
              -77.122,
              37.662
            ],
            [
              -77.145,
              37.669
            ],
            [
              -77.164,
              37.669
            ],
            [
              -77.168,
              37.661
            ],
            [
              -77.181,
              37.657
            ],
            [
              -77.192,
              37.666
            ],
            [
              -77.184,
              37.674
            ],
            [
              -77.184,
              37.684
            ],
            [
              -77.19,
              37.691
            ],
            [
              -77.201,
              37.689
            ],
            [
              -77.203,
              37.68
            ],
            [
              -77.216,
              37.69
            ],
            [
              -77.226,
              37.69
            ],
            [
              -77.238,
              37.685
            ],
            [
              -77.243,
              37.698
            ],
            [
              -77.232,
              37.712
            ],
            [
              -77.236,
              37.725
            ],
            [
              -77.246,
              37.729
            ],
            [
              -77.254,
              37.725
            ],
            [
              -77.245,
              37.713
            ],
            [
              -77.255,
              37.709
            ],
            [
              -77.266,
              37.723
            ],
            [
              -77.282,
              37.713
            ],
            [
              -77.291,
              37.713
            ],
            [
              -77.299,
              37.727
            ],
            [
              -77.297,
              37.739
            ],
            [
              -77.323,
              37.734
            ],
            [
              -77.321,
              37.744
            ],
            [
              -77.307,
              37.744
            ],
            [
              -77.309,
              37.754
            ],
            [
              -77.334,
              37.754
            ],
            [
              -77.329,
              37.776
            ],
            [
              -77.334,
              37.791
            ],
            [
              -77.349,
              37.788
            ],
            [
              -77.343,
              37.8
            ],
            [
              -77.329,
              37.81
            ],
            [
              -77.298,
              37.827
            ],
            [
              -77.285,
              37.848
            ],
            [
              -77.275,
              37.856
            ],
            [
              -77.271,
              37.865
            ],
            [
              -77.254,
              37.874
            ],
            [
              -77.249,
              37.88
            ],
            [
              -77.245,
              37.906
            ],
            [
              -77.219,
              37.905
            ],
            [
              -77.212,
              37.899
            ],
            [
              -77.216,
              37.891
            ],
            [
              -77.18,
              37.892
            ]
          ]
        ]
      },
      "properties": {
        "name": "King William County",
        "id": "51101",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51101"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.993,
              38.277
            ],
            [
              -77.007,
              38.276
            ],
            [
              -77.016,
              38.27
            ],
            [
              -77.026,
              38.27
            ],
            [
              -77.034,
              38.259
            ],
            [
              -77.053,
              38.26
            ],
            [
              -77.056,
              38.205
            ],
            [
              -77.054,
              38.179
            ],
            [
              -77.067,
              38.165
            ],
            [
              -77.077,
              38.156
            ],
            [
              -77.084,
              38.169
            ],
            [
              -77.094,
              38.172
            ],
            [
              -77.106,
              38.16
            ],
            [
              -77.119,
              38.158
            ],
            [
              -77.119,
              38.171
            ],
            [
              -77.132,
              38.17
            ],
            [
              -77.146,
              38.175
            ],
            [
              -77.163,
              38.173
            ],
            [
              -77.177,
              38.174
            ],
            [
              -77.194,
              38.185
            ],
            [
              -77.203,
              38.187
            ],
            [
              -77.216,
              38.198
            ],
            [
              -77.228,
              38.2
            ],
            [
              -77.229,
              38.189
            ],
            [
              -77.239,
              38.186
            ],
            [
              -77.25,
              38.188
            ],
            [
              -77.254,
              38.195
            ],
            [
              -77.242,
              38.211
            ],
            [
              -77.252,
              38.23
            ],
            [
              -77.228,
              38.236
            ],
            [
              -77.225,
              38.243
            ],
            [
              -77.244,
              38.245
            ],
            [
              -77.252,
              38.251
            ],
            [
              -77.27,
              38.25
            ],
            [
              -77.277,
              38.244
            ],
            [
              -77.278,
              38.225
            ],
            [
              -77.294,
              38.226
            ],
            [
              -77.291,
              38.237
            ],
            [
              -77.296,
              38.243
            ],
            [
              -77.308,
              38.235
            ],
            [
              -77.328,
              38.245
            ],
            [
              -77.329,
              38.253
            ],
            [
              -77.346,
              38.262
            ],
            [
              -77.347,
              38.279
            ],
            [
              -77.341,
              38.287
            ],
            [
              -77.351,
              38.303
            ],
            [
              -77.327,
              38.321
            ],
            [
              -77.328,
              38.336
            ],
            [
              -77.323,
              38.34
            ],
            [
              -77.306,
              38.343
            ],
            [
              -77.279,
              38.341
            ],
            [
              -77.264,
              38.333
            ],
            [
              -77.252,
              38.332
            ],
            [
              -77.228,
              38.335
            ],
            [
              -77.2,
              38.343
            ],
            [
              -77.174,
              38.344
            ],
            [
              -77.163,
              38.349
            ],
            [
              -77.145,
              38.366
            ],
            [
              -77.135,
              38.369
            ],
            [
              -77.093,
              38.37
            ],
            [
              -77.073,
              38.378
            ],
            [
              -77.062,
              38.394
            ],
            [
              -77.048,
              38.402
            ],
            [
              -77.038,
              38.4
            ],
            [
              -77.015,
              38.38
            ],
            [
              -77.015,
              38.332
            ],
            [
              -77.022,
              38.325
            ],
            [
              -77.038,
              38.32
            ],
            [
              -77.054,
              38.326
            ],
            [
              -77.065,
              38.322
            ],
            [
              -77.047,
              38.311
            ],
            [
              -77.034,
              38.311
            ],
            [
              -77.011,
              38.294
            ],
            [
              -76.998,
              38.28
            ],
            [
              -76.993,
              38.277
            ]
          ]
        ]
      },
      "properties": {
        "name": "King George County",
        "id": "51099",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51099"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.673,
              37.37
            ],
            [
              -76.688,
              37.37
            ],
            [
              -76.715,
              37.366
            ],
            [
              -76.73,
              37.372
            ],
            [
              -76.742,
              37.371
            ],
            [
              -76.755,
              37.354
            ],
            [
              -76.754,
              37.339
            ],
            [
              -76.736,
              37.332
            ],
            [
              -76.736,
              37.324
            ],
            [
              -76.729,
              37.312
            ],
            [
              -76.741,
              37.307
            ],
            [
              -76.727,
              37.28
            ],
            [
              -76.738,
              37.28
            ],
            [
              -76.741,
              37.266
            ],
            [
              -76.728,
              37.25
            ],
            [
              -76.706,
              37.248
            ],
            [
              -76.673,
              37.247
            ],
            [
              -76.666,
              37.251
            ],
            [
              -76.68,
              37.266
            ],
            [
              -76.665,
              37.264
            ],
            [
              -76.658,
              37.245
            ],
            [
              -76.651,
              37.239
            ],
            [
              -76.625,
              37.234
            ],
            [
              -76.601,
              37.238
            ],
            [
              -76.596,
              37.232
            ],
            [
              -76.593,
              37.215
            ],
            [
              -76.592,
              37.21
            ],
            [
              -76.578,
              37.19
            ],
            [
              -76.582,
              37.183
            ],
            [
              -76.599,
              37.178
            ],
            [
              -76.606,
              37.169
            ],
            [
              -76.612,
              37.171
            ],
            [
              -76.621,
              37.195
            ],
            [
              -76.635,
              37.213
            ],
            [
              -76.65,
              37.221
            ],
            [
              -76.69,
              37.224
            ],
            [
              -76.699,
              37.228
            ],
            [
              -76.703,
              37.216
            ],
            [
              -76.738,
              37.215
            ],
            [
              -76.747,
              37.21
            ],
            [
              -76.736,
              37.203
            ],
            [
              -76.746,
              37.192
            ],
            [
              -76.76,
              37.194
            ],
            [
              -76.775,
              37.208
            ],
            [
              -76.796,
              37.236
            ],
            [
              -76.812,
              37.242
            ],
            [
              -76.827,
              37.244
            ],
            [
              -76.867,
              37.243
            ],
            [
              -76.865,
              37.255
            ],
            [
              -76.872,
              37.277
            ],
            [
              -76.87,
              37.287
            ],
            [
              -76.861,
              37.287
            ],
            [
              -76.853,
              37.295
            ],
            [
              -76.865,
              37.3
            ],
            [
              -76.864,
              37.311
            ],
            [
              -76.876,
              37.326
            ],
            [
              -76.874,
              37.344
            ],
            [
              -76.88,
              37.353
            ],
            [
              -76.872,
              37.363
            ],
            [
              -76.875,
              37.369
            ],
            [
              -76.886,
              37.37
            ],
            [
              -76.9,
              37.361
            ],
            [
              -76.909,
              37.351
            ],
            [
              -76.916,
              37.354
            ],
            [
              -76.904,
              37.378
            ],
            [
              -76.9,
              37.385
            ],
            [
              -76.89,
              37.389
            ],
            [
              -76.898,
              37.397
            ],
            [
              -76.893,
              37.404
            ],
            [
              -76.891,
              37.421
            ],
            [
              -76.894,
              37.429
            ],
            [
              -76.879,
              37.442
            ],
            [
              -76.865,
              37.445
            ],
            [
              -76.861,
              37.451
            ],
            [
              -76.819,
              37.452
            ],
            [
              -76.792,
              37.44
            ],
            [
              -76.77,
              37.437
            ],
            [
              -76.76,
              37.448
            ],
            [
              -76.763,
              37.455
            ],
            [
              -76.755,
              37.462
            ],
            [
              -76.744,
              37.443
            ],
            [
              -76.709,
              37.416
            ],
            [
              -76.695,
              37.402
            ],
            [
              -76.673,
              37.37
            ]
          ]
        ]
      },
      "properties": {
        "name": "James City County",
        "id": "51095",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51095"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.516,
              36.912
            ],
            [
              -76.526,
              36.91
            ],
            [
              -76.53,
              36.919
            ],
            [
              -76.541,
              36.912
            ],
            [
              -76.557,
              36.898
            ],
            [
              -76.61,
              36.859
            ],
            [
              -76.75,
              36.75
            ],
            [
              -76.783,
              36.726
            ],
            [
              -76.815,
              36.705
            ],
            [
              -76.841,
              36.685
            ],
            [
              -76.873,
              36.662
            ],
            [
              -76.902,
              36.644
            ],
            [
              -76.91,
              36.648
            ],
            [
              -76.919,
              36.663
            ],
            [
              -76.915,
              36.671
            ],
            [
              -76.922,
              36.679
            ],
            [
              -76.918,
              36.701
            ],
            [
              -76.93,
              36.707
            ],
            [
              -76.928,
              36.715
            ],
            [
              -76.916,
              36.724
            ],
            [
              -76.917,
              36.733
            ],
            [
              -76.899,
              36.746
            ],
            [
              -76.901,
              36.759
            ],
            [
              -76.892,
              36.763
            ],
            [
              -76.892,
              36.777
            ],
            [
              -76.872,
              36.787
            ],
            [
              -76.866,
              36.799
            ],
            [
              -76.871,
              36.807
            ],
            [
              -76.861,
              36.825
            ],
            [
              -76.864,
              36.834
            ],
            [
              -76.854,
              36.845
            ],
            [
              -76.853,
              36.852
            ],
            [
              -76.844,
              36.858
            ],
            [
              -76.84,
              36.867
            ],
            [
              -76.825,
              36.881
            ],
            [
              -76.829,
              36.889
            ],
            [
              -76.818,
              36.902
            ],
            [
              -76.825,
              36.919
            ],
            [
              -76.836,
              36.919
            ],
            [
              -76.848,
              36.941
            ],
            [
              -76.86,
              36.954
            ],
            [
              -76.849,
              36.998
            ],
            [
              -76.772,
              37.031
            ],
            [
              -76.724,
              37.05
            ],
            [
              -76.701,
              37.057
            ],
            [
              -76.702,
              37.065
            ],
            [
              -76.693,
              37.083
            ],
            [
              -76.686,
              37.088
            ],
            [
              -76.682,
              37.105
            ],
            [
              -76.676,
              37.109
            ],
            [
              -76.68,
              37.121
            ],
            [
              -76.673,
              37.142
            ],
            [
              -76.665,
              37.133
            ],
            [
              -76.659,
              37.112
            ],
            [
              -76.659,
              37.095
            ],
            [
              -76.67,
              37.068
            ],
            [
              -76.665,
              37.047
            ],
            [
              -76.638,
              37.035
            ],
            [
              -76.616,
              37.036
            ],
            [
              -76.598,
              37.033
            ],
            [
              -76.584,
              37.027
            ],
            [
              -76.58,
              37.02
            ],
            [
              -76.584,
              37.007
            ],
            [
              -76.591,
              37.004
            ],
            [
              -76.612,
              37.006
            ],
            [
              -76.621,
              36.994
            ],
            [
              -76.602,
              36.998
            ],
            [
              -76.586,
              36.997
            ],
            [
              -76.569,
              37.004
            ],
            [
              -76.559,
              37.003
            ],
            [
              -76.548,
              36.991
            ],
            [
              -76.527,
              36.981
            ],
            [
              -76.528,
              36.976
            ],
            [
              -76.513,
              36.969
            ],
            [
              -76.495,
              36.965
            ],
            [
              -76.491,
              36.96
            ],
            [
              -76.485,
              36.939
            ],
            [
              -76.49,
              36.936
            ],
            [
              -76.497,
              36.949
            ],
            [
              -76.504,
              36.943
            ],
            [
              -76.501,
              36.927
            ],
            [
              -76.516,
              36.912
            ]
          ]
        ]
      },
      "properties": {
        "name": "Isle Of Wight County",
        "id": "51093",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51093"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.254,
              37.291
            ],
            [
              -77.285,
              37.274
            ],
            [
              -77.311,
              37.266
            ],
            [
              -77.322,
              37.265
            ],
            [
              -77.331,
              37.257
            ],
            [
              -77.329,
              37.289
            ],
            [
              -77.337,
              37.314
            ],
            [
              -77.322,
              37.308
            ],
            [
              -77.291,
              37.311
            ],
            [
              -77.274,
              37.318
            ],
            [
              -77.269,
              37.306
            ],
            [
              -77.259,
              37.3
            ],
            [
              -77.254,
              37.291
            ]
          ]
        ]
      },
      "properties": {
        "name": "Hopewell City",
        "id": "51670",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51670"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.511,
              38.18
            ],
            [
              -79.56,
              38.199
            ],
            [
              -79.705,
              38.221
            ],
            [
              -79.762,
              38.253
            ],
            [
              -79.788,
              38.269
            ],
            [
              -79.789,
              38.281
            ],
            [
              -79.795,
              38.29
            ],
            [
              -79.808,
              38.304
            ],
            [
              -79.807,
              38.311
            ],
            [
              -79.792,
              38.324
            ],
            [
              -79.774,
              38.337
            ],
            [
              -79.766,
              38.35
            ],
            [
              -79.755,
              38.356
            ],
            [
              -79.742,
              38.354
            ],
            [
              -79.731,
              38.358
            ],
            [
              -79.728,
              38.367
            ],
            [
              -79.732,
              38.373
            ],
            [
              -79.727,
              38.386
            ],
            [
              -79.719,
              38.399
            ],
            [
              -79.691,
              38.432
            ],
            [
              -79.688,
              38.457
            ],
            [
              -79.697,
              38.47
            ],
            [
              -79.696,
              38.488
            ],
            [
              -79.692,
              38.496
            ],
            [
              -79.679,
              38.51
            ],
            [
              -79.663,
              38.516
            ],
            [
              -79.67,
              38.529
            ],
            [
              -79.667,
              38.536
            ],
            [
              -79.668,
              38.553
            ],
            [
              -79.66,
              38.565
            ],
            [
              -79.662,
              38.569
            ],
            [
              -79.65,
              38.588
            ],
            [
              -79.641,
              38.592
            ],
            [
              -79.589,
              38.57
            ],
            [
              -79.544,
              38.557
            ],
            [
              -79.536,
              38.552
            ],
            [
              -79.523,
              38.536
            ],
            [
              -79.494,
              38.495
            ],
            [
              -79.475,
              38.457
            ],
            [
              -79.33,
              38.418
            ],
            [
              -79.308,
              38.413
            ],
            [
              -79.317,
              38.406
            ],
            [
              -79.305,
              38.391
            ],
            [
              -79.311,
              38.383
            ],
            [
              -79.321,
              38.38
            ],
            [
              -79.335,
              38.37
            ],
            [
              -79.338,
              38.358
            ],
            [
              -79.348,
              38.355
            ],
            [
              -79.36,
              38.342
            ],
            [
              -79.382,
              38.308
            ],
            [
              -79.383,
              38.296
            ],
            [
              -79.393,
              38.292
            ],
            [
              -79.403,
              38.274
            ],
            [
              -79.398,
              38.26
            ],
            [
              -79.404,
              38.248
            ],
            [
              -79.419,
              38.234
            ],
            [
              -79.427,
              38.231
            ],
            [
              -79.438,
              38.217
            ],
            [
              -79.464,
              38.223
            ],
            [
              -79.475,
              38.218
            ],
            [
              -79.478,
              38.208
            ],
            [
              -79.511,
              38.18
            ]
          ]
        ]
      },
      "properties": {
        "name": "Highland County",
        "id": "51091",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51091"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.715,
              36.541
            ],
            [
              -79.815,
              36.542
            ],
            [
              -80.054,
              36.543
            ],
            [
              -80.05,
              36.607
            ],
            [
              -80.058,
              36.637
            ],
            [
              -80.058,
              36.658
            ],
            [
              -80.067,
              36.667
            ],
            [
              -80.078,
              36.686
            ],
            [
              -80.086,
              36.704
            ],
            [
              -80.093,
              36.715
            ],
            [
              -80.096,
              36.728
            ],
            [
              -80.093,
              36.746
            ],
            [
              -80.086,
              36.762
            ],
            [
              -80.093,
              36.776
            ],
            [
              -80.08,
              36.791
            ],
            [
              -80.062,
              36.794
            ],
            [
              -80.041,
              36.794
            ],
            [
              -80.029,
              36.781
            ],
            [
              -80.012,
              36.789
            ],
            [
              -80,
              36.831
            ],
            [
              -79.8,
              36.793
            ],
            [
              -79.789,
              36.8
            ],
            [
              -79.771,
              36.795
            ],
            [
              -79.749,
              36.793
            ],
            [
              -79.739,
              36.811
            ],
            [
              -79.689,
              36.828
            ],
            [
              -79.668,
              36.827
            ],
            [
              -79.641,
              36.856
            ],
            [
              -79.665,
              36.744
            ],
            [
              -79.704,
              36.596
            ],
            [
              -79.715,
              36.541
            ]
          ],
          [
            [
              -79.83,
              36.65
            ],
            [
              -79.831,
              36.661
            ],
            [
              -79.843,
              36.672
            ],
            [
              -79.836,
              36.708
            ],
            [
              -79.88,
              36.714
            ],
            [
              -79.905,
              36.683
            ],
            [
              -79.894,
              36.674
            ],
            [
              -79.858,
              36.664
            ],
            [
              -79.86,
              36.651
            ],
            [
              -79.844,
              36.646
            ],
            [
              -79.83,
              36.65
            ]
          ]
        ]
      },
      "properties": {
        "name": "Henry County",
        "id": "51089",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51089"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.243,
              37.539
            ],
            [
              -77.226,
              37.536
            ],
            [
              -77.218,
              37.531
            ],
            [
              -77.204,
              37.513
            ],
            [
              -77.193,
              37.509
            ],
            [
              -77.189,
              37.499
            ],
            [
              -77.179,
              37.493
            ],
            [
              -77.228,
              37.407
            ],
            [
              -77.217,
              37.389
            ],
            [
              -77.224,
              37.383
            ],
            [
              -77.234,
              37.383
            ],
            [
              -77.244,
              37.394
            ],
            [
              -77.251,
              37.381
            ],
            [
              -77.266,
              37.381
            ],
            [
              -77.271,
              37.375
            ],
            [
              -77.269,
              37.36
            ],
            [
              -77.283,
              37.353
            ],
            [
              -77.302,
              37.358
            ],
            [
              -77.307,
              37.363
            ],
            [
              -77.308,
              37.374
            ],
            [
              -77.297,
              37.392
            ],
            [
              -77.3,
              37.406
            ],
            [
              -77.308,
              37.406
            ],
            [
              -77.318,
              37.383
            ],
            [
              -77.324,
              37.379
            ],
            [
              -77.349,
              37.38
            ],
            [
              -77.362,
              37.389
            ],
            [
              -77.371,
              37.392
            ],
            [
              -77.378,
              37.383
            ],
            [
              -77.385,
              37.388
            ],
            [
              -77.383,
              37.397
            ],
            [
              -77.394,
              37.405
            ],
            [
              -77.397,
              37.418
            ],
            [
              -77.402,
              37.425
            ],
            [
              -77.419,
              37.423
            ],
            [
              -77.428,
              37.435
            ],
            [
              -77.42,
              37.448
            ],
            [
              -77.418,
              37.457
            ],
            [
              -77.422,
              37.472
            ],
            [
              -77.422,
              37.496
            ],
            [
              -77.417,
              37.514
            ],
            [
              -77.394,
              37.506
            ],
            [
              -77.386,
              37.535
            ],
            [
              -77.395,
              37.55
            ],
            [
              -77.408,
              37.558
            ],
            [
              -77.414,
              37.58
            ],
            [
              -77.431,
              37.581
            ],
            [
              -77.439,
              37.586
            ],
            [
              -77.438,
              37.599
            ],
            [
              -77.448,
              37.603
            ],
            [
              -77.478,
              37.599
            ],
            [
              -77.479,
              37.588
            ],
            [
              -77.473,
              37.579
            ],
            [
              -77.482,
              37.573
            ],
            [
              -77.494,
              37.582
            ],
            [
              -77.5,
              37.575
            ],
            [
              -77.533,
              37.593
            ],
            [
              -77.547,
              37.572
            ],
            [
              -77.527,
              37.568
            ],
            [
              -77.53,
              37.56
            ],
            [
              -77.545,
              37.561
            ],
            [
              -77.56,
              37.555
            ],
            [
              -77.579,
              37.559
            ],
            [
              -77.595,
              37.556
            ],
            [
              -77.628,
              37.559
            ],
            [
              -77.656,
              37.566
            ],
            [
              -77.639,
              37.566
            ],
            [
              -77.634,
              37.577
            ],
            [
              -77.617,
              37.58
            ],
            [
              -77.618,
              37.589
            ],
            [
              -77.629,
              37.598
            ],
            [
              -77.639,
              37.602
            ],
            [
              -77.653,
              37.619
            ],
            [
              -77.656,
              37.639
            ],
            [
              -77.651,
              37.649
            ],
            [
              -77.64,
              37.685
            ],
            [
              -77.632,
              37.706
            ],
            [
              -77.61,
              37.709
            ],
            [
              -77.6,
              37.705
            ],
            [
              -77.594,
              37.695
            ],
            [
              -77.565,
              37.682
            ],
            [
              -77.539,
              37.687
            ],
            [
              -77.534,
              37.694
            ],
            [
              -77.524,
              37.699
            ],
            [
              -77.5,
              37.701
            ],
            [
              -77.485,
              37.685
            ],
            [
              -77.468,
              37.686
            ],
            [
              -77.464,
              37.68
            ],
            [
              -77.447,
              37.685
            ],
            [
              -77.442,
              37.673
            ],
            [
              -77.433,
              37.662
            ],
            [
              -77.434,
              37.656
            ],
            [
              -77.425,
              37.649
            ],
            [
              -77.407,
              37.609
            ],
            [
              -77.392,
              37.6
            ],
            [
              -77.371,
              37.594
            ],
            [
              -77.354,
              37.582
            ],
            [
              -77.332,
              37.577
            ],
            [
              -77.303,
              37.559
            ],
            [
              -77.294,
              37.56
            ],
            [
              -77.262,
              37.551
            ],
            [
              -77.243,
              37.539
            ]
          ]
        ]
      },
      "properties": {
        "name": "Henrico County",
        "id": "51087",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51087"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.876,
              38.486
            ],
            [
              -78.857,
              38.475
            ],
            [
              -78.846,
              38.461
            ],
            [
              -78.834,
              38.455
            ],
            [
              -78.833,
              38.444
            ],
            [
              -78.824,
              38.44
            ],
            [
              -78.829,
              38.42
            ],
            [
              -78.851,
              38.413
            ],
            [
              -78.882,
              38.412
            ],
            [
              -78.889,
              38.393
            ],
            [
              -78.914,
              38.39
            ],
            [
              -78.918,
              38.396
            ],
            [
              -78.904,
              38.414
            ],
            [
              -78.908,
              38.435
            ],
            [
              -78.917,
              38.437
            ],
            [
              -78.901,
              38.459
            ],
            [
              -78.891,
              38.457
            ],
            [
              -78.876,
              38.486
            ]
          ]
        ]
      },
      "properties": {
        "name": "Harrisonburg City",
        "id": "51660",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51660"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.643,
              37.992
            ],
            [
              -77.643,
              37.981
            ],
            [
              -77.619,
              37.965
            ],
            [
              -77.615,
              37.958
            ],
            [
              -77.592,
              37.95
            ],
            [
              -77.58,
              37.956
            ],
            [
              -77.569,
              37.955
            ],
            [
              -77.562,
              37.937
            ],
            [
              -77.548,
              37.929
            ],
            [
              -77.558,
              37.924
            ],
            [
              -77.544,
              37.917
            ],
            [
              -77.53,
              37.921
            ],
            [
              -77.523,
              37.911
            ],
            [
              -77.495,
              37.898
            ],
            [
              -77.494,
              37.891
            ],
            [
              -77.481,
              37.884
            ],
            [
              -77.472,
              37.889
            ],
            [
              -77.446,
              37.894
            ],
            [
              -77.429,
              37.871
            ],
            [
              -77.418,
              37.863
            ],
            [
              -77.429,
              37.854
            ],
            [
              -77.425,
              37.828
            ],
            [
              -77.413,
              37.824
            ],
            [
              -77.41,
              37.819
            ],
            [
              -77.421,
              37.809
            ],
            [
              -77.408,
              37.804
            ],
            [
              -77.396,
              37.803
            ],
            [
              -77.403,
              37.78
            ],
            [
              -77.381,
              37.775
            ],
            [
              -77.364,
              37.795
            ],
            [
              -77.349,
              37.788
            ],
            [
              -77.334,
              37.791
            ],
            [
              -77.329,
              37.776
            ],
            [
              -77.334,
              37.754
            ],
            [
              -77.309,
              37.754
            ],
            [
              -77.307,
              37.744
            ],
            [
              -77.321,
              37.744
            ],
            [
              -77.323,
              37.734
            ],
            [
              -77.297,
              37.739
            ],
            [
              -77.299,
              37.727
            ],
            [
              -77.291,
              37.713
            ],
            [
              -77.282,
              37.713
            ],
            [
              -77.266,
              37.723
            ],
            [
              -77.255,
              37.709
            ],
            [
              -77.245,
              37.713
            ],
            [
              -77.254,
              37.725
            ],
            [
              -77.246,
              37.729
            ],
            [
              -77.236,
              37.725
            ],
            [
              -77.232,
              37.712
            ],
            [
              -77.243,
              37.698
            ],
            [
              -77.238,
              37.685
            ],
            [
              -77.226,
              37.69
            ],
            [
              -77.216,
              37.69
            ],
            [
              -77.203,
              37.68
            ],
            [
              -77.201,
              37.689
            ],
            [
              -77.19,
              37.691
            ],
            [
              -77.184,
              37.684
            ],
            [
              -77.184,
              37.674
            ],
            [
              -77.192,
              37.666
            ],
            [
              -77.181,
              37.657
            ],
            [
              -77.168,
              37.661
            ],
            [
              -77.164,
              37.669
            ],
            [
              -77.145,
              37.669
            ],
            [
              -77.122,
              37.662
            ],
            [
              -77.112,
              37.664
            ],
            [
              -77.109,
              37.654
            ],
            [
              -77.127,
              37.638
            ],
            [
              -77.13,
              37.631
            ],
            [
              -77.138,
              37.619
            ],
            [
              -77.133,
              37.613
            ],
            [
              -77.14,
              37.595
            ],
            [
              -77.145,
              37.592
            ],
            [
              -77.173,
              37.596
            ],
            [
              -77.208,
              37.569
            ],
            [
              -77.218,
              37.555
            ],
            [
              -77.237,
              37.547
            ],
            [
              -77.243,
              37.539
            ],
            [
              -77.262,
              37.551
            ],
            [
              -77.294,
              37.56
            ],
            [
              -77.303,
              37.559
            ],
            [
              -77.332,
              37.577
            ],
            [
              -77.354,
              37.582
            ],
            [
              -77.371,
              37.594
            ],
            [
              -77.392,
              37.6
            ],
            [
              -77.407,
              37.609
            ],
            [
              -77.425,
              37.649
            ],
            [
              -77.434,
              37.656
            ],
            [
              -77.433,
              37.662
            ],
            [
              -77.442,
              37.673
            ],
            [
              -77.447,
              37.685
            ],
            [
              -77.464,
              37.68
            ],
            [
              -77.468,
              37.686
            ],
            [
              -77.485,
              37.685
            ],
            [
              -77.5,
              37.701
            ],
            [
              -77.524,
              37.699
            ],
            [
              -77.534,
              37.694
            ],
            [
              -77.539,
              37.687
            ],
            [
              -77.565,
              37.682
            ],
            [
              -77.594,
              37.695
            ],
            [
              -77.6,
              37.705
            ],
            [
              -77.61,
              37.709
            ],
            [
              -77.632,
              37.706
            ],
            [
              -77.649,
              37.713
            ],
            [
              -77.664,
              37.704
            ],
            [
              -77.692,
              37.705
            ],
            [
              -77.791,
              37.727
            ],
            [
              -77.8,
              37.733
            ],
            [
              -77.688,
              38.008
            ],
            [
              -77.672,
              38.004
            ],
            [
              -77.658,
              37.992
            ],
            [
              -77.643,
              37.992
            ]
          ]
        ]
      },
      "properties": {
        "name": "Hanover County",
        "id": "51085",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51085"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.387,
              36.994
            ],
            [
              -76.397,
              37.001
            ],
            [
              -76.409,
              36.994
            ],
            [
              -76.43,
              37.026
            ],
            [
              -76.44,
              37.023
            ],
            [
              -76.449,
              37.038
            ],
            [
              -76.45,
              37.057
            ],
            [
              -76.447,
              37.068
            ],
            [
              -76.451,
              37.077
            ],
            [
              -76.433,
              37.095
            ],
            [
              -76.402,
              37.095
            ],
            [
              -76.395,
              37.11
            ],
            [
              -76.378,
              37.112
            ],
            [
              -76.349,
              37.093
            ],
            [
              -76.338,
              37.09
            ],
            [
              -76.344,
              37.079
            ],
            [
              -76.358,
              37.072
            ],
            [
              -76.362,
              37.059
            ],
            [
              -76.353,
              37.052
            ],
            [
              -76.348,
              37.062
            ],
            [
              -76.336,
              37.069
            ],
            [
              -76.335,
              37.083
            ],
            [
              -76.328,
              37.083
            ],
            [
              -76.324,
              37.096
            ],
            [
              -76.306,
              37.093
            ],
            [
              -76.277,
              37.104
            ],
            [
              -76.269,
              37.092
            ],
            [
              -76.27,
              37.084
            ],
            [
              -76.29,
              37.035
            ],
            [
              -76.296,
              37.013
            ],
            [
              -76.304,
              37.002
            ],
            [
              -76.318,
              37.002
            ],
            [
              -76.302,
              37.017
            ],
            [
              -76.307,
              37.028
            ],
            [
              -76.32,
              37.015
            ],
            [
              -76.327,
              37.012
            ],
            [
              -76.341,
              37.017
            ],
            [
              -76.35,
              37.005
            ],
            [
              -76.38,
              36.998
            ],
            [
              -76.387,
              36.994
            ]
          ]
        ]
      },
      "properties": {
        "name": "Hampton City",
        "id": "51650",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51650"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.904,
              37.022
            ],
            [
              -78.909,
              37.012
            ],
            [
              -78.892,
              37.004
            ],
            [
              -78.901,
              36.985
            ],
            [
              -78.89,
              36.977
            ],
            [
              -78.87,
              36.986
            ],
            [
              -78.815,
              36.984
            ],
            [
              -78.799,
              36.969
            ],
            [
              -78.795,
              36.958
            ],
            [
              -78.782,
              36.955
            ],
            [
              -78.776,
              36.96
            ],
            [
              -78.776,
              36.984
            ],
            [
              -78.769,
              36.989
            ],
            [
              -78.757,
              36.987
            ],
            [
              -78.751,
              36.994
            ],
            [
              -78.763,
              37.002
            ],
            [
              -78.758,
              37.006
            ],
            [
              -78.746,
              37.005
            ],
            [
              -78.74,
              36.98
            ],
            [
              -78.741,
              36.958
            ],
            [
              -78.731,
              36.943
            ],
            [
              -78.735,
              36.934
            ],
            [
              -78.751,
              36.93
            ],
            [
              -78.753,
              36.921
            ],
            [
              -78.733,
              36.912
            ],
            [
              -78.695,
              36.878
            ],
            [
              -78.689,
              36.865
            ],
            [
              -78.674,
              36.86
            ],
            [
              -78.668,
              36.851
            ],
            [
              -78.667,
              36.841
            ],
            [
              -78.688,
              36.832
            ],
            [
              -78.684,
              36.823
            ],
            [
              -78.67,
              36.815
            ],
            [
              -78.684,
              36.792
            ],
            [
              -78.671,
              36.772
            ],
            [
              -78.671,
              36.762
            ],
            [
              -78.683,
              36.757
            ],
            [
              -78.693,
              36.742
            ],
            [
              -78.661,
              36.708
            ],
            [
              -78.646,
              36.7
            ],
            [
              -78.625,
              36.676
            ],
            [
              -78.612,
              36.666
            ],
            [
              -78.554,
              36.64
            ],
            [
              -78.542,
              36.63
            ],
            [
              -78.545,
              36.626
            ],
            [
              -78.563,
              36.638
            ],
            [
              -78.574,
              36.641
            ],
            [
              -78.616,
              36.662
            ],
            [
              -78.644,
              36.688
            ],
            [
              -78.657,
              36.693
            ],
            [
              -78.67,
              36.693
            ],
            [
              -78.7,
              36.68
            ],
            [
              -78.699,
              36.664
            ],
            [
              -78.707,
              36.653
            ],
            [
              -78.712,
              36.631
            ],
            [
              -78.711,
              36.617
            ],
            [
              -78.717,
              36.602
            ],
            [
              -78.715,
              36.594
            ],
            [
              -78.719,
              36.579
            ],
            [
              -78.732,
              36.57
            ],
            [
              -78.737,
              36.554
            ],
            [
              -78.73,
              36.544
            ],
            [
              -78.976,
              36.545
            ],
            [
              -79.219,
              36.542
            ],
            [
              -79.092,
              37.061
            ],
            [
              -79.055,
              37.045
            ],
            [
              -79.039,
              37.045
            ],
            [
              -79.015,
              37.039
            ],
            [
              -79.003,
              37.03
            ],
            [
              -78.974,
              37.05
            ],
            [
              -78.969,
              37.046
            ],
            [
              -78.935,
              37.035
            ],
            [
              -78.922,
              37.026
            ],
            [
              -78.904,
              37.022
            ]
          ]
        ]
      },
      "properties": {
        "name": "Halifax County",
        "id": "51083",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51083"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.62,
              36.878
            ],
            [
              -77.608,
              36.877
            ],
            [
              -77.593,
              36.869
            ],
            [
              -77.581,
              36.854
            ],
            [
              -77.558,
              36.847
            ],
            [
              -77.55,
              36.852
            ],
            [
              -77.528,
              36.852
            ],
            [
              -77.503,
              36.845
            ],
            [
              -77.488,
              36.856
            ],
            [
              -77.474,
              36.861
            ],
            [
              -77.46,
              36.862
            ],
            [
              -77.469,
              36.815
            ],
            [
              -77.492,
              36.721
            ],
            [
              -77.479,
              36.723
            ],
            [
              -77.468,
              36.717
            ],
            [
              -77.444,
              36.713
            ],
            [
              -77.432,
              36.708
            ],
            [
              -77.503,
              36.672
            ],
            [
              -77.48,
              36.669
            ],
            [
              -77.477,
              36.662
            ],
            [
              -77.461,
              36.653
            ],
            [
              -77.449,
              36.652
            ],
            [
              -77.438,
              36.656
            ],
            [
              -77.416,
              36.654
            ],
            [
              -77.389,
              36.642
            ],
            [
              -77.378,
              36.633
            ],
            [
              -77.371,
              36.616
            ],
            [
              -77.372,
              36.61
            ],
            [
              -77.362,
              36.601
            ],
            [
              -77.359,
              36.584
            ],
            [
              -77.362,
              36.572
            ],
            [
              -77.351,
              36.554
            ],
            [
              -77.34,
              36.552
            ],
            [
              -77.333,
              36.56
            ],
            [
              -77.305,
              36.546
            ],
            [
              -77.485,
              36.546
            ],
            [
              -77.767,
              36.546
            ],
            [
              -77.665,
              36.7
            ],
            [
              -77.658,
              36.713
            ],
            [
              -77.66,
              36.893
            ],
            [
              -77.646,
              36.894
            ],
            [
              -77.648,
              36.883
            ],
            [
              -77.632,
              36.887
            ],
            [
              -77.62,
              36.878
            ]
          ],
          [
            [
              -77.522,
              36.714
            ],
            [
              -77.544,
              36.712
            ],
            [
              -77.556,
              36.713
            ],
            [
              -77.564,
              36.706
            ],
            [
              -77.555,
              36.675
            ],
            [
              -77.544,
              36.672
            ],
            [
              -77.539,
              36.676
            ],
            [
              -77.525,
              36.673
            ],
            [
              -77.522,
              36.684
            ],
            [
              -77.509,
              36.682
            ],
            [
              -77.51,
              36.718
            ],
            [
              -77.522,
              36.714
            ]
          ]
        ]
      },
      "properties": {
        "name": "Greensville County",
        "id": "51081",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51081"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.289,
              38.272
            ],
            [
              -78.369,
              38.186
            ],
            [
              -78.398,
              38.192
            ],
            [
              -78.558,
              38.243
            ],
            [
              -78.659,
              38.278
            ],
            [
              -78.65,
              38.293
            ],
            [
              -78.635,
              38.294
            ],
            [
              -78.624,
              38.304
            ],
            [
              -78.605,
              38.309
            ],
            [
              -78.59,
              38.324
            ],
            [
              -78.556,
              38.339
            ],
            [
              -78.551,
              38.353
            ],
            [
              -78.539,
              38.364
            ],
            [
              -78.525,
              38.37
            ],
            [
              -78.51,
              38.395
            ],
            [
              -78.501,
              38.402
            ],
            [
              -78.487,
              38.422
            ],
            [
              -78.476,
              38.435
            ],
            [
              -78.478,
              38.444
            ],
            [
              -78.462,
              38.455
            ],
            [
              -78.46,
              38.466
            ],
            [
              -78.45,
              38.481
            ],
            [
              -78.447,
              38.465
            ],
            [
              -78.435,
              38.456
            ],
            [
              -78.433,
              38.426
            ],
            [
              -78.438,
              38.408
            ],
            [
              -78.434,
              38.394
            ],
            [
              -78.424,
              38.388
            ],
            [
              -78.429,
              38.366
            ],
            [
              -78.412,
              38.352
            ],
            [
              -78.405,
              38.339
            ],
            [
              -78.377,
              38.318
            ],
            [
              -78.364,
              38.318
            ],
            [
              -78.358,
              38.302
            ],
            [
              -78.362,
              38.295
            ],
            [
              -78.349,
              38.288
            ],
            [
              -78.33,
              38.273
            ],
            [
              -78.305,
              38.27
            ],
            [
              -78.299,
              38.275
            ],
            [
              -78.289,
              38.272
            ]
          ]
        ]
      },
      "properties": {
        "name": "Greene County",
        "id": "51079",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51079"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -81.047,
              36.807
            ],
            [
              -80.989,
              36.74
            ],
            [
              -80.931,
              36.67
            ],
            [
              -80.946,
              36.674
            ],
            [
              -80.95,
              36.663
            ],
            [
              -80.948,
              36.651
            ],
            [
              -80.926,
              36.641
            ],
            [
              -80.932,
              36.627
            ],
            [
              -80.918,
              36.626
            ],
            [
              -80.914,
              36.65
            ],
            [
              -80.838,
              36.56
            ],
            [
              -80.912,
              36.561
            ],
            [
              -81.07,
              36.565
            ],
            [
              -81.278,
              36.571
            ],
            [
              -81.37,
              36.573
            ],
            [
              -81.489,
              36.581
            ],
            [
              -81.588,
              36.588
            ],
            [
              -81.676,
              36.589
            ],
            [
              -81.647,
              36.613
            ],
            [
              -81.62,
              36.612
            ],
            [
              -81.611,
              36.617
            ],
            [
              -81.605,
              36.641
            ],
            [
              -81.582,
              36.647
            ],
            [
              -81.567,
              36.658
            ],
            [
              -81.545,
              36.659
            ],
            [
              -81.539,
              36.661
            ],
            [
              -81.53,
              36.689
            ],
            [
              -81.545,
              36.698
            ],
            [
              -81.545,
              36.703
            ],
            [
              -81.519,
              36.705
            ],
            [
              -81.506,
              36.711
            ],
            [
              -81.485,
              36.712
            ],
            [
              -81.456,
              36.719
            ],
            [
              -81.432,
              36.72
            ],
            [
              -81.406,
              36.732
            ],
            [
              -81.385,
              36.739
            ],
            [
              -81.366,
              36.743
            ],
            [
              -81.309,
              36.751
            ],
            [
              -81.291,
              36.755
            ],
            [
              -81.262,
              36.765
            ],
            [
              -81.233,
              36.763
            ],
            [
              -81.214,
              36.76
            ],
            [
              -81.196,
              36.76
            ],
            [
              -81.184,
              36.764
            ],
            [
              -81.171,
              36.762
            ],
            [
              -81.16,
              36.769
            ],
            [
              -81.144,
              36.766
            ],
            [
              -81.116,
              36.769
            ],
            [
              -81.092,
              36.769
            ],
            [
              -81.086,
              36.787
            ],
            [
              -81.063,
              36.797
            ],
            [
              -81.047,
              36.807
            ]
          ]
        ]
      },
      "properties": {
        "name": "Grayson County",
        "id": "51077",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51077"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.632,
              37.706
            ],
            [
              -77.64,
              37.685
            ],
            [
              -77.651,
              37.649
            ],
            [
              -77.656,
              37.639
            ],
            [
              -77.653,
              37.619
            ],
            [
              -77.639,
              37.602
            ],
            [
              -77.629,
              37.598
            ],
            [
              -77.618,
              37.589
            ],
            [
              -77.617,
              37.58
            ],
            [
              -77.634,
              37.577
            ],
            [
              -77.639,
              37.566
            ],
            [
              -77.656,
              37.566
            ],
            [
              -77.708,
              37.59
            ],
            [
              -77.732,
              37.59
            ],
            [
              -77.749,
              37.601
            ],
            [
              -77.763,
              37.612
            ],
            [
              -77.796,
              37.613
            ],
            [
              -77.812,
              37.607
            ],
            [
              -77.821,
              37.61
            ],
            [
              -77.822,
              37.625
            ],
            [
              -77.833,
              37.636
            ],
            [
              -77.853,
              37.644
            ],
            [
              -77.874,
              37.658
            ],
            [
              -77.9,
              37.672
            ],
            [
              -77.91,
              37.69
            ],
            [
              -77.926,
              37.691
            ],
            [
              -77.948,
              37.678
            ],
            [
              -77.957,
              37.663
            ],
            [
              -77.945,
              37.644
            ],
            [
              -77.949,
              37.63
            ],
            [
              -77.959,
              37.626
            ],
            [
              -77.977,
              37.624
            ],
            [
              -77.993,
              37.631
            ],
            [
              -78.016,
              37.643
            ],
            [
              -78.045,
              37.643
            ],
            [
              -78.065,
              37.648
            ],
            [
              -78.076,
              37.655
            ],
            [
              -78.089,
              37.668
            ],
            [
              -78.111,
              37.671
            ],
            [
              -78.117,
              37.679
            ],
            [
              -78.097,
              37.695
            ],
            [
              -78.095,
              37.703
            ],
            [
              -78.108,
              37.718
            ],
            [
              -78.128,
              37.725
            ],
            [
              -78.138,
              37.736
            ],
            [
              -78.163,
              37.745
            ],
            [
              -78.154,
              37.771
            ],
            [
              -78.063,
              37.906
            ],
            [
              -78.006,
              37.875
            ],
            [
              -77.992,
              37.857
            ],
            [
              -77.946,
              37.845
            ],
            [
              -77.917,
              37.807
            ],
            [
              -77.906,
              37.779
            ],
            [
              -77.891,
              37.76
            ],
            [
              -77.833,
              37.754
            ],
            [
              -77.8,
              37.733
            ],
            [
              -77.791,
              37.727
            ],
            [
              -77.692,
              37.705
            ],
            [
              -77.664,
              37.704
            ],
            [
              -77.649,
              37.713
            ],
            [
              -77.632,
              37.706
            ]
          ]
        ]
      },
      "properties": {
        "name": "Goochland County",
        "id": "51075",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51075"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.525,
              37.551
            ],
            [
              -76.519,
              37.545
            ],
            [
              -76.464,
              37.525
            ],
            [
              -76.461,
              37.517
            ],
            [
              -76.446,
              37.512
            ],
            [
              -76.439,
              37.514
            ],
            [
              -76.439,
              37.508
            ],
            [
              -76.45,
              37.486
            ],
            [
              -76.445,
              37.459
            ],
            [
              -76.447,
              37.435
            ],
            [
              -76.443,
              37.416
            ],
            [
              -76.417,
              37.412
            ],
            [
              -76.417,
              37.399
            ],
            [
              -76.409,
              37.397
            ],
            [
              -76.41,
              37.374
            ],
            [
              -76.428,
              37.385
            ],
            [
              -76.447,
              37.386
            ],
            [
              -76.456,
              37.399
            ],
            [
              -76.468,
              37.4
            ],
            [
              -76.492,
              37.416
            ],
            [
              -76.493,
              37.401
            ],
            [
              -76.472,
              37.393
            ],
            [
              -76.465,
              37.385
            ],
            [
              -76.473,
              37.373
            ],
            [
              -76.485,
              37.375
            ],
            [
              -76.487,
              37.365
            ],
            [
              -76.479,
              37.362
            ],
            [
              -76.467,
              37.367
            ],
            [
              -76.426,
              37.354
            ],
            [
              -76.422,
              37.346
            ],
            [
              -76.413,
              37.341
            ],
            [
              -76.412,
              37.326
            ],
            [
              -76.442,
              37.328
            ],
            [
              -76.449,
              37.335
            ],
            [
              -76.465,
              37.327
            ],
            [
              -76.48,
              37.342
            ],
            [
              -76.479,
              37.318
            ],
            [
              -76.467,
              37.317
            ],
            [
              -76.445,
              37.322
            ],
            [
              -76.446,
              37.311
            ],
            [
              -76.454,
              37.308
            ],
            [
              -76.465,
              37.311
            ],
            [
              -76.47,
              37.303
            ],
            [
              -76.451,
              37.294
            ],
            [
              -76.452,
              37.303
            ],
            [
              -76.438,
              37.312
            ],
            [
              -76.403,
              37.309
            ],
            [
              -76.386,
              37.293
            ],
            [
              -76.385,
              37.284
            ],
            [
              -76.392,
              37.276
            ],
            [
              -76.403,
              37.279
            ],
            [
              -76.404,
              37.266
            ],
            [
              -76.419,
              37.267
            ],
            [
              -76.436,
              37.259
            ],
            [
              -76.461,
              37.254
            ],
            [
              -76.474,
              37.256
            ],
            [
              -76.484,
              37.263
            ],
            [
              -76.495,
              37.252
            ],
            [
              -76.505,
              37.252
            ],
            [
              -76.511,
              37.271
            ],
            [
              -76.524,
              37.281
            ],
            [
              -76.536,
              37.285
            ],
            [
              -76.555,
              37.299
            ],
            [
              -76.561,
              37.3
            ],
            [
              -76.564,
              37.314
            ],
            [
              -76.575,
              37.314
            ],
            [
              -76.598,
              37.339
            ],
            [
              -76.609,
              37.349
            ],
            [
              -76.618,
              37.361
            ],
            [
              -76.632,
              37.374
            ],
            [
              -76.639,
              37.384
            ],
            [
              -76.656,
              37.398
            ],
            [
              -76.658,
              37.411
            ],
            [
              -76.672,
              37.412
            ],
            [
              -76.69,
              37.422
            ],
            [
              -76.691,
              37.431
            ],
            [
              -76.7,
              37.434
            ],
            [
              -76.704,
              37.443
            ],
            [
              -76.703,
              37.452
            ],
            [
              -76.688,
              37.451
            ],
            [
              -76.675,
              37.462
            ],
            [
              -76.667,
              37.456
            ],
            [
              -76.655,
              37.467
            ],
            [
              -76.646,
              37.486
            ],
            [
              -76.652,
              37.5
            ],
            [
              -76.668,
              37.519
            ],
            [
              -76.671,
              37.533
            ],
            [
              -76.664,
              37.552
            ],
            [
              -76.665,
              37.568
            ],
            [
              -76.654,
              37.601
            ],
            [
              -76.639,
              37.591
            ],
            [
              -76.628,
              37.591
            ],
            [
              -76.615,
              37.584
            ],
            [
              -76.595,
              37.588
            ],
            [
              -76.582,
              37.576
            ],
            [
              -76.574,
              37.563
            ],
            [
              -76.563,
              37.564
            ],
            [
              -76.551,
              37.57
            ],
            [
              -76.525,
              37.551
            ]
          ]
        ]
      },
      "properties": {
        "name": "Gloucester County",
        "id": "51073",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51073"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -80.476,
              37.427
            ],
            [
              -80.428,
              37.319
            ],
            [
              -80.448,
              37.309
            ],
            [
              -80.476,
              37.29
            ],
            [
              -80.505,
              37.273
            ],
            [
              -80.53,
              37.263
            ],
            [
              -80.555,
              37.261
            ],
            [
              -80.607,
              37.247
            ],
            [
              -80.622,
              37.242
            ],
            [
              -80.672,
              37.224
            ],
            [
              -80.705,
              37.209
            ],
            [
              -80.779,
              37.189
            ],
            [
              -80.804,
              37.179
            ],
            [
              -80.829,
              37.162
            ],
            [
              -80.856,
              37.148
            ],
            [
              -80.882,
              37.169
            ],
            [
              -80.862,
              37.18
            ],
            [
              -80.872,
              37.193
            ],
            [
              -80.895,
              37.18
            ],
            [
              -81.01,
              37.275
            ],
            [
              -80.978,
              37.294
            ],
            [
              -80.96,
              37.294
            ],
            [
              -80.935,
              37.301
            ],
            [
              -80.898,
              37.317
            ],
            [
              -80.871,
              37.337
            ],
            [
              -80.854,
              37.345
            ],
            [
              -80.853,
              37.353
            ],
            [
              -80.882,
              37.382
            ],
            [
              -80.881,
              37.389
            ],
            [
              -80.864,
              37.41
            ],
            [
              -80.866,
              37.419
            ],
            [
              -80.858,
              37.43
            ],
            [
              -80.837,
              37.425
            ],
            [
              -80.816,
              37.411
            ],
            [
              -80.8,
              37.396
            ],
            [
              -80.783,
              37.392
            ],
            [
              -80.771,
              37.373
            ],
            [
              -80.731,
              37.385
            ],
            [
              -80.652,
              37.42
            ],
            [
              -80.59,
              37.452
            ],
            [
              -80.567,
              37.466
            ],
            [
              -80.55,
              37.473
            ],
            [
              -80.508,
              37.481
            ],
            [
              -80.503,
              37.479
            ],
            [
              -80.493,
              37.46
            ],
            [
              -80.494,
              37.442
            ],
            [
              -80.476,
              37.427
            ]
          ]
        ]
      },
      "properties": {
        "name": "Giles County",
        "id": "51071",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51071"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -80.914,
              36.65
            ],
            [
              -80.918,
              36.626
            ],
            [
              -80.932,
              36.627
            ],
            [
              -80.926,
              36.641
            ],
            [
              -80.948,
              36.651
            ],
            [
              -80.95,
              36.663
            ],
            [
              -80.946,
              36.674
            ],
            [
              -80.931,
              36.67
            ],
            [
              -80.93,
              36.679
            ],
            [
              -80.916,
              36.694
            ],
            [
              -80.889,
              36.697
            ],
            [
              -80.877,
              36.692
            ],
            [
              -80.902,
              36.661
            ],
            [
              -80.914,
              36.65
            ]
          ]
        ]
      },
      "properties": {
        "name": "Galax City",
        "id": "51640",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51640"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.448,
              38.287
            ],
            [
              -77.45,
              38.275
            ],
            [
              -77.457,
              38.271
            ],
            [
              -77.466,
              38.279
            ],
            [
              -77.473,
              38.27
            ],
            [
              -77.495,
              38.274
            ],
            [
              -77.493,
              38.279
            ],
            [
              -77.512,
              38.28
            ],
            [
              -77.507,
              38.292
            ],
            [
              -77.515,
              38.305
            ],
            [
              -77.529,
              38.309
            ],
            [
              -77.528,
              38.32
            ],
            [
              -77.504,
              38.327
            ],
            [
              -77.48,
              38.317
            ],
            [
              -77.464,
              38.315
            ],
            [
              -77.448,
              38.287
            ]
          ]
        ]
      },
      "properties": {
        "name": "Fredericksburg City",
        "id": "51630",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51630"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.152,
              39.037
            ],
            [
              -78.159,
              39.029
            ],
            [
              -78.162,
              39.019
            ],
            [
              -78.314,
              39.01
            ],
            [
              -78.316,
              39.03
            ],
            [
              -78.309,
              39.034
            ],
            [
              -78.343,
              39.057
            ],
            [
              -78.338,
              39.072
            ],
            [
              -78.327,
              39.074
            ],
            [
              -78.333,
              39.085
            ],
            [
              -78.335,
              39.101
            ],
            [
              -78.375,
              39.093
            ],
            [
              -78.389,
              39.096
            ],
            [
              -78.401,
              39.092
            ],
            [
              -78.42,
              39.08
            ],
            [
              -78.431,
              39.066
            ],
            [
              -78.444,
              39.054
            ],
            [
              -78.446,
              39.035
            ],
            [
              -78.45,
              39.028
            ],
            [
              -78.542,
              39.06
            ],
            [
              -78.53,
              39.067
            ],
            [
              -78.503,
              39.094
            ],
            [
              -78.485,
              39.107
            ],
            [
              -78.46,
              39.115
            ],
            [
              -78.449,
              39.123
            ],
            [
              -78.43,
              39.149
            ],
            [
              -78.412,
              39.16
            ],
            [
              -78.404,
              39.172
            ],
            [
              -78.426,
              39.185
            ],
            [
              -78.432,
              39.205
            ],
            [
              -78.41,
              39.227
            ],
            [
              -78.404,
              39.238
            ],
            [
              -78.404,
              39.249
            ],
            [
              -78.418,
              39.256
            ],
            [
              -78.401,
              39.281
            ],
            [
              -78.386,
              39.294
            ],
            [
              -78.358,
              39.321
            ],
            [
              -78.341,
              39.353
            ],
            [
              -78.365,
              39.36
            ],
            [
              -78.347,
              39.384
            ],
            [
              -78.347,
              39.392
            ],
            [
              -78.357,
              39.402
            ],
            [
              -78.359,
              39.412
            ],
            [
              -78.351,
              39.422
            ],
            [
              -78.353,
              39.435
            ],
            [
              -78.347,
              39.447
            ],
            [
              -78.347,
              39.467
            ],
            [
              -78.268,
              39.418
            ],
            [
              -78.181,
              39.36
            ],
            [
              -78.031,
              39.264
            ],
            [
              -78.038,
              39.254
            ],
            [
              -78.042,
              39.238
            ],
            [
              -78.053,
              39.231
            ],
            [
              -78.068,
              39.209
            ],
            [
              -78.076,
              39.188
            ],
            [
              -78.076,
              39.177
            ],
            [
              -78.085,
              39.166
            ],
            [
              -78.101,
              39.125
            ],
            [
              -78.107,
              39.117
            ],
            [
              -78.104,
              39.107
            ],
            [
              -78.108,
              39.099
            ],
            [
              -78.12,
              39.092
            ],
            [
              -78.135,
              39.074
            ],
            [
              -78.146,
              39.075
            ],
            [
              -78.139,
              39.058
            ],
            [
              -78.152,
              39.037
            ]
          ],
          [
            [
              -78.172,
              39.143
            ],
            [
              -78.165,
              39.157
            ],
            [
              -78.153,
              39.172
            ],
            [
              -78.137,
              39.184
            ],
            [
              -78.16,
              39.198
            ],
            [
              -78.188,
              39.205
            ],
            [
              -78.196,
              39.193
            ],
            [
              -78.201,
              39.179
            ],
            [
              -78.189,
              39.174
            ],
            [
              -78.198,
              39.142
            ],
            [
              -78.179,
              39.135
            ],
            [
              -78.172,
              39.143
            ]
          ]
        ]
      },
      "properties": {
        "name": "Frederick County",
        "id": "51069",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": 87
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.596,
              37.045
            ],
            [
              -79.641,
              36.856
            ],
            [
              -79.668,
              36.827
            ],
            [
              -79.689,
              36.828
            ],
            [
              -79.739,
              36.811
            ],
            [
              -79.749,
              36.793
            ],
            [
              -79.771,
              36.795
            ],
            [
              -79.789,
              36.8
            ],
            [
              -79.8,
              36.793
            ],
            [
              -80,
              36.831
            ],
            [
              -80.012,
              36.789
            ],
            [
              -80.029,
              36.781
            ],
            [
              -80.041,
              36.794
            ],
            [
              -80.042,
              36.799
            ],
            [
              -80.072,
              36.823
            ],
            [
              -80.067,
              36.841
            ],
            [
              -80.085,
              36.849
            ],
            [
              -80.099,
              36.846
            ],
            [
              -80.125,
              36.851
            ],
            [
              -80.208,
              36.866
            ],
            [
              -80.235,
              36.872
            ],
            [
              -80.199,
              36.903
            ],
            [
              -80.194,
              36.923
            ],
            [
              -80.187,
              36.94
            ],
            [
              -80.165,
              36.955
            ],
            [
              -80.16,
              36.949
            ],
            [
              -80.147,
              36.95
            ],
            [
              -80.137,
              36.964
            ],
            [
              -80.143,
              36.977
            ],
            [
              -80.14,
              36.985
            ],
            [
              -80.124,
              36.991
            ],
            [
              -80.137,
              37
            ],
            [
              -80.131,
              37.007
            ],
            [
              -80.12,
              37.011
            ],
            [
              -80.119,
              37.02
            ],
            [
              -80.108,
              37.024
            ],
            [
              -80.114,
              37.033
            ],
            [
              -80.121,
              37.056
            ],
            [
              -80.112,
              37.073
            ],
            [
              -80.113,
              37.088
            ],
            [
              -80.129,
              37.12
            ],
            [
              -80.129,
              37.128
            ],
            [
              -80.119,
              37.131
            ],
            [
              -80.098,
              37.152
            ],
            [
              -80.094,
              37.16
            ],
            [
              -80.08,
              37.162
            ],
            [
              -80.069,
              37.167
            ],
            [
              -80.051,
              37.168
            ],
            [
              -80.034,
              37.176
            ],
            [
              -80.012,
              37.173
            ],
            [
              -80.007,
              37.16
            ],
            [
              -79.992,
              37.147
            ],
            [
              -79.978,
              37.143
            ],
            [
              -79.967,
              37.138
            ],
            [
              -79.96,
              37.139
            ],
            [
              -79.948,
              37.15
            ],
            [
              -79.918,
              37.166
            ],
            [
              -79.911,
              37.179
            ],
            [
              -79.897,
              37.184
            ],
            [
              -79.894,
              37.2
            ],
            [
              -79.877,
              37.214
            ],
            [
              -79.856,
              37.216
            ],
            [
              -79.848,
              37.225
            ],
            [
              -79.843,
              37.218
            ],
            [
              -79.833,
              37.218
            ],
            [
              -79.819,
              37.224
            ],
            [
              -79.808,
              37.216
            ],
            [
              -79.793,
              37.223
            ],
            [
              -79.793,
              37.23
            ],
            [
              -79.781,
              37.23
            ],
            [
              -79.775,
              37.217
            ],
            [
              -79.779,
              37.212
            ],
            [
              -79.772,
              37.2
            ],
            [
              -79.764,
              37.202
            ],
            [
              -79.759,
              37.193
            ],
            [
              -79.734,
              37.189
            ],
            [
              -79.719,
              37.191
            ],
            [
              -79.712,
              37.174
            ],
            [
              -79.708,
              37.156
            ],
            [
              -79.701,
              37.151
            ],
            [
              -79.688,
              37.151
            ],
            [
              -79.679,
              37.156
            ],
            [
              -79.672,
              37.151
            ],
            [
              -79.662,
              37.136
            ],
            [
              -79.654,
              37.13
            ],
            [
              -79.65,
              37.119
            ],
            [
              -79.634,
              37.097
            ],
            [
              -79.615,
              37.092
            ],
            [
              -79.612,
              37.085
            ],
            [
              -79.622,
              37.08
            ],
            [
              -79.596,
              37.057
            ],
            [
              -79.596,
              37.045
            ]
          ]
        ]
      },
      "properties": {
        "name": "Franklin County",
        "id": "51067",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51067"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.91,
              36.648
            ],
            [
              -76.942,
              36.662
            ],
            [
              -76.962,
              36.667
            ],
            [
              -76.947,
              36.674
            ],
            [
              -76.95,
              36.678
            ],
            [
              -76.965,
              36.679
            ],
            [
              -76.967,
              36.687
            ],
            [
              -76.955,
              36.69
            ],
            [
              -76.96,
              36.702
            ],
            [
              -76.946,
              36.71
            ],
            [
              -76.93,
              36.707
            ],
            [
              -76.918,
              36.701
            ],
            [
              -76.922,
              36.679
            ],
            [
              -76.915,
              36.671
            ],
            [
              -76.919,
              36.663
            ],
            [
              -76.91,
              36.648
            ]
          ]
        ]
      },
      "properties": {
        "name": "Franklin City",
        "id": "51620",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51620"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.163,
              37.745
            ],
            [
              -78.181,
              37.744
            ],
            [
              -78.21,
              37.727
            ],
            [
              -78.233,
              37.708
            ],
            [
              -78.238,
              37.693
            ],
            [
              -78.249,
              37.69
            ],
            [
              -78.275,
              37.7
            ],
            [
              -78.284,
              37.708
            ],
            [
              -78.341,
              37.72
            ],
            [
              -78.361,
              37.731
            ],
            [
              -78.403,
              37.736
            ],
            [
              -78.44,
              37.748
            ],
            [
              -78.459,
              37.758
            ],
            [
              -78.476,
              37.771
            ],
            [
              -78.485,
              37.79
            ],
            [
              -78.49,
              37.792
            ],
            [
              -78.487,
              37.801
            ],
            [
              -78.306,
              38.007
            ],
            [
              -78.291,
              37.999
            ],
            [
              -78.259,
              37.987
            ],
            [
              -78.221,
              37.976
            ],
            [
              -78.213,
              37.964
            ],
            [
              -78.196,
              37.954
            ],
            [
              -78.17,
              37.951
            ],
            [
              -78.141,
              37.936
            ],
            [
              -78.063,
              37.906
            ],
            [
              -78.154,
              37.771
            ],
            [
              -78.163,
              37.745
            ]
          ]
        ]
      },
      "properties": {
        "name": "Fluvanna County",
        "id": "51065",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51065"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -80.235,
              36.872
            ],
            [
              -80.254,
              36.871
            ],
            [
              -80.255,
              36.864
            ],
            [
              -80.285,
              36.859
            ],
            [
              -80.303,
              36.844
            ],
            [
              -80.318,
              36.844
            ],
            [
              -80.329,
              36.831
            ],
            [
              -80.344,
              36.832
            ],
            [
              -80.347,
              36.812
            ],
            [
              -80.362,
              36.803
            ],
            [
              -80.377,
              36.803
            ],
            [
              -80.392,
              36.792
            ],
            [
              -80.385,
              36.784
            ],
            [
              -80.392,
              36.776
            ],
            [
              -80.388,
              36.77
            ],
            [
              -80.397,
              36.764
            ],
            [
              -80.398,
              36.756
            ],
            [
              -80.393,
              36.748
            ],
            [
              -80.399,
              36.742
            ],
            [
              -80.431,
              36.743
            ],
            [
              -80.444,
              36.748
            ],
            [
              -80.459,
              36.738
            ],
            [
              -80.453,
              36.733
            ],
            [
              -80.461,
              36.725
            ],
            [
              -80.464,
              36.71
            ],
            [
              -80.466,
              36.711
            ],
            [
              -80.634,
              36.932
            ],
            [
              -80.63,
              36.936
            ],
            [
              -80.595,
              36.946
            ],
            [
              -80.572,
              36.96
            ],
            [
              -80.564,
              36.968
            ],
            [
              -80.535,
              36.977
            ],
            [
              -80.518,
              36.994
            ],
            [
              -80.519,
              37.009
            ],
            [
              -80.509,
              37.005
            ],
            [
              -80.496,
              36.985
            ],
            [
              -80.475,
              36.994
            ],
            [
              -80.471,
              37.003
            ],
            [
              -80.448,
              37.02
            ],
            [
              -80.443,
              37.009
            ],
            [
              -80.434,
              37.016
            ],
            [
              -80.424,
              37.011
            ],
            [
              -80.422,
              37.003
            ],
            [
              -80.41,
              37.006
            ],
            [
              -80.419,
              37.017
            ],
            [
              -80.409,
              37.019
            ],
            [
              -80.401,
              37.011
            ],
            [
              -80.392,
              37.009
            ],
            [
              -80.383,
              37.019
            ],
            [
              -80.356,
              37.02
            ],
            [
              -80.344,
              37.028
            ],
            [
              -80.293,
              37.073
            ],
            [
              -80.276,
              37.082
            ],
            [
              -80.231,
              37.097
            ],
            [
              -80.224,
              37.103
            ],
            [
              -80.176,
              37.125
            ],
            [
              -80.173,
              37.116
            ],
            [
              -80.159,
              37.111
            ],
            [
              -80.152,
              37.119
            ],
            [
              -80.151,
              37.128
            ],
            [
              -80.129,
              37.128
            ],
            [
              -80.129,
              37.12
            ],
            [
              -80.113,
              37.088
            ],
            [
              -80.112,
              37.073
            ],
            [
              -80.121,
              37.056
            ],
            [
              -80.114,
              37.033
            ],
            [
              -80.108,
              37.024
            ],
            [
              -80.119,
              37.02
            ],
            [
              -80.12,
              37.011
            ],
            [
              -80.131,
              37.007
            ],
            [
              -80.137,
              37
            ],
            [
              -80.124,
              36.991
            ],
            [
              -80.14,
              36.985
            ],
            [
              -80.143,
              36.977
            ],
            [
              -80.137,
              36.964
            ],
            [
              -80.147,
              36.95
            ],
            [
              -80.16,
              36.949
            ],
            [
              -80.165,
              36.955
            ],
            [
              -80.187,
              36.94
            ],
            [
              -80.194,
              36.923
            ],
            [
              -80.199,
              36.903
            ],
            [
              -80.235,
              36.872
            ]
          ]
        ]
      },
      "properties": {
        "name": "Floyd County",
        "id": "51063",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51063"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.527,
              38.555
            ],
            [
              -77.584,
              38.509
            ],
            [
              -77.617,
              38.475
            ],
            [
              -77.631,
              38.458
            ],
            [
              -77.629,
              38.438
            ],
            [
              -77.634,
              38.419
            ],
            [
              -77.634,
              38.409
            ],
            [
              -77.679,
              38.425
            ],
            [
              -77.695,
              38.425
            ],
            [
              -77.716,
              38.421
            ],
            [
              -77.734,
              38.413
            ],
            [
              -77.742,
              38.425
            ],
            [
              -77.755,
              38.432
            ],
            [
              -77.762,
              38.443
            ],
            [
              -77.762,
              38.459
            ],
            [
              -77.776,
              38.468
            ],
            [
              -77.775,
              38.474
            ],
            [
              -77.782,
              38.487
            ],
            [
              -77.8,
              38.504
            ],
            [
              -77.802,
              38.512
            ],
            [
              -77.813,
              38.529
            ],
            [
              -77.826,
              38.538
            ],
            [
              -77.834,
              38.538
            ],
            [
              -77.858,
              38.562
            ],
            [
              -77.874,
              38.59
            ],
            [
              -77.864,
              38.598
            ],
            [
              -77.871,
              38.609
            ],
            [
              -77.861,
              38.616
            ],
            [
              -77.87,
              38.632
            ],
            [
              -77.877,
              38.636
            ],
            [
              -77.87,
              38.65
            ],
            [
              -77.885,
              38.667
            ],
            [
              -77.896,
              38.663
            ],
            [
              -77.904,
              38.671
            ],
            [
              -77.898,
              38.679
            ],
            [
              -77.908,
              38.697
            ],
            [
              -77.931,
              38.699
            ],
            [
              -77.945,
              38.697
            ],
            [
              -77.965,
              38.7
            ],
            [
              -77.992,
              38.712
            ],
            [
              -78.005,
              38.721
            ],
            [
              -78.017,
              38.742
            ],
            [
              -78.016,
              38.75
            ],
            [
              -78.027,
              38.761
            ],
            [
              -78.021,
              38.779
            ],
            [
              -78.029,
              38.786
            ],
            [
              -78.028,
              38.796
            ],
            [
              -78.05,
              38.801
            ],
            [
              -78.052,
              38.806
            ],
            [
              -78.074,
              38.821
            ],
            [
              -78.097,
              38.829
            ],
            [
              -78.104,
              38.84
            ],
            [
              -78.117,
              38.847
            ],
            [
              -78.132,
              38.863
            ],
            [
              -78.117,
              38.886
            ],
            [
              -78.108,
              38.879
            ],
            [
              -78.087,
              38.886
            ],
            [
              -78.076,
              38.882
            ],
            [
              -78.06,
              38.889
            ],
            [
              -78.064,
              38.901
            ],
            [
              -78.074,
              38.909
            ],
            [
              -78.064,
              38.932
            ],
            [
              -78.038,
              38.941
            ],
            [
              -78.034,
              38.951
            ],
            [
              -78.023,
              38.959
            ],
            [
              -78.017,
              38.97
            ],
            [
              -78.005,
              38.982
            ],
            [
              -77.988,
              38.999
            ],
            [
              -77.961,
              39.015
            ],
            [
              -77.657,
              38.944
            ],
            [
              -77.679,
              38.898
            ],
            [
              -77.688,
              38.875
            ],
            [
              -77.703,
              38.887
            ],
            [
              -77.704,
              38.872
            ],
            [
              -77.717,
              38.856
            ],
            [
              -77.716,
              38.829
            ],
            [
              -77.659,
              38.748
            ],
            [
              -77.538,
              38.571
            ],
            [
              -77.534,
              38.561
            ],
            [
              -77.527,
              38.555
            ]
          ]
        ]
      },
      "properties": {
        "name": "Fauquier County",
        "id": "51061",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51061"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.172,
              38.893
            ],
            [
              -77.15,
              38.876
            ],
            [
              -77.158,
              38.873
            ],
            [
              -77.174,
              38.879
            ],
            [
              -77.19,
              38.878
            ],
            [
              -77.194,
              38.886
            ],
            [
              -77.189,
              38.896
            ],
            [
              -77.172,
              38.893
            ]
          ]
        ]
      },
      "properties": {
        "name": "Falls Church City",
        "id": "51610",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51610"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.172,
              38.893
            ],
            [
              -77.189,
              38.896
            ],
            [
              -77.194,
              38.886
            ],
            [
              -77.19,
              38.878
            ],
            [
              -77.174,
              38.879
            ],
            [
              -77.158,
              38.873
            ],
            [
              -77.15,
              38.876
            ],
            [
              -77.11,
              38.844
            ],
            [
              -77.128,
              38.837
            ],
            [
              -77.142,
              38.827
            ],
            [
              -77.145,
              38.81
            ],
            [
              -77.139,
              38.798
            ],
            [
              -77.115,
              38.802
            ],
            [
              -77.084,
              38.801
            ],
            [
              -77.062,
              38.795
            ],
            [
              -77.04,
              38.786
            ],
            [
              -77.041,
              38.762
            ],
            [
              -77.04,
              38.728
            ],
            [
              -77.044,
              38.715
            ],
            [
              -77.055,
              38.708
            ],
            [
              -77.081,
              38.708
            ],
            [
              -77.091,
              38.702
            ],
            [
              -77.104,
              38.701
            ],
            [
              -77.123,
              38.71
            ],
            [
              -77.126,
              38.707
            ],
            [
              -77.119,
              38.692
            ],
            [
              -77.129,
              38.678
            ],
            [
              -77.142,
              38.674
            ],
            [
              -77.166,
              38.684
            ],
            [
              -77.179,
              38.682
            ],
            [
              -77.159,
              38.669
            ],
            [
              -77.151,
              38.657
            ],
            [
              -77.135,
              38.65
            ],
            [
              -77.133,
              38.635
            ],
            [
              -77.15,
              38.635
            ],
            [
              -77.156,
              38.64
            ],
            [
              -77.167,
              38.637
            ],
            [
              -77.168,
              38.625
            ],
            [
              -77.201,
              38.616
            ],
            [
              -77.216,
              38.637
            ],
            [
              -77.209,
              38.642
            ],
            [
              -77.198,
              38.643
            ],
            [
              -77.194,
              38.653
            ],
            [
              -77.199,
              38.657
            ],
            [
              -77.223,
              38.655
            ],
            [
              -77.236,
              38.661
            ],
            [
              -77.255,
              38.679
            ],
            [
              -77.273,
              38.69
            ],
            [
              -77.302,
              38.706
            ],
            [
              -77.326,
              38.7
            ],
            [
              -77.325,
              38.711
            ],
            [
              -77.332,
              38.716
            ],
            [
              -77.36,
              38.724
            ],
            [
              -77.368,
              38.711
            ],
            [
              -77.383,
              38.721
            ],
            [
              -77.38,
              38.734
            ],
            [
              -77.394,
              38.749
            ],
            [
              -77.41,
              38.755
            ],
            [
              -77.417,
              38.774
            ],
            [
              -77.431,
              38.781
            ],
            [
              -77.44,
              38.8
            ],
            [
              -77.45,
              38.802
            ],
            [
              -77.464,
              38.796
            ],
            [
              -77.492,
              38.797
            ],
            [
              -77.492,
              38.811
            ],
            [
              -77.505,
              38.817
            ],
            [
              -77.508,
              38.841
            ],
            [
              -77.52,
              38.838
            ],
            [
              -77.532,
              38.839
            ],
            [
              -77.537,
              38.848
            ],
            [
              -77.47,
              38.92
            ],
            [
              -77.327,
              39.061
            ],
            [
              -77.297,
              39.052
            ],
            [
              -77.271,
              39.035
            ],
            [
              -77.248,
              39.028
            ],
            [
              -77.243,
              39.015
            ],
            [
              -77.249,
              38.997
            ],
            [
              -77.245,
              38.987
            ],
            [
              -77.226,
              38.976
            ],
            [
              -77.211,
              38.975
            ],
            [
              -77.19,
              38.969
            ],
            [
              -77.155,
              38.967
            ],
            [
              -77.138,
              38.955
            ],
            [
              -77.121,
              38.934
            ],
            [
              -77.172,
              38.893
            ]
          ],
          [
            [
              -77.298,
              38.868
            ],
            [
              -77.308,
              38.863
            ],
            [
              -77.327,
              38.868
            ],
            [
              -77.335,
              38.854
            ],
            [
              -77.319,
              38.842
            ],
            [
              -77.319,
              38.835
            ],
            [
              -77.287,
              38.837
            ],
            [
              -77.286,
              38.841
            ],
            [
              -77.27,
              38.84
            ],
            [
              -77.268,
              38.862
            ],
            [
              -77.27,
              38.866
            ],
            [
              -77.298,
              38.868
            ]
          ]
        ]
      },
      "properties": {
        "name": "Fairfax County",
        "id": "51059",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51059"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.298,
              38.868
            ],
            [
              -77.27,
              38.866
            ],
            [
              -77.268,
              38.862
            ],
            [
              -77.27,
              38.84
            ],
            [
              -77.286,
              38.841
            ],
            [
              -77.287,
              38.837
            ],
            [
              -77.319,
              38.835
            ],
            [
              -77.319,
              38.842
            ],
            [
              -77.335,
              38.854
            ],
            [
              -77.327,
              38.868
            ],
            [
              -77.308,
              38.863
            ],
            [
              -77.298,
              38.868
            ]
          ]
        ]
      },
      "properties": {
        "name": "Fairfax City",
        "id": "51600",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51600"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.685,
              37.768
            ],
            [
              -76.717,
              37.759
            ],
            [
              -76.727,
              37.755
            ],
            [
              -76.742,
              37.741
            ],
            [
              -76.755,
              37.739
            ],
            [
              -76.76,
              37.751
            ],
            [
              -76.794,
              37.776
            ],
            [
              -76.796,
              37.793
            ],
            [
              -76.816,
              37.794
            ],
            [
              -76.843,
              37.799
            ],
            [
              -76.868,
              37.786
            ],
            [
              -76.88,
              37.783
            ],
            [
              -76.902,
              37.795
            ],
            [
              -76.914,
              37.797
            ],
            [
              -76.937,
              37.791
            ],
            [
              -76.946,
              37.784
            ],
            [
              -76.948,
              37.829
            ],
            [
              -76.973,
              37.83
            ],
            [
              -76.985,
              37.841
            ],
            [
              -76.998,
              37.836
            ],
            [
              -77.017,
              37.843
            ],
            [
              -77.025,
              37.864
            ],
            [
              -77.045,
              37.873
            ],
            [
              -77.044,
              37.878
            ],
            [
              -77.03,
              37.879
            ],
            [
              -77.026,
              37.885
            ],
            [
              -77.032,
              37.893
            ],
            [
              -77.026,
              37.906
            ],
            [
              -77.039,
              37.928
            ],
            [
              -77.049,
              37.928
            ],
            [
              -77.061,
              37.943
            ],
            [
              -77.073,
              37.948
            ],
            [
              -77.066,
              37.96
            ],
            [
              -77.073,
              37.968
            ],
            [
              -77.073,
              37.98
            ],
            [
              -77.079,
              37.991
            ],
            [
              -77.079,
              38
            ],
            [
              -77.088,
              38.012
            ],
            [
              -77.124,
              38.014
            ],
            [
              -77.134,
              38.024
            ],
            [
              -77.128,
              38.038
            ],
            [
              -77.138,
              38.049
            ],
            [
              -77.16,
              38.065
            ],
            [
              -77.169,
              38.078
            ],
            [
              -77.152,
              38.091
            ],
            [
              -77.146,
              38.1
            ],
            [
              -77.146,
              38.119
            ],
            [
              -77.143,
              38.123
            ],
            [
              -77.12,
              38.121
            ],
            [
              -77.107,
              38.126
            ],
            [
              -77.115,
              38.134
            ],
            [
              -77.099,
              38.154
            ],
            [
              -77.087,
              38.134
            ],
            [
              -77.057,
              38.141
            ],
            [
              -77.063,
              38.118
            ],
            [
              -77.06,
              38.106
            ],
            [
              -77.046,
              38.099
            ],
            [
              -77.035,
              38.09
            ],
            [
              -77.017,
              38.089
            ],
            [
              -77.004,
              38.096
            ],
            [
              -76.976,
              38.084
            ],
            [
              -76.939,
              38.074
            ],
            [
              -76.933,
              38.066
            ],
            [
              -76.929,
              38.05
            ],
            [
              -76.919,
              38.031
            ],
            [
              -76.926,
              38.024
            ],
            [
              -76.924,
              38.015
            ],
            [
              -76.917,
              38.007
            ],
            [
              -76.93,
              37.989
            ],
            [
              -76.92,
              37.979
            ],
            [
              -76.91,
              37.977
            ],
            [
              -76.888,
              37.977
            ],
            [
              -76.882,
              37.971
            ],
            [
              -76.89,
              37.956
            ],
            [
              -76.874,
              37.949
            ],
            [
              -76.865,
              37.937
            ],
            [
              -76.847,
              37.922
            ],
            [
              -76.823,
              37.918
            ],
            [
              -76.827,
              37.911
            ],
            [
              -76.812,
              37.899
            ],
            [
              -76.796,
              37.898
            ],
            [
              -76.796,
              37.89
            ],
            [
              -76.787,
              37.876
            ],
            [
              -76.785,
              37.865
            ],
            [
              -76.773,
              37.856
            ],
            [
              -76.767,
              37.84
            ],
            [
              -76.757,
              37.83
            ],
            [
              -76.736,
              37.8
            ],
            [
              -76.72,
              37.788
            ],
            [
              -76.694,
              37.787
            ],
            [
              -76.682,
              37.781
            ],
            [
              -76.685,
              37.768
            ]
          ]
        ]
      },
      "properties": {
        "name": "Essex County",
        "id": "51057",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51057"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.522,
              36.714
            ],
            [
              -77.51,
              36.718
            ],
            [
              -77.509,
              36.682
            ],
            [
              -77.522,
              36.684
            ],
            [
              -77.525,
              36.673
            ],
            [
              -77.539,
              36.676
            ],
            [
              -77.544,
              36.672
            ],
            [
              -77.555,
              36.675
            ],
            [
              -77.564,
              36.706
            ],
            [
              -77.556,
              36.713
            ],
            [
              -77.544,
              36.712
            ],
            [
              -77.522,
              36.714
            ]
          ]
        ]
      },
      "properties": {
        "name": "Emporia City",
        "id": "51595",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51595"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.447,
              37.223
            ],
            [
              -77.446,
              37.188
            ],
            [
              -77.423,
              37.181
            ],
            [
              -77.422,
              37.165
            ],
            [
              -77.4,
              37.171
            ],
            [
              -77.399,
              37.169
            ],
            [
              -77.398,
              37.047
            ],
            [
              -77.405,
              36.993
            ],
            [
              -77.62,
              36.878
            ],
            [
              -77.632,
              36.887
            ],
            [
              -77.648,
              36.883
            ],
            [
              -77.646,
              36.894
            ],
            [
              -77.66,
              36.893
            ],
            [
              -77.676,
              36.902
            ],
            [
              -77.696,
              36.906
            ],
            [
              -77.703,
              36.915
            ],
            [
              -77.719,
              36.916
            ],
            [
              -77.719,
              36.93
            ],
            [
              -77.74,
              36.952
            ],
            [
              -77.759,
              36.958
            ],
            [
              -77.765,
              36.972
            ],
            [
              -77.783,
              36.976
            ],
            [
              -77.802,
              36.985
            ],
            [
              -77.815,
              36.984
            ],
            [
              -77.819,
              36.989
            ],
            [
              -77.84,
              36.996
            ],
            [
              -77.859,
              36.989
            ],
            [
              -77.885,
              36.992
            ],
            [
              -77.894,
              36.989
            ],
            [
              -77.9,
              37.117
            ],
            [
              -77.9,
              37.145
            ],
            [
              -77.883,
              37.146
            ],
            [
              -77.871,
              37.152
            ],
            [
              -77.86,
              37.162
            ],
            [
              -77.842,
              37.169
            ],
            [
              -77.822,
              37.168
            ],
            [
              -77.807,
              37.179
            ],
            [
              -77.802,
              37.19
            ],
            [
              -77.79,
              37.196
            ],
            [
              -77.749,
              37.195
            ],
            [
              -77.73,
              37.204
            ],
            [
              -77.723,
              37.214
            ],
            [
              -77.695,
              37.224
            ],
            [
              -77.69,
              37.234
            ],
            [
              -77.673,
              37.243
            ],
            [
              -77.664,
              37.244
            ],
            [
              -77.651,
              37.267
            ],
            [
              -77.618,
              37.272
            ],
            [
              -77.61,
              37.269
            ],
            [
              -77.597,
              37.251
            ],
            [
              -77.573,
              37.239
            ],
            [
              -77.561,
              37.227
            ],
            [
              -77.543,
              37.227
            ],
            [
              -77.522,
              37.217
            ],
            [
              -77.511,
              37.218
            ],
            [
              -77.503,
              37.224
            ],
            [
              -77.473,
              37.227
            ],
            [
              -77.447,
              37.223
            ]
          ]
        ]
      },
      "properties": {
        "name": "Dinwiddie County",
        "id": "51053",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51053"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -82.149,
              37.041
            ],
            [
              -82.158,
              37.038
            ],
            [
              -82.169,
              37.04
            ],
            [
              -82.186,
              37.028
            ],
            [
              -82.2,
              37.029
            ],
            [
              -82.24,
              37.002
            ],
            [
              -82.243,
              36.995
            ],
            [
              -82.262,
              36.989
            ],
            [
              -82.274,
              37.001
            ],
            [
              -82.286,
              36.998
            ],
            [
              -82.302,
              36.986
            ],
            [
              -82.328,
              36.971
            ],
            [
              -82.346,
              36.959
            ],
            [
              -82.363,
              36.956
            ],
            [
              -82.366,
              36.97
            ],
            [
              -82.372,
              36.975
            ],
            [
              -82.404,
              36.985
            ],
            [
              -82.468,
              37.023
            ],
            [
              -82.483,
              37.024
            ],
            [
              -82.491,
              37.031
            ],
            [
              -82.494,
              37.051
            ],
            [
              -82.492,
              37.06
            ],
            [
              -82.543,
              37.124
            ],
            [
              -82.552,
              37.204
            ],
            [
              -82.534,
              37.208
            ],
            [
              -82.517,
              37.215
            ],
            [
              -82.501,
              37.225
            ],
            [
              -82.49,
              37.227
            ],
            [
              -82.479,
              37.234
            ],
            [
              -82.464,
              37.237
            ],
            [
              -82.434,
              37.249
            ],
            [
              -82.397,
              37.256
            ],
            [
              -82.352,
              37.268
            ],
            [
              -82.342,
              37.274
            ],
            [
              -82.337,
              37.283
            ],
            [
              -82.32,
              37.288
            ],
            [
              -82.314,
              37.296
            ],
            [
              -82.298,
              37.307
            ],
            [
              -82.271,
              37.29
            ],
            [
              -82.269,
              37.284
            ],
            [
              -82.251,
              37.273
            ],
            [
              -82.234,
              37.224
            ],
            [
              -82.23,
              37.202
            ],
            [
              -82.199,
              37.157
            ],
            [
              -82.187,
              37.156
            ],
            [
              -82.185,
              37.147
            ],
            [
              -82.17,
              37.131
            ],
            [
              -82.172,
              37.12
            ],
            [
              -82.157,
              37.112
            ],
            [
              -82.16,
              37.103
            ],
            [
              -82.15,
              37.08
            ],
            [
              -82.137,
              37.063
            ],
            [
              -82.136,
              37.051
            ],
            [
              -82.149,
              37.041
            ]
          ]
        ]
      },
      "properties": {
        "name": "Dickenson County",
        "id": "51051",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51051"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.343,
              36.541
            ],
            [
              -79.399,
              36.541
            ],
            [
              -79.47,
              36.54
            ],
            [
              -79.471,
              36.558
            ],
            [
              -79.46,
              36.568
            ],
            [
              -79.457,
              36.578
            ],
            [
              -79.48,
              36.585
            ],
            [
              -79.495,
              36.584
            ],
            [
              -79.519,
              36.604
            ],
            [
              -79.499,
              36.618
            ],
            [
              -79.484,
              36.616
            ],
            [
              -79.445,
              36.607
            ],
            [
              -79.439,
              36.608
            ],
            [
              -79.431,
              36.599
            ],
            [
              -79.423,
              36.603
            ],
            [
              -79.406,
              36.63
            ],
            [
              -79.402,
              36.643
            ],
            [
              -79.393,
              36.642
            ],
            [
              -79.378,
              36.634
            ],
            [
              -79.37,
              36.635
            ],
            [
              -79.365,
              36.608
            ],
            [
              -79.354,
              36.609
            ],
            [
              -79.349,
              36.599
            ],
            [
              -79.331,
              36.602
            ],
            [
              -79.33,
              36.583
            ],
            [
              -79.304,
              36.582
            ],
            [
              -79.305,
              36.57
            ],
            [
              -79.32,
              36.574
            ],
            [
              -79.342,
              36.562
            ],
            [
              -79.351,
              36.548
            ],
            [
              -79.343,
              36.541
            ]
          ]
        ]
      },
      "properties": {
        "name": "Danville City",
        "id": "51590",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51590"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.076,
              37.655
            ],
            [
              -78.081,
              37.652
            ],
            [
              -78.132,
              37.456
            ],
            [
              -78.137,
              37.459
            ],
            [
              -78.159,
              37.453
            ],
            [
              -78.172,
              37.443
            ],
            [
              -78.183,
              37.445
            ],
            [
              -78.189,
              37.439
            ],
            [
              -78.188,
              37.431
            ],
            [
              -78.207,
              37.424
            ],
            [
              -78.214,
              37.404
            ],
            [
              -78.223,
              37.399
            ],
            [
              -78.231,
              37.385
            ],
            [
              -78.238,
              37.382
            ],
            [
              -78.239,
              37.367
            ],
            [
              -78.251,
              37.359
            ],
            [
              -78.264,
              37.358
            ],
            [
              -78.283,
              37.345
            ],
            [
              -78.298,
              37.328
            ],
            [
              -78.319,
              37.312
            ],
            [
              -78.328,
              37.309
            ],
            [
              -78.335,
              37.316
            ],
            [
              -78.349,
              37.318
            ],
            [
              -78.358,
              37.304
            ],
            [
              -78.366,
              37.31
            ],
            [
              -78.386,
              37.31
            ],
            [
              -78.396,
              37.307
            ],
            [
              -78.429,
              37.332
            ],
            [
              -78.457,
              37.337
            ],
            [
              -78.468,
              37.342
            ],
            [
              -78.251,
              37.634
            ],
            [
              -78.249,
              37.69
            ],
            [
              -78.238,
              37.693
            ],
            [
              -78.233,
              37.708
            ],
            [
              -78.21,
              37.727
            ],
            [
              -78.181,
              37.744
            ],
            [
              -78.163,
              37.745
            ],
            [
              -78.138,
              37.736
            ],
            [
              -78.128,
              37.725
            ],
            [
              -78.108,
              37.718
            ],
            [
              -78.095,
              37.703
            ],
            [
              -78.097,
              37.695
            ],
            [
              -78.117,
              37.679
            ],
            [
              -78.111,
              37.671
            ],
            [
              -78.089,
              37.668
            ],
            [
              -78.076,
              37.655
            ]
          ]
        ]
      },
      "properties": {
        "name": "Cumberland County",
        "id": "51049",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51049"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.634,
              38.409
            ],
            [
              -77.633,
              38.399
            ],
            [
              -77.619,
              38.383
            ],
            [
              -77.618,
              38.369
            ],
            [
              -77.63,
              38.367
            ],
            [
              -77.649,
              38.378
            ],
            [
              -77.673,
              38.37
            ],
            [
              -77.679,
              38.36
            ],
            [
              -77.697,
              38.357
            ],
            [
              -77.704,
              38.362
            ],
            [
              -77.721,
              38.37
            ],
            [
              -77.747,
              38.378
            ],
            [
              -77.747,
              38.383
            ],
            [
              -77.764,
              38.391
            ],
            [
              -77.778,
              38.39
            ],
            [
              -77.787,
              38.378
            ],
            [
              -77.782,
              38.366
            ],
            [
              -77.808,
              38.379
            ],
            [
              -77.829,
              38.383
            ],
            [
              -77.84,
              38.377
            ],
            [
              -77.849,
              38.383
            ],
            [
              -77.86,
              38.384
            ],
            [
              -77.881,
              38.38
            ],
            [
              -77.89,
              38.39
            ],
            [
              -77.907,
              38.383
            ],
            [
              -77.921,
              38.367
            ],
            [
              -77.949,
              38.362
            ],
            [
              -77.96,
              38.356
            ],
            [
              -77.976,
              38.358
            ],
            [
              -77.978,
              38.347
            ],
            [
              -77.99,
              38.35
            ],
            [
              -78.008,
              38.344
            ],
            [
              -78.019,
              38.336
            ],
            [
              -78.035,
              38.328
            ],
            [
              -78.042,
              38.314
            ],
            [
              -78.059,
              38.318
            ],
            [
              -78.069,
              38.312
            ],
            [
              -78.084,
              38.317
            ],
            [
              -78.097,
              38.314
            ],
            [
              -78.107,
              38.315
            ],
            [
              -78.098,
              38.328
            ],
            [
              -78.091,
              38.332
            ],
            [
              -78.095,
              38.342
            ],
            [
              -78.108,
              38.346
            ],
            [
              -78.119,
              38.363
            ],
            [
              -78.114,
              38.381
            ],
            [
              -78.096,
              38.393
            ],
            [
              -78.097,
              38.401
            ],
            [
              -78.107,
              38.416
            ],
            [
              -78.117,
              38.418
            ],
            [
              -78.128,
              38.431
            ],
            [
              -78.122,
              38.44
            ],
            [
              -78.132,
              38.447
            ],
            [
              -78.234,
              38.536
            ],
            [
              -78.217,
              38.537
            ],
            [
              -78.211,
              38.532
            ],
            [
              -78.177,
              38.522
            ],
            [
              -78.084,
              38.604
            ],
            [
              -78.03,
              38.64
            ],
            [
              -77.931,
              38.699
            ],
            [
              -77.908,
              38.697
            ],
            [
              -77.898,
              38.679
            ],
            [
              -77.904,
              38.671
            ],
            [
              -77.896,
              38.663
            ],
            [
              -77.885,
              38.667
            ],
            [
              -77.87,
              38.65
            ],
            [
              -77.877,
              38.636
            ],
            [
              -77.87,
              38.632
            ],
            [
              -77.861,
              38.616
            ],
            [
              -77.871,
              38.609
            ],
            [
              -77.864,
              38.598
            ],
            [
              -77.874,
              38.59
            ],
            [
              -77.858,
              38.562
            ],
            [
              -77.834,
              38.538
            ],
            [
              -77.826,
              38.538
            ],
            [
              -77.813,
              38.529
            ],
            [
              -77.802,
              38.512
            ],
            [
              -77.8,
              38.504
            ],
            [
              -77.782,
              38.487
            ],
            [
              -77.775,
              38.474
            ],
            [
              -77.776,
              38.468
            ],
            [
              -77.762,
              38.459
            ],
            [
              -77.762,
              38.443
            ],
            [
              -77.755,
              38.432
            ],
            [
              -77.742,
              38.425
            ],
            [
              -77.734,
              38.413
            ],
            [
              -77.716,
              38.421
            ],
            [
              -77.695,
              38.425
            ],
            [
              -77.679,
              38.425
            ],
            [
              -77.634,
              38.409
            ]
          ]
        ]
      },
      "properties": {
        "name": "Culpeper County",
        "id": "51047",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51047"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -80.086,
              37.418
            ],
            [
              -80.121,
              37.399
            ],
            [
              -80.159,
              37.382
            ],
            [
              -80.204,
              37.379
            ],
            [
              -80.214,
              37.371
            ],
            [
              -80.242,
              37.359
            ],
            [
              -80.263,
              37.342
            ],
            [
              -80.334,
              37.361
            ],
            [
              -80.356,
              37.348
            ],
            [
              -80.403,
              37.33
            ],
            [
              -80.428,
              37.319
            ],
            [
              -80.476,
              37.427
            ],
            [
              -80.45,
              37.433
            ],
            [
              -80.426,
              37.45
            ],
            [
              -80.403,
              37.462
            ],
            [
              -80.374,
              37.473
            ],
            [
              -80.365,
              37.485
            ],
            [
              -80.352,
              37.491
            ],
            [
              -80.318,
              37.5
            ],
            [
              -80.3,
              37.51
            ],
            [
              -80.282,
              37.534
            ],
            [
              -80.295,
              37.54
            ],
            [
              -80.307,
              37.529
            ],
            [
              -80.334,
              37.537
            ],
            [
              -80.313,
              37.546
            ],
            [
              -80.326,
              37.567
            ],
            [
              -80.275,
              37.589
            ],
            [
              -80.261,
              37.596
            ],
            [
              -80.236,
              37.613
            ],
            [
              -80.221,
              37.628
            ],
            [
              -80.203,
              37.618
            ],
            [
              -80.173,
              37.615
            ],
            [
              -80.15,
              37.601
            ],
            [
              -80.136,
              37.603
            ],
            [
              -80.103,
              37.626
            ],
            [
              -80.073,
              37.637
            ],
            [
              -80.036,
              37.659
            ],
            [
              -80.021,
              37.649
            ],
            [
              -80.034,
              37.635
            ],
            [
              -80.011,
              37.602
            ],
            [
              -79.986,
              37.572
            ],
            [
              -79.975,
              37.553
            ],
            [
              -79.973,
              37.544
            ],
            [
              -79.986,
              37.536
            ],
            [
              -80.01,
              37.512
            ],
            [
              -80.018,
              37.494
            ],
            [
              -80.025,
              37.484
            ],
            [
              -80.046,
              37.447
            ],
            [
              -80.071,
              37.427
            ],
            [
              -80.086,
              37.418
            ]
          ]
        ]
      },
      "properties": {
        "name": "Craig County",
        "id": "51045",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51045"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.977,
              37.754
            ],
            [
              -79.993,
              37.748
            ],
            [
              -80.007,
              37.762
            ],
            [
              -80,
              37.78
            ],
            [
              -79.998,
              37.806
            ],
            [
              -79.989,
              37.816
            ],
            [
              -79.983,
              37.812
            ],
            [
              -79.981,
              37.797
            ],
            [
              -79.973,
              37.782
            ],
            [
              -79.972,
              37.77
            ],
            [
              -79.977,
              37.754
            ]
          ]
        ]
      },
      "properties": {
        "name": "Covington City",
        "id": "51580",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51580"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.358,
              37.28
            ],
            [
              -77.368,
              37.273
            ],
            [
              -77.375,
              37.264
            ],
            [
              -77.377,
              37.245
            ],
            [
              -77.386,
              37.238
            ],
            [
              -77.402,
              37.239
            ],
            [
              -77.416,
              37.233
            ],
            [
              -77.416,
              37.253
            ],
            [
              -77.432,
              37.275
            ],
            [
              -77.427,
              37.283
            ],
            [
              -77.407,
              37.282
            ],
            [
              -77.391,
              37.287
            ],
            [
              -77.377,
              37.285
            ],
            [
              -77.374,
              37.295
            ],
            [
              -77.358,
              37.28
            ]
          ]
        ]
      },
      "properties": {
        "name": "Colonial Heights City",
        "id": "51570",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51570"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.961,
              39.015
            ],
            [
              -77.988,
              38.999
            ],
            [
              -78.005,
              38.982
            ],
            [
              -78.055,
              39.02
            ],
            [
              -78.094,
              39.014
            ],
            [
              -78.152,
              39.037
            ],
            [
              -78.139,
              39.058
            ],
            [
              -78.146,
              39.075
            ],
            [
              -78.135,
              39.074
            ],
            [
              -78.12,
              39.092
            ],
            [
              -78.108,
              39.099
            ],
            [
              -78.104,
              39.107
            ],
            [
              -78.107,
              39.117
            ],
            [
              -78.101,
              39.125
            ],
            [
              -78.085,
              39.166
            ],
            [
              -78.076,
              39.177
            ],
            [
              -78.076,
              39.188
            ],
            [
              -78.068,
              39.209
            ],
            [
              -78.053,
              39.231
            ],
            [
              -78.042,
              39.238
            ],
            [
              -78.038,
              39.254
            ],
            [
              -78.031,
              39.264
            ],
            [
              -77.953,
              39.215
            ],
            [
              -77.83,
              39.134
            ],
            [
              -77.833,
              39.127
            ],
            [
              -77.849,
              39.118
            ],
            [
              -77.855,
              39.109
            ],
            [
              -77.856,
              39.094
            ],
            [
              -77.862,
              39.085
            ],
            [
              -77.879,
              39.078
            ],
            [
              -77.899,
              39.054
            ],
            [
              -77.927,
              39.035
            ],
            [
              -77.942,
              39.022
            ],
            [
              -77.961,
              39.015
            ]
          ]
        ]
      },
      "properties": {
        "name": "Clarke County",
        "id": "51043",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": 106
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.42,
              37.448
            ],
            [
              -77.428,
              37.435
            ],
            [
              -77.419,
              37.423
            ],
            [
              -77.402,
              37.425
            ],
            [
              -77.397,
              37.418
            ],
            [
              -77.394,
              37.405
            ],
            [
              -77.383,
              37.397
            ],
            [
              -77.385,
              37.388
            ],
            [
              -77.378,
              37.383
            ],
            [
              -77.371,
              37.392
            ],
            [
              -77.362,
              37.389
            ],
            [
              -77.349,
              37.38
            ],
            [
              -77.324,
              37.379
            ],
            [
              -77.318,
              37.383
            ],
            [
              -77.308,
              37.406
            ],
            [
              -77.3,
              37.406
            ],
            [
              -77.297,
              37.392
            ],
            [
              -77.308,
              37.374
            ],
            [
              -77.307,
              37.363
            ],
            [
              -77.302,
              37.358
            ],
            [
              -77.283,
              37.353
            ],
            [
              -77.269,
              37.36
            ],
            [
              -77.271,
              37.375
            ],
            [
              -77.266,
              37.381
            ],
            [
              -77.251,
              37.381
            ],
            [
              -77.245,
              37.371
            ],
            [
              -77.254,
              37.354
            ],
            [
              -77.264,
              37.351
            ],
            [
              -77.27,
              37.348
            ],
            [
              -77.276,
              37.334
            ],
            [
              -77.293,
              37.328
            ],
            [
              -77.291,
              37.311
            ],
            [
              -77.322,
              37.308
            ],
            [
              -77.337,
              37.314
            ],
            [
              -77.351,
              37.312
            ],
            [
              -77.358,
              37.28
            ],
            [
              -77.374,
              37.295
            ],
            [
              -77.377,
              37.285
            ],
            [
              -77.391,
              37.287
            ],
            [
              -77.407,
              37.282
            ],
            [
              -77.427,
              37.283
            ],
            [
              -77.432,
              37.275
            ],
            [
              -77.416,
              37.253
            ],
            [
              -77.416,
              37.233
            ],
            [
              -77.433,
              37.226
            ],
            [
              -77.447,
              37.223
            ],
            [
              -77.473,
              37.227
            ],
            [
              -77.503,
              37.224
            ],
            [
              -77.511,
              37.218
            ],
            [
              -77.522,
              37.217
            ],
            [
              -77.543,
              37.227
            ],
            [
              -77.561,
              37.227
            ],
            [
              -77.573,
              37.239
            ],
            [
              -77.597,
              37.251
            ],
            [
              -77.61,
              37.269
            ],
            [
              -77.618,
              37.272
            ],
            [
              -77.651,
              37.267
            ],
            [
              -77.665,
              37.281
            ],
            [
              -77.668,
              37.291
            ],
            [
              -77.677,
              37.295
            ],
            [
              -77.696,
              37.284
            ],
            [
              -77.708,
              37.3
            ],
            [
              -77.719,
              37.297
            ],
            [
              -77.719,
              37.286
            ],
            [
              -77.738,
              37.285
            ],
            [
              -77.743,
              37.27
            ],
            [
              -77.757,
              37.269
            ],
            [
              -77.77,
              37.277
            ],
            [
              -77.774,
              37.287
            ],
            [
              -77.784,
              37.295
            ],
            [
              -77.804,
              37.303
            ],
            [
              -77.809,
              37.313
            ],
            [
              -77.801,
              37.322
            ],
            [
              -77.8,
              37.333
            ],
            [
              -77.818,
              37.339
            ],
            [
              -77.842,
              37.34
            ],
            [
              -77.852,
              37.345
            ],
            [
              -77.854,
              37.358
            ],
            [
              -77.864,
              37.364
            ],
            [
              -77.879,
              37.366
            ],
            [
              -77.879,
              37.384
            ],
            [
              -77.871,
              37.395
            ],
            [
              -77.877,
              37.415
            ],
            [
              -77.858,
              37.419
            ],
            [
              -77.849,
              37.418
            ],
            [
              -77.838,
              37.423
            ],
            [
              -77.822,
              37.423
            ],
            [
              -77.81,
              37.428
            ],
            [
              -77.801,
              37.446
            ],
            [
              -77.799,
              37.461
            ],
            [
              -77.656,
              37.566
            ],
            [
              -77.628,
              37.559
            ],
            [
              -77.595,
              37.556
            ],
            [
              -77.602,
              37.545
            ],
            [
              -77.595,
              37.533
            ],
            [
              -77.573,
              37.533
            ],
            [
              -77.553,
              37.542
            ],
            [
              -77.545,
              37.528
            ],
            [
              -77.528,
              37.532
            ],
            [
              -77.527,
              37.506
            ],
            [
              -77.51,
              37.47
            ],
            [
              -77.487,
              37.459
            ],
            [
              -77.46,
              37.464
            ],
            [
              -77.434,
              37.457
            ],
            [
              -77.42,
              37.448
            ]
          ]
        ]
      },
      "properties": {
        "name": "Chesterfield County",
        "id": "51041",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51041"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.403,
              36.82
            ],
            [
              -76.405,
              36.818
            ],
            [
              -76.387,
              36.8
            ],
            [
              -76.376,
              36.786
            ],
            [
              -76.336,
              36.792
            ],
            [
              -76.302,
              36.799
            ],
            [
              -76.292,
              36.8
            ],
            [
              -76.29,
              36.823
            ],
            [
              -76.275,
              36.828
            ],
            [
              -76.258,
              36.821
            ],
            [
              -76.246,
              36.833
            ],
            [
              -76.234,
              36.838
            ],
            [
              -76.222,
              36.837
            ],
            [
              -76.225,
              36.829
            ],
            [
              -76.202,
              36.771
            ],
            [
              -76.191,
              36.767
            ],
            [
              -76.144,
              36.758
            ],
            [
              -76.101,
              36.717
            ],
            [
              -76.088,
              36.714
            ],
            [
              -76.069,
              36.696
            ],
            [
              -76.075,
              36.683
            ],
            [
              -76.103,
              36.675
            ],
            [
              -76.111,
              36.669
            ],
            [
              -76.122,
              36.668
            ],
            [
              -76.122,
              36.55
            ],
            [
              -76.241,
              36.55
            ],
            [
              -76.491,
              36.55
            ],
            [
              -76.472,
              36.7
            ],
            [
              -76.463,
              36.769
            ],
            [
              -76.461,
              36.815
            ],
            [
              -76.434,
              36.859
            ],
            [
              -76.428,
              36.866
            ],
            [
              -76.398,
              36.866
            ],
            [
              -76.388,
              36.848
            ],
            [
              -76.388,
              36.841
            ],
            [
              -76.4,
              36.835
            ],
            [
              -76.403,
              36.82
            ]
          ]
        ]
      },
      "properties": {
        "name": "Chesapeake City",
        "id": "51550",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51550"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.47,
              38.055
            ],
            [
              -78.456,
              38.054
            ],
            [
              -78.452,
              38.029
            ],
            [
              -78.471,
              38.012
            ],
            [
              -78.487,
              38.015
            ],
            [
              -78.492,
              38.008
            ],
            [
              -78.519,
              38.011
            ],
            [
              -78.524,
              38.018
            ],
            [
              -78.517,
              38.042
            ],
            [
              -78.508,
              38.056
            ],
            [
              -78.485,
              38.069
            ],
            [
              -78.471,
              38.071
            ],
            [
              -78.465,
              38.064
            ],
            [
              -78.47,
              38.055
            ]
          ]
        ]
      },
      "properties": {
        "name": "Charlottesville City",
        "id": "51540",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51540"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.447,
              37.079
            ],
            [
              -78.493,
              36.892
            ],
            [
              -78.495,
              36.889
            ],
            [
              -78.646,
              36.7
            ],
            [
              -78.661,
              36.708
            ],
            [
              -78.693,
              36.742
            ],
            [
              -78.683,
              36.757
            ],
            [
              -78.671,
              36.762
            ],
            [
              -78.671,
              36.772
            ],
            [
              -78.684,
              36.792
            ],
            [
              -78.67,
              36.815
            ],
            [
              -78.684,
              36.823
            ],
            [
              -78.688,
              36.832
            ],
            [
              -78.667,
              36.841
            ],
            [
              -78.668,
              36.851
            ],
            [
              -78.674,
              36.86
            ],
            [
              -78.689,
              36.865
            ],
            [
              -78.695,
              36.878
            ],
            [
              -78.733,
              36.912
            ],
            [
              -78.753,
              36.921
            ],
            [
              -78.751,
              36.93
            ],
            [
              -78.735,
              36.934
            ],
            [
              -78.731,
              36.943
            ],
            [
              -78.741,
              36.958
            ],
            [
              -78.74,
              36.98
            ],
            [
              -78.746,
              37.005
            ],
            [
              -78.758,
              37.006
            ],
            [
              -78.763,
              37.002
            ],
            [
              -78.751,
              36.994
            ],
            [
              -78.757,
              36.987
            ],
            [
              -78.769,
              36.989
            ],
            [
              -78.776,
              36.984
            ],
            [
              -78.776,
              36.96
            ],
            [
              -78.782,
              36.955
            ],
            [
              -78.795,
              36.958
            ],
            [
              -78.799,
              36.969
            ],
            [
              -78.815,
              36.984
            ],
            [
              -78.87,
              36.986
            ],
            [
              -78.89,
              36.977
            ],
            [
              -78.901,
              36.985
            ],
            [
              -78.892,
              37.004
            ],
            [
              -78.909,
              37.012
            ],
            [
              -78.904,
              37.022
            ],
            [
              -78.826,
              37.203
            ],
            [
              -78.811,
              37.198
            ],
            [
              -78.785,
              37.22
            ],
            [
              -78.77,
              37.223
            ],
            [
              -78.758,
              37.219
            ],
            [
              -78.735,
              37.222
            ],
            [
              -78.726,
              37.235
            ],
            [
              -78.707,
              37.24
            ],
            [
              -78.685,
              37.252
            ],
            [
              -78.686,
              37.243
            ],
            [
              -78.694,
              37.212
            ],
            [
              -78.695,
              37.2
            ],
            [
              -78.69,
              37.192
            ],
            [
              -78.679,
              37.197
            ],
            [
              -78.649,
              37.193
            ],
            [
              -78.64,
              37.184
            ],
            [
              -78.639,
              37.173
            ],
            [
              -78.622,
              37.161
            ],
            [
              -78.586,
              37.141
            ],
            [
              -78.563,
              37.153
            ],
            [
              -78.553,
              37.152
            ],
            [
              -78.517,
              37.136
            ],
            [
              -78.512,
              37.131
            ],
            [
              -78.507,
              37.111
            ],
            [
              -78.491,
              37.093
            ],
            [
              -78.481,
              37.087
            ],
            [
              -78.463,
              37.084
            ],
            [
              -78.447,
              37.079
            ]
          ]
        ]
      },
      "properties": {
        "name": "Charlotte County",
        "id": "51037",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51037"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -76.904,
              37.378
            ],
            [
              -76.916,
              37.354
            ],
            [
              -76.909,
              37.351
            ],
            [
              -76.9,
              37.361
            ],
            [
              -76.886,
              37.37
            ],
            [
              -76.875,
              37.369
            ],
            [
              -76.872,
              37.363
            ],
            [
              -76.88,
              37.353
            ],
            [
              -76.874,
              37.344
            ],
            [
              -76.876,
              37.326
            ],
            [
              -76.885,
              37.312
            ],
            [
              -76.878,
              37.297
            ],
            [
              -76.884,
              37.283
            ],
            [
              -76.884,
              37.269
            ],
            [
              -76.879,
              37.26
            ],
            [
              -76.884,
              37.254
            ],
            [
              -76.895,
              37.252
            ],
            [
              -76.898,
              37.246
            ],
            [
              -76.911,
              37.245
            ],
            [
              -76.917,
              37.235
            ],
            [
              -76.94,
              37.24
            ],
            [
              -76.96,
              37.252
            ],
            [
              -76.983,
              37.279
            ],
            [
              -76.985,
              37.295
            ],
            [
              -76.99,
              37.304
            ],
            [
              -77.011,
              37.317
            ],
            [
              -77.038,
              37.303
            ],
            [
              -77.068,
              37.281
            ],
            [
              -77.077,
              37.282
            ],
            [
              -77.079,
              37.298
            ],
            [
              -77.077,
              37.311
            ],
            [
              -77.081,
              37.32
            ],
            [
              -77.117,
              37.318
            ],
            [
              -77.127,
              37.312
            ],
            [
              -77.161,
              37.311
            ],
            [
              -77.183,
              37.314
            ],
            [
              -77.203,
              37.328
            ],
            [
              -77.23,
              37.327
            ],
            [
              -77.26,
              37.32
            ],
            [
              -77.266,
              37.326
            ],
            [
              -77.261,
              37.333
            ],
            [
              -77.264,
              37.351
            ],
            [
              -77.254,
              37.354
            ],
            [
              -77.245,
              37.371
            ],
            [
              -77.251,
              37.381
            ],
            [
              -77.244,
              37.394
            ],
            [
              -77.234,
              37.383
            ],
            [
              -77.224,
              37.383
            ],
            [
              -77.217,
              37.389
            ],
            [
              -77.228,
              37.407
            ],
            [
              -77.179,
              37.493
            ],
            [
              -77.17,
              37.484
            ],
            [
              -77.159,
              37.487
            ],
            [
              -77.139,
              37.473
            ],
            [
              -77.128,
              37.473
            ],
            [
              -77.116,
              37.456
            ],
            [
              -77.107,
              37.454
            ],
            [
              -77.094,
              37.443
            ],
            [
              -77.07,
              37.441
            ],
            [
              -77.06,
              37.431
            ],
            [
              -77.026,
              37.429
            ],
            [
              -77.019,
              37.416
            ],
            [
              -77.005,
              37.413
            ],
            [
              -76.998,
              37.419
            ],
            [
              -76.981,
              37.421
            ],
            [
              -76.969,
              37.419
            ],
            [
              -76.965,
              37.408
            ],
            [
              -76.95,
              37.407
            ],
            [
              -76.94,
              37.411
            ],
            [
              -76.935,
              37.403
            ],
            [
              -76.946,
              37.398
            ],
            [
              -76.943,
              37.385
            ],
            [
              -76.934,
              37.389
            ],
            [
              -76.926,
              37.401
            ],
            [
              -76.906,
              37.395
            ],
            [
              -76.917,
              37.387
            ],
            [
              -76.904,
              37.378
            ]
          ]
        ]
      },
      "properties": {
        "name": "Charles City County",
        "id": "51036",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51036"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -80.634,
              36.932
            ],
            [
              -80.466,
              36.711
            ],
            [
              -80.464,
              36.71
            ],
            [
              -80.454,
              36.701
            ],
            [
              -80.461,
              36.692
            ],
            [
              -80.466,
              36.674
            ],
            [
              -80.489,
              36.662
            ],
            [
              -80.494,
              36.653
            ],
            [
              -80.505,
              36.656
            ],
            [
              -80.514,
              36.651
            ],
            [
              -80.526,
              36.655
            ],
            [
              -80.529,
              36.646
            ],
            [
              -80.54,
              36.641
            ],
            [
              -80.549,
              36.644
            ],
            [
              -80.552,
              36.652
            ],
            [
              -80.571,
              36.658
            ],
            [
              -80.59,
              36.658
            ],
            [
              -80.604,
              36.649
            ],
            [
              -80.604,
              36.638
            ],
            [
              -80.622,
              36.62
            ],
            [
              -80.619,
              36.612
            ],
            [
              -80.626,
              36.606
            ],
            [
              -80.623,
              36.591
            ],
            [
              -80.615,
              36.589
            ],
            [
              -80.612,
              36.557
            ],
            [
              -80.652,
              36.558
            ],
            [
              -80.838,
              36.56
            ],
            [
              -80.914,
              36.65
            ],
            [
              -80.902,
              36.661
            ],
            [
              -80.877,
              36.692
            ],
            [
              -80.889,
              36.697
            ],
            [
              -80.916,
              36.694
            ],
            [
              -80.93,
              36.679
            ],
            [
              -80.931,
              36.67
            ],
            [
              -80.989,
              36.74
            ],
            [
              -81.047,
              36.807
            ],
            [
              -81.036,
              36.814
            ],
            [
              -81.015,
              36.811
            ],
            [
              -80.855,
              36.85
            ],
            [
              -80.843,
              36.85
            ],
            [
              -80.82,
              36.855
            ],
            [
              -80.792,
              36.865
            ],
            [
              -80.737,
              36.882
            ],
            [
              -80.733,
              36.884
            ],
            [
              -80.699,
              36.879
            ],
            [
              -80.698,
              36.885
            ],
            [
              -80.683,
              36.896
            ],
            [
              -80.683,
              36.91
            ],
            [
              -80.669,
              36.911
            ],
            [
              -80.652,
              36.923
            ],
            [
              -80.634,
              36.932
            ]
          ]
        ]
      },
      "properties": {
        "name": "Carroll County",
        "id": "51035",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51035"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.203,
              38.187
            ],
            [
              -77.2,
              38.181
            ],
            [
              -77.176,
              38.163
            ],
            [
              -77.162,
              38.161
            ],
            [
              -77.149,
              38.168
            ],
            [
              -77.134,
              38.159
            ],
            [
              -77.126,
              38.137
            ],
            [
              -77.115,
              38.134
            ],
            [
              -77.107,
              38.126
            ],
            [
              -77.12,
              38.121
            ],
            [
              -77.143,
              38.123
            ],
            [
              -77.146,
              38.119
            ],
            [
              -77.146,
              38.1
            ],
            [
              -77.152,
              38.091
            ],
            [
              -77.169,
              38.078
            ],
            [
              -77.16,
              38.065
            ],
            [
              -77.138,
              38.049
            ],
            [
              -77.128,
              38.038
            ],
            [
              -77.134,
              38.024
            ],
            [
              -77.124,
              38.014
            ],
            [
              -77.088,
              38.012
            ],
            [
              -77.079,
              38
            ],
            [
              -77.079,
              37.991
            ],
            [
              -77.073,
              37.98
            ],
            [
              -77.073,
              37.968
            ],
            [
              -77.097,
              37.966
            ],
            [
              -77.115,
              37.972
            ],
            [
              -77.151,
              37.972
            ],
            [
              -77.159,
              37.966
            ],
            [
              -77.169,
              37.965
            ],
            [
              -77.182,
              37.951
            ],
            [
              -77.185,
              37.942
            ],
            [
              -77.181,
              37.935
            ],
            [
              -77.188,
              37.91
            ],
            [
              -77.186,
              37.899
            ],
            [
              -77.18,
              37.892
            ],
            [
              -77.216,
              37.891
            ],
            [
              -77.212,
              37.899
            ],
            [
              -77.219,
              37.905
            ],
            [
              -77.245,
              37.906
            ],
            [
              -77.249,
              37.88
            ],
            [
              -77.254,
              37.874
            ],
            [
              -77.271,
              37.865
            ],
            [
              -77.275,
              37.856
            ],
            [
              -77.285,
              37.848
            ],
            [
              -77.298,
              37.827
            ],
            [
              -77.329,
              37.81
            ],
            [
              -77.343,
              37.8
            ],
            [
              -77.349,
              37.788
            ],
            [
              -77.364,
              37.795
            ],
            [
              -77.381,
              37.775
            ],
            [
              -77.403,
              37.78
            ],
            [
              -77.396,
              37.803
            ],
            [
              -77.408,
              37.804
            ],
            [
              -77.421,
              37.809
            ],
            [
              -77.41,
              37.819
            ],
            [
              -77.413,
              37.824
            ],
            [
              -77.425,
              37.828
            ],
            [
              -77.429,
              37.854
            ],
            [
              -77.418,
              37.863
            ],
            [
              -77.429,
              37.871
            ],
            [
              -77.446,
              37.894
            ],
            [
              -77.472,
              37.889
            ],
            [
              -77.481,
              37.884
            ],
            [
              -77.494,
              37.891
            ],
            [
              -77.495,
              37.898
            ],
            [
              -77.523,
              37.911
            ],
            [
              -77.53,
              37.921
            ],
            [
              -77.544,
              37.917
            ],
            [
              -77.558,
              37.924
            ],
            [
              -77.548,
              37.929
            ],
            [
              -77.562,
              37.937
            ],
            [
              -77.569,
              37.955
            ],
            [
              -77.58,
              37.956
            ],
            [
              -77.592,
              37.95
            ],
            [
              -77.615,
              37.958
            ],
            [
              -77.619,
              37.965
            ],
            [
              -77.643,
              37.981
            ],
            [
              -77.643,
              37.992
            ],
            [
              -77.64,
              37.995
            ],
            [
              -77.367,
              38.244
            ],
            [
              -77.36,
              38.243
            ],
            [
              -77.345,
              38.252
            ],
            [
              -77.328,
              38.245
            ],
            [
              -77.308,
              38.235
            ],
            [
              -77.296,
              38.243
            ],
            [
              -77.291,
              38.237
            ],
            [
              -77.294,
              38.226
            ],
            [
              -77.278,
              38.225
            ],
            [
              -77.277,
              38.244
            ],
            [
              -77.27,
              38.25
            ],
            [
              -77.252,
              38.251
            ],
            [
              -77.244,
              38.245
            ],
            [
              -77.225,
              38.243
            ],
            [
              -77.228,
              38.236
            ],
            [
              -77.252,
              38.23
            ],
            [
              -77.242,
              38.211
            ],
            [
              -77.254,
              38.195
            ],
            [
              -77.25,
              38.188
            ],
            [
              -77.239,
              38.186
            ],
            [
              -77.229,
              38.189
            ],
            [
              -77.228,
              38.2
            ],
            [
              -77.216,
              38.198
            ],
            [
              -77.203,
              38.187
            ]
          ]
        ]
      },
      "properties": {
        "name": "Caroline County",
        "id": "51033",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51033"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.023,
              37.432
            ],
            [
              -78.986,
              37.36
            ],
            [
              -78.943,
              37.282
            ],
            [
              -78.929,
              37.276
            ],
            [
              -78.925,
              37.264
            ],
            [
              -78.926,
              37.246
            ],
            [
              -78.912,
              37.243
            ],
            [
              -78.89,
              37.246
            ],
            [
              -78.874,
              37.242
            ],
            [
              -78.861,
              37.235
            ],
            [
              -78.862,
              37.214
            ],
            [
              -78.826,
              37.203
            ],
            [
              -78.904,
              37.022
            ],
            [
              -78.922,
              37.026
            ],
            [
              -78.935,
              37.035
            ],
            [
              -78.969,
              37.046
            ],
            [
              -78.974,
              37.05
            ],
            [
              -79.003,
              37.03
            ],
            [
              -79.015,
              37.039
            ],
            [
              -79.039,
              37.045
            ],
            [
              -79.055,
              37.045
            ],
            [
              -79.092,
              37.061
            ],
            [
              -79.112,
              37.065
            ],
            [
              -79.12,
              37.079
            ],
            [
              -79.137,
              37.081
            ],
            [
              -79.163,
              37.066
            ],
            [
              -79.174,
              37.065
            ],
            [
              -79.185,
              37.075
            ],
            [
              -79.195,
              37.063
            ],
            [
              -79.203,
              37.065
            ],
            [
              -79.207,
              37.077
            ],
            [
              -79.203,
              37.111
            ],
            [
              -79.21,
              37.12
            ],
            [
              -79.218,
              37.12
            ],
            [
              -79.223,
              37.113
            ],
            [
              -79.221,
              37.101
            ],
            [
              -79.234,
              37.103
            ],
            [
              -79.234,
              37.118
            ],
            [
              -79.254,
              37.134
            ],
            [
              -79.267,
              37.124
            ],
            [
              -79.275,
              37.11
            ],
            [
              -79.293,
              37.107
            ],
            [
              -79.3,
              37.109
            ],
            [
              -79.329,
              37.128
            ],
            [
              -79.336,
              37.136
            ],
            [
              -79.347,
              37.127
            ],
            [
              -79.363,
              37.122
            ],
            [
              -79.377,
              37.124
            ],
            [
              -79.379,
              37.116
            ],
            [
              -79.368,
              37.11
            ],
            [
              -79.375,
              37.102
            ],
            [
              -79.401,
              37.095
            ],
            [
              -79.401,
              37.074
            ],
            [
              -79.404,
              37.068
            ],
            [
              -79.416,
              37.064
            ],
            [
              -79.427,
              37.064
            ],
            [
              -79.441,
              37.06
            ],
            [
              -79.258,
              37.355
            ],
            [
              -79.255,
              37.351
            ],
            [
              -79.214,
              37.333
            ],
            [
              -79.206,
              37.341
            ],
            [
              -79.195,
              37.344
            ],
            [
              -79.176,
              37.341
            ],
            [
              -79.157,
              37.359
            ],
            [
              -79.135,
              37.376
            ],
            [
              -79.119,
              37.368
            ],
            [
              -79.102,
              37.377
            ],
            [
              -79.085,
              37.396
            ],
            [
              -79.072,
              37.389
            ],
            [
              -79.062,
              37.397
            ],
            [
              -79.071,
              37.422
            ],
            [
              -79.065,
              37.424
            ],
            [
              -79.051,
              37.418
            ],
            [
              -79.042,
              37.421
            ],
            [
              -79.039,
              37.435
            ],
            [
              -79.023,
              37.432
            ]
          ]
        ]
      },
      "properties": {
        "name": "Campbell County",
        "id": "51031",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51031"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.361,
              37.751
            ],
            [
              -79.349,
              37.755
            ],
            [
              -79.343,
              37.762
            ],
            [
              -79.329,
              37.76
            ],
            [
              -79.333,
              37.738
            ],
            [
              -79.339,
              37.732
            ],
            [
              -79.36,
              37.703
            ],
            [
              -79.373,
              37.697
            ],
            [
              -79.383,
              37.706
            ],
            [
              -79.375,
              37.712
            ],
            [
              -79.378,
              37.727
            ],
            [
              -79.372,
              37.746
            ],
            [
              -79.361,
              37.751
            ]
          ]
        ]
      },
      "properties": {
        "name": "Buena Vista City",
        "id": "51530",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51530"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.249,
              37.69
            ],
            [
              -78.251,
              37.634
            ],
            [
              -78.468,
              37.342
            ],
            [
              -78.479,
              37.338
            ],
            [
              -78.513,
              37.335
            ],
            [
              -78.523,
              37.344
            ],
            [
              -78.539,
              37.353
            ],
            [
              -78.558,
              37.356
            ],
            [
              -78.561,
              37.369
            ],
            [
              -78.572,
              37.379
            ],
            [
              -78.585,
              37.385
            ],
            [
              -78.584,
              37.392
            ],
            [
              -78.591,
              37.4
            ],
            [
              -78.602,
              37.403
            ],
            [
              -78.615,
              37.389
            ],
            [
              -78.627,
              37.388
            ],
            [
              -78.642,
              37.402
            ],
            [
              -78.643,
              37.419
            ],
            [
              -78.679,
              37.427
            ],
            [
              -78.7,
              37.45
            ],
            [
              -78.829,
              37.558
            ],
            [
              -78.824,
              37.57
            ],
            [
              -78.837,
              37.583
            ],
            [
              -78.838,
              37.591
            ],
            [
              -78.82,
              37.6
            ],
            [
              -78.816,
              37.608
            ],
            [
              -78.825,
              37.617
            ],
            [
              -78.83,
              37.628
            ],
            [
              -78.819,
              37.638
            ],
            [
              -78.803,
              37.644
            ],
            [
              -78.779,
              37.639
            ],
            [
              -78.736,
              37.636
            ],
            [
              -78.724,
              37.642
            ],
            [
              -78.726,
              37.66
            ],
            [
              -78.717,
              37.671
            ],
            [
              -78.699,
              37.676
            ],
            [
              -78.702,
              37.695
            ],
            [
              -78.692,
              37.698
            ],
            [
              -78.677,
              37.691
            ],
            [
              -78.67,
              37.681
            ],
            [
              -78.659,
              37.68
            ],
            [
              -78.651,
              37.687
            ],
            [
              -78.663,
              37.701
            ],
            [
              -78.663,
              37.71
            ],
            [
              -78.652,
              37.729
            ],
            [
              -78.643,
              37.738
            ],
            [
              -78.611,
              37.756
            ],
            [
              -78.589,
              37.756
            ],
            [
              -78.548,
              37.765
            ],
            [
              -78.523,
              37.76
            ],
            [
              -78.503,
              37.76
            ],
            [
              -78.497,
              37.769
            ],
            [
              -78.499,
              37.787
            ],
            [
              -78.49,
              37.792
            ],
            [
              -78.485,
              37.79
            ],
            [
              -78.476,
              37.771
            ],
            [
              -78.459,
              37.758
            ],
            [
              -78.44,
              37.748
            ],
            [
              -78.403,
              37.736
            ],
            [
              -78.361,
              37.731
            ],
            [
              -78.341,
              37.72
            ],
            [
              -78.284,
              37.708
            ],
            [
              -78.275,
              37.7
            ],
            [
              -78.249,
              37.69
            ]
          ]
        ]
      },
      "properties": {
        "name": "Buckingham County",
        "id": "51029",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51029"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -81.741,
              37.24
            ],
            [
              -81.744,
              37.224
            ],
            [
              -81.756,
              37.218
            ],
            [
              -81.759,
              37.204
            ],
            [
              -81.781,
              37.199
            ],
            [
              -81.789,
              37.189
            ],
            [
              -81.823,
              37.179
            ],
            [
              -81.832,
              37.179
            ],
            [
              -81.846,
              37.173
            ],
            [
              -81.856,
              37.172
            ],
            [
              -81.872,
              37.165
            ],
            [
              -81.869,
              37.155
            ],
            [
              -81.896,
              37.151
            ],
            [
              -81.904,
              37.142
            ],
            [
              -81.914,
              37.134
            ],
            [
              -81.935,
              37.129
            ],
            [
              -81.946,
              37.131
            ],
            [
              -81.961,
              37.127
            ],
            [
              -81.977,
              37.119
            ],
            [
              -81.992,
              37.125
            ],
            [
              -82.008,
              37.117
            ],
            [
              -82.02,
              37.087
            ],
            [
              -82.019,
              37.069
            ],
            [
              -82.03,
              37.064
            ],
            [
              -82.036,
              37.053
            ],
            [
              -82.049,
              37.046
            ],
            [
              -82.064,
              37.045
            ],
            [
              -82.075,
              37.039
            ],
            [
              -82.102,
              37.051
            ],
            [
              -82.113,
              37.04
            ],
            [
              -82.134,
              37.043
            ],
            [
              -82.149,
              37.041
            ],
            [
              -82.136,
              37.051
            ],
            [
              -82.137,
              37.063
            ],
            [
              -82.15,
              37.08
            ],
            [
              -82.16,
              37.103
            ],
            [
              -82.157,
              37.112
            ],
            [
              -82.172,
              37.12
            ],
            [
              -82.17,
              37.131
            ],
            [
              -82.185,
              37.147
            ],
            [
              -82.187,
              37.156
            ],
            [
              -82.199,
              37.157
            ],
            [
              -82.23,
              37.202
            ],
            [
              -82.234,
              37.224
            ],
            [
              -82.251,
              37.273
            ],
            [
              -82.269,
              37.284
            ],
            [
              -82.271,
              37.29
            ],
            [
              -82.298,
              37.307
            ],
            [
              -82.093,
              37.45
            ],
            [
              -81.967,
              37.537
            ],
            [
              -81.959,
              37.538
            ],
            [
              -81.937,
              37.516
            ],
            [
              -81.928,
              37.514
            ],
            [
              -81.951,
              37.501
            ],
            [
              -81.952,
              37.492
            ],
            [
              -81.966,
              37.492
            ],
            [
              -81.988,
              37.484
            ],
            [
              -81.995,
              37.471
            ],
            [
              -81.985,
              37.457
            ],
            [
              -81.972,
              37.453
            ],
            [
              -81.967,
              37.447
            ],
            [
              -81.957,
              37.447
            ],
            [
              -81.937,
              37.439
            ],
            [
              -81.935,
              37.42
            ],
            [
              -81.925,
              37.411
            ],
            [
              -81.929,
              37.404
            ],
            [
              -81.934,
              37.38
            ],
            [
              -81.926,
              37.361
            ],
            [
              -81.911,
              37.348
            ],
            [
              -81.898,
              37.334
            ],
            [
              -81.89,
              37.329
            ],
            [
              -81.879,
              37.33
            ],
            [
              -81.864,
              37.317
            ],
            [
              -81.865,
              37.308
            ],
            [
              -81.854,
              37.302
            ],
            [
              -81.85,
              37.287
            ],
            [
              -81.82,
              37.278
            ],
            [
              -81.798,
              37.284
            ],
            [
              -81.773,
              37.275
            ],
            [
              -81.76,
              37.274
            ],
            [
              -81.746,
              37.258
            ],
            [
              -81.741,
              37.24
            ]
          ]
        ]
      },
      "properties": {
        "name": "Buchanan County",
        "id": "51027",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51027"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.894,
              36.989
            ],
            [
              -77.885,
              36.992
            ],
            [
              -77.859,
              36.989
            ],
            [
              -77.84,
              36.996
            ],
            [
              -77.819,
              36.989
            ],
            [
              -77.815,
              36.984
            ],
            [
              -77.802,
              36.985
            ],
            [
              -77.783,
              36.976
            ],
            [
              -77.765,
              36.972
            ],
            [
              -77.759,
              36.958
            ],
            [
              -77.74,
              36.952
            ],
            [
              -77.719,
              36.93
            ],
            [
              -77.719,
              36.916
            ],
            [
              -77.703,
              36.915
            ],
            [
              -77.696,
              36.906
            ],
            [
              -77.676,
              36.902
            ],
            [
              -77.66,
              36.893
            ],
            [
              -77.658,
              36.713
            ],
            [
              -77.665,
              36.7
            ],
            [
              -77.767,
              36.546
            ],
            [
              -77.91,
              36.546
            ],
            [
              -78.049,
              36.546
            ],
            [
              -78.03,
              36.779
            ],
            [
              -78.009,
              37.018
            ],
            [
              -77.999,
              37.017
            ],
            [
              -77.98,
              37
            ],
            [
              -77.97,
              36.989
            ],
            [
              -77.957,
              36.991
            ],
            [
              -77.945,
              36.987
            ],
            [
              -77.913,
              36.985
            ],
            [
              -77.894,
              36.989
            ]
          ]
        ]
      },
      "properties": {
        "name": "Brunswick County",
        "id": "51025",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51025"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -82.145,
              36.595
            ],
            [
              -82.23,
              36.596
            ],
            [
              -82.237,
              36.597
            ],
            [
              -82.188,
              36.623
            ],
            [
              -82.158,
              36.63
            ],
            [
              -82.14,
              36.637
            ],
            [
              -82.114,
              36.638
            ],
            [
              -82.106,
              36.629
            ],
            [
              -82.128,
              36.612
            ],
            [
              -82.145,
              36.595
            ]
          ]
        ]
      },
      "properties": {
        "name": "Bristol City",
        "id": "51520",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51520"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.849,
              37.31
            ],
            [
              -79.865,
              37.329
            ],
            [
              -79.962,
              37.371
            ],
            [
              -80.086,
              37.418
            ],
            [
              -80.071,
              37.427
            ],
            [
              -80.046,
              37.447
            ],
            [
              -80.025,
              37.484
            ],
            [
              -80.018,
              37.494
            ],
            [
              -80.01,
              37.512
            ],
            [
              -79.986,
              37.536
            ],
            [
              -79.973,
              37.544
            ],
            [
              -79.975,
              37.553
            ],
            [
              -79.986,
              37.572
            ],
            [
              -80.011,
              37.602
            ],
            [
              -80.034,
              37.635
            ],
            [
              -80.021,
              37.649
            ],
            [
              -79.992,
              37.664
            ],
            [
              -79.973,
              37.678
            ],
            [
              -79.958,
              37.684
            ],
            [
              -79.944,
              37.697
            ],
            [
              -79.92,
              37.703
            ],
            [
              -79.897,
              37.733
            ],
            [
              -79.872,
              37.748
            ],
            [
              -79.854,
              37.764
            ],
            [
              -79.845,
              37.784
            ],
            [
              -79.817,
              37.801
            ],
            [
              -79.674,
              37.764
            ],
            [
              -79.679,
              37.745
            ],
            [
              -79.684,
              37.74
            ],
            [
              -79.675,
              37.704
            ],
            [
              -79.668,
              37.699
            ],
            [
              -79.675,
              37.675
            ],
            [
              -79.683,
              37.666
            ],
            [
              -79.571,
              37.599
            ],
            [
              -79.579,
              37.582
            ],
            [
              -79.5,
              37.536
            ],
            [
              -79.503,
              37.521
            ],
            [
              -79.536,
              37.506
            ],
            [
              -79.541,
              37.497
            ],
            [
              -79.56,
              37.497
            ],
            [
              -79.582,
              37.474
            ],
            [
              -79.583,
              37.456
            ],
            [
              -79.593,
              37.452
            ],
            [
              -79.619,
              37.459
            ],
            [
              -79.624,
              37.457
            ],
            [
              -79.641,
              37.477
            ],
            [
              -79.654,
              37.486
            ],
            [
              -79.675,
              37.489
            ],
            [
              -79.69,
              37.48
            ],
            [
              -79.72,
              37.451
            ],
            [
              -79.766,
              37.424
            ],
            [
              -79.781,
              37.417
            ],
            [
              -79.813,
              37.407
            ],
            [
              -79.815,
              37.399
            ],
            [
              -79.81,
              37.391
            ],
            [
              -79.796,
              37.385
            ],
            [
              -79.784,
              37.384
            ],
            [
              -79.778,
              37.378
            ],
            [
              -79.788,
              37.364
            ],
            [
              -79.795,
              37.348
            ],
            [
              -79.807,
              37.342
            ],
            [
              -79.818,
              37.332
            ],
            [
              -79.833,
              37.326
            ],
            [
              -79.846,
              37.316
            ],
            [
              -79.849,
              37.31
            ]
          ]
        ]
      },
      "properties": {
        "name": "Botetourt County",
        "id": "51023",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51023"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -80.856,
              37.148
            ],
            [
              -80.891,
              37.126
            ],
            [
              -80.907,
              37.12
            ],
            [
              -80.933,
              37.116
            ],
            [
              -80.915,
              37.074
            ],
            [
              -80.982,
              37.055
            ],
            [
              -81.007,
              37.052
            ],
            [
              -81.023,
              37.049
            ],
            [
              -81.107,
              37.021
            ],
            [
              -81.113,
              37.022
            ],
            [
              -81.131,
              37.037
            ],
            [
              -81.167,
              37.026
            ],
            [
              -81.179,
              37.027
            ],
            [
              -81.206,
              37.045
            ],
            [
              -81.227,
              37.045
            ],
            [
              -81.241,
              37.036
            ],
            [
              -81.284,
              37.02
            ],
            [
              -81.326,
              36.989
            ],
            [
              -81.35,
              36.967
            ],
            [
              -81.356,
              36.964
            ],
            [
              -81.373,
              36.966
            ],
            [
              -81.38,
              36.952
            ],
            [
              -81.437,
              37.01
            ],
            [
              -81.462,
              37.036
            ],
            [
              -81.428,
              37.041
            ],
            [
              -81.411,
              37.053
            ],
            [
              -81.399,
              37.058
            ],
            [
              -81.375,
              37.055
            ],
            [
              -81.355,
              37.059
            ],
            [
              -81.322,
              37.069
            ],
            [
              -81.28,
              37.087
            ],
            [
              -81.269,
              37.096
            ],
            [
              -81.261,
              37.122
            ],
            [
              -81.268,
              37.129
            ],
            [
              -81.283,
              37.132
            ],
            [
              -81.295,
              37.131
            ],
            [
              -81.303,
              37.136
            ],
            [
              -81.329,
              37.14
            ],
            [
              -81.331,
              37.15
            ],
            [
              -81.3,
              37.164
            ],
            [
              -81.264,
              37.174
            ],
            [
              -81.286,
              37.216
            ],
            [
              -81.263,
              37.219
            ],
            [
              -81.228,
              37.234
            ],
            [
              -81.219,
              37.237
            ],
            [
              -81.178,
              37.257
            ],
            [
              -81.159,
              37.265
            ],
            [
              -81.122,
              37.276
            ],
            [
              -81.094,
              37.282
            ],
            [
              -81.032,
              37.292
            ],
            [
              -80.989,
              37.302
            ],
            [
              -80.978,
              37.294
            ],
            [
              -81.01,
              37.275
            ],
            [
              -80.895,
              37.18
            ],
            [
              -80.872,
              37.193
            ],
            [
              -80.862,
              37.18
            ],
            [
              -80.882,
              37.169
            ],
            [
              -80.856,
              37.148
            ]
          ]
        ]
      },
      "properties": {
        "name": "Bland County",
        "id": "51021",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51021"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.185,
              37.468
            ],
            [
              -79.209,
              37.469
            ],
            [
              -79.242,
              37.451
            ],
            [
              -79.252,
              37.447
            ],
            [
              -79.264,
              37.449
            ],
            [
              -79.268,
              37.431
            ],
            [
              -79.251,
              37.43
            ],
            [
              -79.243,
              37.42
            ],
            [
              -79.254,
              37.406
            ],
            [
              -79.232,
              37.395
            ],
            [
              -79.258,
              37.355
            ],
            [
              -79.441,
              37.06
            ],
            [
              -79.458,
              37.06
            ],
            [
              -79.475,
              37.066
            ],
            [
              -79.486,
              37.067
            ],
            [
              -79.489,
              37.058
            ],
            [
              -79.481,
              37.048
            ],
            [
              -79.481,
              37.037
            ],
            [
              -79.462,
              37.025
            ],
            [
              -79.466,
              37.018
            ],
            [
              -79.483,
              37.009
            ],
            [
              -79.489,
              37.018
            ],
            [
              -79.504,
              37.03
            ],
            [
              -79.51,
              37.031
            ],
            [
              -79.537,
              37.045
            ],
            [
              -79.541,
              37.052
            ],
            [
              -79.56,
              37.045
            ],
            [
              -79.561,
              37.037
            ],
            [
              -79.579,
              37.038
            ],
            [
              -79.596,
              37.045
            ],
            [
              -79.596,
              37.057
            ],
            [
              -79.622,
              37.08
            ],
            [
              -79.612,
              37.085
            ],
            [
              -79.615,
              37.092
            ],
            [
              -79.634,
              37.097
            ],
            [
              -79.65,
              37.119
            ],
            [
              -79.654,
              37.13
            ],
            [
              -79.662,
              37.136
            ],
            [
              -79.672,
              37.151
            ],
            [
              -79.679,
              37.156
            ],
            [
              -79.688,
              37.151
            ],
            [
              -79.701,
              37.151
            ],
            [
              -79.708,
              37.156
            ],
            [
              -79.712,
              37.174
            ],
            [
              -79.719,
              37.191
            ],
            [
              -79.734,
              37.189
            ],
            [
              -79.759,
              37.193
            ],
            [
              -79.764,
              37.202
            ],
            [
              -79.772,
              37.2
            ],
            [
              -79.779,
              37.212
            ],
            [
              -79.775,
              37.217
            ],
            [
              -79.781,
              37.23
            ],
            [
              -79.793,
              37.23
            ],
            [
              -79.793,
              37.223
            ],
            [
              -79.808,
              37.216
            ],
            [
              -79.819,
              37.224
            ],
            [
              -79.833,
              37.218
            ],
            [
              -79.843,
              37.218
            ],
            [
              -79.848,
              37.225
            ],
            [
              -79.843,
              37.231
            ],
            [
              -79.848,
              37.24
            ],
            [
              -79.845,
              37.252
            ],
            [
              -79.858,
              37.262
            ],
            [
              -79.85,
              37.278
            ],
            [
              -79.853,
              37.29
            ],
            [
              -79.843,
              37.299
            ],
            [
              -79.849,
              37.31
            ],
            [
              -79.846,
              37.316
            ],
            [
              -79.833,
              37.326
            ],
            [
              -79.818,
              37.332
            ],
            [
              -79.807,
              37.342
            ],
            [
              -79.795,
              37.348
            ],
            [
              -79.788,
              37.364
            ],
            [
              -79.778,
              37.378
            ],
            [
              -79.784,
              37.384
            ],
            [
              -79.796,
              37.385
            ],
            [
              -79.81,
              37.391
            ],
            [
              -79.815,
              37.399
            ],
            [
              -79.813,
              37.407
            ],
            [
              -79.781,
              37.417
            ],
            [
              -79.766,
              37.424
            ],
            [
              -79.72,
              37.451
            ],
            [
              -79.69,
              37.48
            ],
            [
              -79.675,
              37.489
            ],
            [
              -79.654,
              37.486
            ],
            [
              -79.641,
              37.477
            ],
            [
              -79.624,
              37.457
            ],
            [
              -79.619,
              37.459
            ],
            [
              -79.593,
              37.452
            ],
            [
              -79.583,
              37.456
            ],
            [
              -79.582,
              37.474
            ],
            [
              -79.56,
              37.497
            ],
            [
              -79.541,
              37.497
            ],
            [
              -79.536,
              37.506
            ],
            [
              -79.503,
              37.521
            ],
            [
              -79.5,
              37.536
            ],
            [
              -79.456,
              37.561
            ],
            [
              -79.438,
              37.569
            ],
            [
              -79.434,
              37.578
            ],
            [
              -79.445,
              37.58
            ],
            [
              -79.454,
              37.6
            ],
            [
              -79.454,
              37.609
            ],
            [
              -79.442,
              37.619
            ],
            [
              -79.432,
              37.615
            ],
            [
              -79.427,
              37.604
            ],
            [
              -79.403,
              37.61
            ],
            [
              -79.393,
              37.6
            ],
            [
              -79.382,
              37.596
            ],
            [
              -79.371,
              37.578
            ],
            [
              -79.363,
              37.551
            ],
            [
              -79.341,
              37.522
            ],
            [
              -79.336,
              37.519
            ],
            [
              -79.313,
              37.513
            ],
            [
              -79.288,
              37.501
            ],
            [
              -79.281,
              37.507
            ],
            [
              -79.265,
              37.513
            ],
            [
              -79.262,
              37.502
            ],
            [
              -79.251,
              37.498
            ],
            [
              -79.241,
              37.506
            ],
            [
              -79.223,
              37.508
            ],
            [
              -79.224,
              37.498
            ],
            [
              -79.214,
              37.49
            ],
            [
              -79.21,
              37.481
            ],
            [
              -79.187,
              37.477
            ],
            [
              -79.185,
              37.468
            ]
          ]
        ]
      },
      "properties": {
        "name": "Bedford County",
        "id": "51019",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51019"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.48,
              38.087
            ],
            [
              -79.502,
              38.059
            ],
            [
              -79.523,
              38.042
            ],
            [
              -79.511,
              38.035
            ],
            [
              -79.555,
              37.982
            ],
            [
              -79.574,
              37.961
            ],
            [
              -79.612,
              37.932
            ],
            [
              -79.627,
              37.912
            ],
            [
              -79.637,
              37.889
            ],
            [
              -79.648,
              37.874
            ],
            [
              -79.664,
              37.861
            ],
            [
              -79.687,
              37.838
            ],
            [
              -79.709,
              37.859
            ],
            [
              -79.727,
              37.873
            ],
            [
              -79.751,
              37.886
            ],
            [
              -79.811,
              37.883
            ],
            [
              -79.884,
              37.894
            ],
            [
              -79.893,
              37.899
            ],
            [
              -79.936,
              37.957
            ],
            [
              -79.969,
              37.955
            ],
            [
              -80.002,
              37.961
            ],
            [
              -80.015,
              37.955
            ],
            [
              -80.027,
              37.945
            ],
            [
              -80.057,
              37.954
            ],
            [
              -80.034,
              37.973
            ],
            [
              -79.999,
              37.997
            ],
            [
              -79.995,
              38.008
            ],
            [
              -79.975,
              38.031
            ],
            [
              -79.962,
              38.062
            ],
            [
              -79.95,
              38.082
            ],
            [
              -79.93,
              38.101
            ],
            [
              -79.927,
              38.109
            ],
            [
              -79.94,
              38.118
            ],
            [
              -79.941,
              38.129
            ],
            [
              -79.931,
              38.137
            ],
            [
              -79.918,
              38.154
            ],
            [
              -79.914,
              38.168
            ],
            [
              -79.919,
              38.182
            ],
            [
              -79.899,
              38.193
            ],
            [
              -79.888,
              38.205
            ],
            [
              -79.873,
              38.213
            ],
            [
              -79.86,
              38.228
            ],
            [
              -79.845,
              38.24
            ],
            [
              -79.815,
              38.252
            ],
            [
              -79.81,
              38.26
            ],
            [
              -79.788,
              38.269
            ],
            [
              -79.762,
              38.253
            ],
            [
              -79.705,
              38.221
            ],
            [
              -79.56,
              38.199
            ],
            [
              -79.511,
              38.18
            ],
            [
              -79.527,
              38.17
            ],
            [
              -79.521,
              38.162
            ],
            [
              -79.534,
              38.154
            ],
            [
              -79.506,
              38.155
            ],
            [
              -79.5,
              38.163
            ],
            [
              -79.481,
              38.171
            ],
            [
              -79.459,
              38.164
            ],
            [
              -79.444,
              38.168
            ],
            [
              -79.435,
              38.163
            ],
            [
              -79.484,
              38.105
            ],
            [
              -79.487,
              38.094
            ],
            [
              -79.48,
              38.087
            ]
          ]
        ]
      },
      "properties": {
        "name": "Bath County",
        "id": "51017",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51017"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.222,
              38.481
            ],
            [
              -79.106,
              38.415
            ],
            [
              -78.922,
              38.31
            ],
            [
              -78.912,
              38.306
            ],
            [
              -78.896,
              38.307
            ],
            [
              -78.889,
              38.305
            ],
            [
              -78.861,
              38.282
            ],
            [
              -78.811,
              38.249
            ],
            [
              -78.751,
              38.208
            ],
            [
              -78.752,
              38.196
            ],
            [
              -78.77,
              38.169
            ],
            [
              -78.771,
              38.158
            ],
            [
              -78.778,
              38.138
            ],
            [
              -78.787,
              38.125
            ],
            [
              -78.777,
              38.105
            ],
            [
              -78.781,
              38.084
            ],
            [
              -78.79,
              38.082
            ],
            [
              -78.798,
              38.068
            ],
            [
              -78.821,
              38.06
            ],
            [
              -78.839,
              38.046
            ],
            [
              -78.858,
              38.031
            ],
            [
              -78.875,
              38.029
            ],
            [
              -78.882,
              38.022
            ],
            [
              -78.882,
              38.008
            ],
            [
              -78.89,
              37.996
            ],
            [
              -78.903,
              37.989
            ],
            [
              -78.902,
              37.976
            ],
            [
              -78.891,
              37.975
            ],
            [
              -78.906,
              37.946
            ],
            [
              -78.921,
              37.946
            ],
            [
              -78.927,
              37.941
            ],
            [
              -78.948,
              37.938
            ],
            [
              -78.968,
              37.917
            ],
            [
              -78.999,
              37.889
            ],
            [
              -79.009,
              37.886
            ],
            [
              -79.045,
              37.896
            ],
            [
              -79.05,
              37.9
            ],
            [
              -79.052,
              37.915
            ],
            [
              -79.074,
              37.916
            ],
            [
              -79.087,
              37.913
            ],
            [
              -79.099,
              37.905
            ],
            [
              -79.118,
              37.903
            ],
            [
              -79.157,
              37.892
            ],
            [
              -79.167,
              37.902
            ],
            [
              -79.2,
              37.929
            ],
            [
              -79.321,
              37.995
            ],
            [
              -79.42,
              38.051
            ],
            [
              -79.48,
              38.087
            ],
            [
              -79.487,
              38.094
            ],
            [
              -79.484,
              38.105
            ],
            [
              -79.435,
              38.163
            ],
            [
              -79.444,
              38.168
            ],
            [
              -79.459,
              38.164
            ],
            [
              -79.481,
              38.171
            ],
            [
              -79.5,
              38.163
            ],
            [
              -79.506,
              38.155
            ],
            [
              -79.534,
              38.154
            ],
            [
              -79.521,
              38.162
            ],
            [
              -79.527,
              38.17
            ],
            [
              -79.511,
              38.18
            ],
            [
              -79.478,
              38.208
            ],
            [
              -79.475,
              38.218
            ],
            [
              -79.464,
              38.223
            ],
            [
              -79.438,
              38.217
            ],
            [
              -79.427,
              38.231
            ],
            [
              -79.419,
              38.234
            ],
            [
              -79.404,
              38.248
            ],
            [
              -79.398,
              38.26
            ],
            [
              -79.403,
              38.274
            ],
            [
              -79.393,
              38.292
            ],
            [
              -79.383,
              38.296
            ],
            [
              -79.382,
              38.308
            ],
            [
              -79.36,
              38.342
            ],
            [
              -79.348,
              38.355
            ],
            [
              -79.338,
              38.358
            ],
            [
              -79.335,
              38.37
            ],
            [
              -79.321,
              38.38
            ],
            [
              -79.311,
              38.383
            ],
            [
              -79.305,
              38.391
            ],
            [
              -79.317,
              38.406
            ],
            [
              -79.308,
              38.413
            ],
            [
              -79.294,
              38.42
            ],
            [
              -79.279,
              38.422
            ],
            [
              -79.279,
              38.433
            ],
            [
              -79.253,
              38.453
            ],
            [
              -79.242,
              38.457
            ],
            [
              -79.237,
              38.47
            ],
            [
              -79.222,
              38.481
            ]
          ],
          [
            [
              -78.889,
              38.097
            ],
            [
              -78.903,
              38.098
            ],
            [
              -78.929,
              38.091
            ],
            [
              -78.938,
              38.077
            ],
            [
              -78.951,
              38.069
            ],
            [
              -78.948,
              38.053
            ],
            [
              -78.93,
              38.049
            ],
            [
              -78.922,
              38.032
            ],
            [
              -78.907,
              38.043
            ],
            [
              -78.903,
              38.05
            ],
            [
              -78.883,
              38.053
            ],
            [
              -78.865,
              38.049
            ],
            [
              -78.865,
              38.062
            ],
            [
              -78.855,
              38.075
            ],
            [
              -78.865,
              38.081
            ],
            [
              -78.865,
              38.096
            ],
            [
              -78.876,
              38.092
            ],
            [
              -78.889,
              38.097
            ]
          ],
          [
            [
              -79.035,
              38.197
            ],
            [
              -79.05,
              38.187
            ],
            [
              -79.079,
              38.186
            ],
            [
              -79.095,
              38.188
            ],
            [
              -79.112,
              38.158
            ],
            [
              -79.109,
              38.14
            ],
            [
              -79.096,
              38.133
            ],
            [
              -79.079,
              38.129
            ],
            [
              -79.072,
              38.132
            ],
            [
              -79.048,
              38.121
            ],
            [
              -79.026,
              38.134
            ],
            [
              -79.019,
              38.144
            ],
            [
              -79.013,
              38.166
            ],
            [
              -79.023,
              38.176
            ],
            [
              -79.012,
              38.183
            ],
            [
              -79.035,
              38.197
            ]
          ]
        ]
      },
      "properties": {
        "name": "Augusta County",
        "id": "51015",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51015"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.041,
              38.84
            ],
            [
              -77.064,
              38.845
            ],
            [
              -77.086,
              38.845
            ],
            [
              -77.087,
              38.827
            ],
            [
              -77.11,
              38.844
            ],
            [
              -77.15,
              38.876
            ],
            [
              -77.172,
              38.893
            ],
            [
              -77.121,
              38.934
            ],
            [
              -77.093,
              38.907
            ],
            [
              -77.067,
              38.896
            ],
            [
              -77.04,
              38.871
            ],
            [
              -77.032,
              38.854
            ],
            [
              -77.034,
              38.844
            ],
            [
              -77.041,
              38.84
            ]
          ]
        ]
      },
      "properties": {
        "name": "Arlington County",
        "id": "51013",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51013"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.829,
              37.558
            ],
            [
              -78.7,
              37.45
            ],
            [
              -78.679,
              37.427
            ],
            [
              -78.643,
              37.419
            ],
            [
              -78.642,
              37.402
            ],
            [
              -78.627,
              37.388
            ],
            [
              -78.615,
              37.389
            ],
            [
              -78.602,
              37.403
            ],
            [
              -78.591,
              37.4
            ],
            [
              -78.603,
              37.354
            ],
            [
              -78.594,
              37.348
            ],
            [
              -78.597,
              37.342
            ],
            [
              -78.609,
              37.338
            ],
            [
              -78.611,
              37.33
            ],
            [
              -78.624,
              37.326
            ],
            [
              -78.646,
              37.305
            ],
            [
              -78.659,
              37.282
            ],
            [
              -78.684,
              37.259
            ],
            [
              -78.685,
              37.252
            ],
            [
              -78.707,
              37.24
            ],
            [
              -78.726,
              37.235
            ],
            [
              -78.735,
              37.222
            ],
            [
              -78.758,
              37.219
            ],
            [
              -78.77,
              37.223
            ],
            [
              -78.785,
              37.22
            ],
            [
              -78.811,
              37.198
            ],
            [
              -78.826,
              37.203
            ],
            [
              -78.862,
              37.214
            ],
            [
              -78.861,
              37.235
            ],
            [
              -78.874,
              37.242
            ],
            [
              -78.89,
              37.246
            ],
            [
              -78.912,
              37.243
            ],
            [
              -78.926,
              37.246
            ],
            [
              -78.925,
              37.264
            ],
            [
              -78.929,
              37.276
            ],
            [
              -78.943,
              37.282
            ],
            [
              -78.986,
              37.36
            ],
            [
              -79.023,
              37.432
            ],
            [
              -79.016,
              37.433
            ],
            [
              -79.011,
              37.447
            ],
            [
              -78.998,
              37.452
            ],
            [
              -78.986,
              37.466
            ],
            [
              -78.969,
              37.476
            ],
            [
              -78.95,
              37.483
            ],
            [
              -78.946,
              37.491
            ],
            [
              -78.954,
              37.499
            ],
            [
              -78.946,
              37.503
            ],
            [
              -78.93,
              37.499
            ],
            [
              -78.919,
              37.503
            ],
            [
              -78.903,
              37.514
            ],
            [
              -78.903,
              37.53
            ],
            [
              -78.887,
              37.531
            ],
            [
              -78.875,
              37.543
            ],
            [
              -78.86,
              37.545
            ],
            [
              -78.843,
              37.536
            ],
            [
              -78.833,
              37.538
            ],
            [
              -78.833,
              37.553
            ],
            [
              -78.829,
              37.558
            ]
          ]
        ]
      },
      "properties": {
        "name": "Appomattox County",
        "id": "51011",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51011"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.875,
              37.543
            ],
            [
              -78.887,
              37.531
            ],
            [
              -78.903,
              37.53
            ],
            [
              -78.903,
              37.514
            ],
            [
              -78.919,
              37.503
            ],
            [
              -78.93,
              37.499
            ],
            [
              -78.946,
              37.503
            ],
            [
              -78.954,
              37.499
            ],
            [
              -78.946,
              37.491
            ],
            [
              -78.95,
              37.483
            ],
            [
              -78.969,
              37.476
            ],
            [
              -78.986,
              37.466
            ],
            [
              -78.998,
              37.452
            ],
            [
              -79.011,
              37.447
            ],
            [
              -79.016,
              37.433
            ],
            [
              -79.023,
              37.432
            ],
            [
              -79.039,
              37.435
            ],
            [
              -79.042,
              37.421
            ],
            [
              -79.051,
              37.418
            ],
            [
              -79.065,
              37.424
            ],
            [
              -79.071,
              37.422
            ],
            [
              -79.062,
              37.397
            ],
            [
              -79.072,
              37.389
            ],
            [
              -79.085,
              37.396
            ],
            [
              -79.102,
              37.407
            ],
            [
              -79.111,
              37.408
            ],
            [
              -79.116,
              37.402
            ],
            [
              -79.127,
              37.404
            ],
            [
              -79.139,
              37.42
            ],
            [
              -79.148,
              37.437
            ],
            [
              -79.179,
              37.455
            ],
            [
              -79.185,
              37.468
            ],
            [
              -79.187,
              37.477
            ],
            [
              -79.21,
              37.481
            ],
            [
              -79.214,
              37.49
            ],
            [
              -79.224,
              37.498
            ],
            [
              -79.223,
              37.508
            ],
            [
              -79.241,
              37.506
            ],
            [
              -79.251,
              37.498
            ],
            [
              -79.262,
              37.502
            ],
            [
              -79.265,
              37.513
            ],
            [
              -79.281,
              37.507
            ],
            [
              -79.288,
              37.501
            ],
            [
              -79.313,
              37.513
            ],
            [
              -79.336,
              37.519
            ],
            [
              -79.341,
              37.522
            ],
            [
              -79.363,
              37.551
            ],
            [
              -79.371,
              37.578
            ],
            [
              -79.382,
              37.596
            ],
            [
              -79.393,
              37.6
            ],
            [
              -79.403,
              37.61
            ],
            [
              -79.427,
              37.604
            ],
            [
              -79.432,
              37.615
            ],
            [
              -79.42,
              37.626
            ],
            [
              -79.399,
              37.63
            ],
            [
              -79.379,
              37.644
            ],
            [
              -79.36,
              37.652
            ],
            [
              -79.353,
              37.66
            ],
            [
              -79.339,
              37.664
            ],
            [
              -79.34,
              37.68
            ],
            [
              -79.321,
              37.7
            ],
            [
              -79.318,
              37.717
            ],
            [
              -79.304,
              37.729
            ],
            [
              -79.304,
              37.741
            ],
            [
              -79.297,
              37.752
            ],
            [
              -79.284,
              37.764
            ],
            [
              -79.272,
              37.779
            ],
            [
              -79.273,
              37.794
            ],
            [
              -79.256,
              37.797
            ],
            [
              -79.245,
              37.809
            ],
            [
              -79.23,
              37.814
            ],
            [
              -79.213,
              37.796
            ],
            [
              -79.2,
              37.791
            ],
            [
              -79.172,
              37.804
            ],
            [
              -79.139,
              37.816
            ],
            [
              -79.12,
              37.802
            ],
            [
              -79.117,
              37.792
            ],
            [
              -79.11,
              37.789
            ],
            [
              -79.089,
              37.789
            ],
            [
              -79.071,
              37.78
            ],
            [
              -79.067,
              37.775
            ],
            [
              -79.07,
              37.76
            ],
            [
              -79.067,
              37.751
            ],
            [
              -79.068,
              37.732
            ],
            [
              -79.066,
              37.718
            ],
            [
              -79.042,
              37.713
            ],
            [
              -79.029,
              37.706
            ],
            [
              -79.019,
              37.707
            ],
            [
              -78.999,
              37.701
            ],
            [
              -78.988,
              37.695
            ],
            [
              -78.983,
              37.687
            ],
            [
              -78.972,
              37.684
            ],
            [
              -78.962,
              37.677
            ],
            [
              -78.96,
              37.662
            ],
            [
              -78.949,
              37.65
            ],
            [
              -78.908,
              37.552
            ],
            [
              -78.893,
              37.546
            ],
            [
              -78.88,
              37.547
            ],
            [
              -78.875,
              37.543
            ]
          ]
        ]
      },
      "properties": {
        "name": "Amherst County",
        "id": "51009",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51009"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.858,
              37.419
            ],
            [
              -77.877,
              37.415
            ],
            [
              -77.871,
              37.395
            ],
            [
              -77.879,
              37.384
            ],
            [
              -77.879,
              37.366
            ],
            [
              -77.864,
              37.364
            ],
            [
              -77.854,
              37.358
            ],
            [
              -77.852,
              37.345
            ],
            [
              -77.842,
              37.34
            ],
            [
              -77.818,
              37.339
            ],
            [
              -77.8,
              37.333
            ],
            [
              -77.801,
              37.322
            ],
            [
              -77.809,
              37.313
            ],
            [
              -77.804,
              37.303
            ],
            [
              -77.784,
              37.295
            ],
            [
              -77.774,
              37.287
            ],
            [
              -77.77,
              37.277
            ],
            [
              -77.757,
              37.269
            ],
            [
              -77.743,
              37.27
            ],
            [
              -77.738,
              37.285
            ],
            [
              -77.719,
              37.286
            ],
            [
              -77.719,
              37.297
            ],
            [
              -77.708,
              37.3
            ],
            [
              -77.696,
              37.284
            ],
            [
              -77.677,
              37.295
            ],
            [
              -77.668,
              37.291
            ],
            [
              -77.665,
              37.281
            ],
            [
              -77.651,
              37.267
            ],
            [
              -77.664,
              37.244
            ],
            [
              -77.673,
              37.243
            ],
            [
              -77.69,
              37.234
            ],
            [
              -77.695,
              37.224
            ],
            [
              -77.723,
              37.214
            ],
            [
              -77.73,
              37.204
            ],
            [
              -77.749,
              37.195
            ],
            [
              -77.79,
              37.196
            ],
            [
              -77.802,
              37.19
            ],
            [
              -78.239,
              37.295
            ],
            [
              -78.239,
              37.367
            ],
            [
              -78.238,
              37.382
            ],
            [
              -78.231,
              37.385
            ],
            [
              -78.223,
              37.399
            ],
            [
              -78.214,
              37.404
            ],
            [
              -78.207,
              37.424
            ],
            [
              -78.188,
              37.431
            ],
            [
              -78.189,
              37.439
            ],
            [
              -78.183,
              37.445
            ],
            [
              -78.172,
              37.443
            ],
            [
              -78.159,
              37.453
            ],
            [
              -78.137,
              37.459
            ],
            [
              -78.132,
              37.456
            ],
            [
              -78.125,
              37.445
            ],
            [
              -78.11,
              37.448
            ],
            [
              -78.099,
              37.438
            ],
            [
              -78.092,
              37.453
            ],
            [
              -78.077,
              37.455
            ],
            [
              -78.065,
              37.451
            ],
            [
              -78.05,
              37.472
            ],
            [
              -78.029,
              37.475
            ],
            [
              -78.024,
              37.485
            ],
            [
              -78.011,
              37.497
            ],
            [
              -78.001,
              37.498
            ],
            [
              -77.99,
              37.488
            ],
            [
              -77.969,
              37.486
            ],
            [
              -77.939,
              37.477
            ],
            [
              -77.93,
              37.482
            ],
            [
              -77.913,
              37.476
            ],
            [
              -77.896,
              37.476
            ],
            [
              -77.898,
              37.458
            ],
            [
              -77.887,
              37.451
            ],
            [
              -77.876,
              37.459
            ],
            [
              -77.869,
              37.456
            ],
            [
              -77.868,
              37.442
            ],
            [
              -77.858,
              37.432
            ],
            [
              -77.858,
              37.419
            ]
          ]
        ]
      },
      "properties": {
        "name": "Amelia County",
        "id": "51007",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51007"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -79.648,
              37.874
            ],
            [
              -79.627,
              37.875
            ],
            [
              -79.607,
              37.86
            ],
            [
              -79.617,
              37.851
            ],
            [
              -79.623,
              37.833
            ],
            [
              -79.633,
              37.82
            ],
            [
              -79.645,
              37.813
            ],
            [
              -79.663,
              37.777
            ],
            [
              -79.674,
              37.764
            ],
            [
              -79.817,
              37.801
            ],
            [
              -79.845,
              37.784
            ],
            [
              -79.854,
              37.764
            ],
            [
              -79.872,
              37.748
            ],
            [
              -79.897,
              37.733
            ],
            [
              -79.92,
              37.703
            ],
            [
              -79.944,
              37.697
            ],
            [
              -79.958,
              37.684
            ],
            [
              -79.973,
              37.678
            ],
            [
              -79.992,
              37.664
            ],
            [
              -80.021,
              37.649
            ],
            [
              -80.036,
              37.659
            ],
            [
              -80.073,
              37.637
            ],
            [
              -80.103,
              37.626
            ],
            [
              -80.136,
              37.603
            ],
            [
              -80.15,
              37.601
            ],
            [
              -80.173,
              37.615
            ],
            [
              -80.203,
              37.618
            ],
            [
              -80.221,
              37.628
            ],
            [
              -80.265,
              37.649
            ],
            [
              -80.277,
              37.658
            ],
            [
              -80.307,
              37.69
            ],
            [
              -80.283,
              37.7
            ],
            [
              -80.266,
              37.719
            ],
            [
              -80.254,
              37.73
            ],
            [
              -80.264,
              37.74
            ],
            [
              -80.257,
              37.756
            ],
            [
              -80.248,
              37.767
            ],
            [
              -80.231,
              37.779
            ],
            [
              -80.222,
              37.779
            ],
            [
              -80.228,
              37.796
            ],
            [
              -80.226,
              37.803
            ],
            [
              -80.211,
              37.816
            ],
            [
              -80.197,
              37.833
            ],
            [
              -80.183,
              37.84
            ],
            [
              -80.182,
              37.851
            ],
            [
              -80.165,
              37.875
            ],
            [
              -80.154,
              37.883
            ],
            [
              -80.14,
              37.886
            ],
            [
              -80.123,
              37.899
            ],
            [
              -80.112,
              37.912
            ],
            [
              -80.093,
              37.925
            ],
            [
              -80.084,
              37.936
            ],
            [
              -80.057,
              37.954
            ],
            [
              -80.027,
              37.945
            ],
            [
              -80.015,
              37.955
            ],
            [
              -80.002,
              37.961
            ],
            [
              -79.969,
              37.955
            ],
            [
              -79.936,
              37.957
            ],
            [
              -79.893,
              37.899
            ],
            [
              -79.884,
              37.894
            ],
            [
              -79.811,
              37.883
            ],
            [
              -79.751,
              37.886
            ],
            [
              -79.727,
              37.873
            ],
            [
              -79.709,
              37.859
            ],
            [
              -79.687,
              37.838
            ],
            [
              -79.664,
              37.861
            ],
            [
              -79.648,
              37.874
            ]
          ],
          [
            [
              -79.977,
              37.754
            ],
            [
              -79.972,
              37.77
            ],
            [
              -79.973,
              37.782
            ],
            [
              -79.981,
              37.797
            ],
            [
              -79.983,
              37.812
            ],
            [
              -79.989,
              37.816
            ],
            [
              -79.998,
              37.806
            ],
            [
              -80,
              37.78
            ],
            [
              -80.007,
              37.762
            ],
            [
              -79.993,
              37.748
            ],
            [
              -79.977,
              37.754
            ]
          ]
        ]
      },
      "properties": {
        "name": "Alleghany County",
        "id": "51005",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51005"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -77.04,
              38.786
            ],
            [
              -77.062,
              38.795
            ],
            [
              -77.084,
              38.801
            ],
            [
              -77.115,
              38.802
            ],
            [
              -77.139,
              38.798
            ],
            [
              -77.145,
              38.81
            ],
            [
              -77.142,
              38.827
            ],
            [
              -77.128,
              38.837
            ],
            [
              -77.11,
              38.844
            ],
            [
              -77.087,
              38.827
            ],
            [
              -77.086,
              38.845
            ],
            [
              -77.064,
              38.845
            ],
            [
              -77.041,
              38.84
            ],
            [
              -77.038,
              38.807
            ],
            [
              -77.04,
              38.786
            ]
          ]
        ]
      },
      "properties": {
        "name": "Alexandria City",
        "id": "51510",
        "STATE": "VA",
        "TYPE": "City",
        "CNTRY": "USA"
      },
      "id": "51510"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "Polygon",
        "coordinates": [
          [
            [
              -78.369,
              38.186
            ],
            [
              -78.336,
              38.178
            ],
            [
              -78.208,
              38.131
            ],
            [
              -78.225,
              38.105
            ],
            [
              -78.255,
              38.064
            ],
            [
              -78.306,
              38.007
            ],
            [
              -78.487,
              37.801
            ],
            [
              -78.49,
              37.792
            ],
            [
              -78.499,
              37.787
            ],
            [
              -78.497,
              37.769
            ],
            [
              -78.503,
              37.76
            ],
            [
              -78.523,
              37.76
            ],
            [
              -78.548,
              37.765
            ],
            [
              -78.589,
              37.756
            ],
            [
              -78.611,
              37.756
            ],
            [
              -78.643,
              37.738
            ],
            [
              -78.652,
              37.729
            ],
            [
              -78.672,
              37.729
            ],
            [
              -78.691,
              37.748
            ],
            [
              -78.683,
              37.759
            ],
            [
              -78.669,
              37.761
            ],
            [
              -78.679,
              37.771
            ],
            [
              -78.692,
              37.777
            ],
            [
              -78.682,
              37.782
            ],
            [
              -78.687,
              37.789
            ],
            [
              -78.703,
              37.826
            ],
            [
              -78.749,
              37.896
            ],
            [
              -78.839,
              38.046
            ],
            [
              -78.821,
              38.06
            ],
            [
              -78.798,
              38.068
            ],
            [
              -78.79,
              38.082
            ],
            [
              -78.781,
              38.084
            ],
            [
              -78.777,
              38.105
            ],
            [
              -78.787,
              38.125
            ],
            [
              -78.778,
              38.138
            ],
            [
              -78.771,
              38.158
            ],
            [
              -78.77,
              38.169
            ],
            [
              -78.752,
              38.196
            ],
            [
              -78.751,
              38.208
            ],
            [
              -78.743,
              38.219
            ],
            [
              -78.732,
              38.225
            ],
            [
              -78.729,
              38.233
            ],
            [
              -78.72,
              38.235
            ],
            [
              -78.713,
              38.245
            ],
            [
              -78.699,
              38.247
            ],
            [
              -78.68,
              38.255
            ],
            [
              -78.669,
              38.249
            ],
            [
              -78.655,
              38.258
            ],
            [
              -78.664,
              38.265
            ],
            [
              -78.659,
              38.278
            ],
            [
              -78.558,
              38.243
            ],
            [
              -78.398,
              38.192
            ],
            [
              -78.369,
              38.186
            ]
          ],
          [
            [
              -78.47,
              38.055
            ],
            [
              -78.465,
              38.064
            ],
            [
              -78.471,
              38.071
            ],
            [
              -78.485,
              38.069
            ],
            [
              -78.508,
              38.056
            ],
            [
              -78.517,
              38.042
            ],
            [
              -78.524,
              38.018
            ],
            [
              -78.519,
              38.011
            ],
            [
              -78.492,
              38.008
            ],
            [
              -78.487,
              38.015
            ],
            [
              -78.471,
              38.012
            ],
            [
              -78.452,
              38.029
            ],
            [
              -78.456,
              38.054
            ],
            [
              -78.47,
              38.055
            ]
          ]
        ]
      },
      "properties": {
        "name": "Albemarle County",
        "id": "51003",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51003"
    },
    {
      "type": "Feature",
      "geometry": {
        "type": "MultiPolygon",
        "coordinates": [
          [
            [
              [
                -75.778,
                37.774
              ],
              [
                -75.78,
                37.769
              ],
              [
                -75.797,
                37.765
              ],
              [
                -75.798,
                37.776
              ],
              [
                -75.787,
                37.779
              ],
              [
                -75.778,
                37.774
              ]
            ]
          ],
          [
            [
              [
                -75.61,
                37.58
              ],
              [
                -75.6,
                37.58
              ],
              [
                -75.601,
                37.567
              ],
              [
                -75.632,
                37.519
              ],
              [
                -75.643,
                37.498
              ],
              [
                -75.662,
                37.48
              ],
              [
                -75.668,
                37.482
              ],
              [
                -75.66,
                37.495
              ],
              [
                -75.659,
                37.524
              ],
              [
                -75.686,
                37.527
              ],
              [
                -75.695,
                37.515
              ],
              [
                -75.714,
                37.514
              ],
              [
                -75.708,
                37.523
              ],
              [
                -75.718,
                37.545
              ],
              [
                -75.712,
                37.557
              ],
              [
                -75.695,
                37.539
              ],
              [
                -75.672,
                37.539
              ],
              [
                -75.67,
                37.534
              ],
              [
                -75.654,
                37.537
              ],
              [
                -75.649,
                37.553
              ],
              [
                -75.636,
                37.565
              ],
              [
                -75.618,
                37.568
              ],
              [
                -75.61,
                37.58
              ]
            ]
          ],
          [
            [
              [
                -75.444,
                37.895
              ],
              [
                -75.431,
                37.892
              ],
              [
                -75.429,
                37.884
              ],
              [
                -75.441,
                37.873
              ],
              [
                -75.473,
                37.85
              ],
              [
                -75.489,
                37.831
              ],
              [
                -75.492,
                37.846
              ],
              [
                -75.48,
                37.853
              ],
              [
                -75.479,
                37.859
              ],
              [
                -75.465,
                37.874
              ],
              [
                -75.452,
                37.892
              ],
              [
                -75.444,
                37.895
              ]
            ]
          ],
          [
            [
              [
                -75.687,
                37.47
              ],
              [
                -75.695,
                37.46
              ],
              [
                -75.707,
                37.461
              ],
              [
                -75.71,
                37.468
              ],
              [
                -75.687,
                37.47
              ]
            ]
          ],
          [
            [
              [
                -75.574,
                37.695
              ],
              [
                -75.578,
                37.684
              ],
              [
                -75.591,
                37.696
              ],
              [
                -75.574,
                37.709
              ],
              [
                -75.562,
                37.736
              ],
              [
                -75.556,
                37.762
              ],
              [
                -75.537,
                37.768
              ],
              [
                -75.531,
                37.783
              ],
              [
                -75.534,
                37.792
              ],
              [
                -75.526,
                37.796
              ],
              [
                -75.524,
                37.812
              ],
              [
                -75.529,
                37.817
              ],
              [
                -75.517,
                37.826
              ],
              [
                -75.507,
                37.827
              ],
              [
                -75.498,
                37.82
              ],
              [
                -75.51,
                37.804
              ],
              [
                -75.53,
                37.766
              ],
              [
                -75.545,
                37.748
              ],
              [
                -75.564,
                37.709
              ],
              [
                -75.574,
                37.695
              ]
            ]
          ],
          [
            [
              [
                -75.894,
                37.885
              ],
              [
                -75.909,
                37.888
              ],
              [
                -75.912,
                37.901
              ],
              [
                -75.903,
                37.901
              ],
              [
                -75.894,
                37.885
              ]
            ]
          ],
          [
            [
              [
                -75.585,
                37.663
              ],
              [
                -75.591,
                37.644
              ],
              [
                -75.602,
                37.625
              ],
              [
                -75.608,
                37.61
              ],
              [
                -75.609,
                37.595
              ],
              [
                -75.624,
                37.597
              ],
              [
                -75.638,
                37.592
              ],
              [
                -75.647,
                37.596
              ],
              [
                -75.669,
                37.596
              ],
              [
                -75.67,
                37.6
              ],
              [
                -75.657,
                37.615
              ],
              [
                -75.653,
                37.624
              ],
              [
                -75.644,
                37.62
              ],
              [
                -75.642,
                37.605
              ],
              [
                -75.629,
                37.602
              ],
              [
                -75.613,
                37.61
              ],
              [
                -75.61,
                37.621
              ],
              [
                -75.637,
                37.63
              ],
              [
                -75.638,
                37.645
              ],
              [
                -75.621,
                37.652
              ],
              [
                -75.611,
                37.652
              ],
              [
                -75.606,
                37.661
              ],
              [
                -75.586,
                37.675
              ],
              [
                -75.578,
                37.673
              ],
              [
                -75.585,
                37.663
              ]
            ]
          ],
          [
            [
              [
                -75.682,
                37.482
              ],
              [
                -75.7,
                37.477
              ],
              [
                -75.699,
                37.484
              ],
              [
                -75.69,
                37.489
              ],
              [
                -75.682,
                37.482
              ]
            ]
          ],
          [
            [
              [
                -75.662,
                37.502
              ],
              [
                -75.674,
                37.492
              ],
              [
                -75.689,
                37.508
              ],
              [
                -75.68,
                37.513
              ],
              [
                -75.677,
                37.522
              ],
              [
                -75.664,
                37.522
              ],
              [
                -75.662,
                37.502
              ]
            ]
          ],
          [
            [
              [
                -75.645,
                37.587
              ],
              [
                -75.628,
                37.59
              ],
              [
                -75.623,
                37.572
              ],
              [
                -75.635,
                37.568
              ],
              [
                -75.645,
                37.574
              ],
              [
                -75.671,
                37.575
              ],
              [
                -75.658,
                37.594
              ],
              [
                -75.645,
                37.587
              ]
            ]
          ],
          [
            [
              [
                -75.99,
                37.81
              ],
              [
                -75.999,
                37.816
              ],
              [
                -75.995,
                37.826
              ],
              [
                -75.995,
                37.841
              ],
              [
                -76.003,
                37.846
              ],
              [
                -75.998,
                37.853
              ],
              [
                -75.985,
                37.843
              ],
              [
                -75.988,
                37.84
              ],
              [
                -75.985,
                37.824
              ],
              [
                -75.99,
                37.81
              ]
            ]
          ],
          [
            [
              [
                -75.315,
                37.984
              ],
              [
                -75.331,
                37.963
              ],
              [
                -75.338,
                37.96
              ],
              [
                -75.344,
                37.95
              ],
              [
                -75.342,
                37.941
              ],
              [
                -75.352,
                37.926
              ],
              [
                -75.38,
                37.921
              ],
              [
                -75.381,
                37.914
              ],
              [
                -75.39,
                37.908
              ],
              [
                -75.405,
                37.903
              ],
              [
                -75.417,
                37.903
              ],
              [
                -75.371,
                37.945
              ],
              [
                -75.362,
                37.957
              ],
              [
                -75.341,
                37.967
              ],
              [
                -75.33,
                37.985
              ],
              [
                -75.315,
                37.984
              ]
            ]
          ],
          [
            [
              [
                -75.384,
                37.95
              ],
              [
                -75.393,
                37.935
              ],
              [
                -75.402,
                37.931
              ],
              [
                -75.413,
                37.943
              ],
              [
                -75.409,
                37.95
              ],
              [
                -75.384,
                37.95
              ]
            ]
          ],
          [
            [
              [
                -75.431,
                37.928
              ],
              [
                -75.414,
                37.928
              ],
              [
                -75.415,
                37.916
              ],
              [
                -75.425,
                37.916
              ],
              [
                -75.431,
                37.911
              ],
              [
                -75.44,
                37.919
              ],
              [
                -75.445,
                37.936
              ],
              [
                -75.432,
                37.938
              ],
              [
                -75.431,
                37.928
              ]
            ]
          ],
          [
            [
              [
                -75.812,
                37.47
              ],
              [
                -75.811,
                37.481
              ],
              [
                -75.798,
                37.49
              ],
              [
                -75.799,
                37.507
              ],
              [
                -75.808,
                37.515
              ],
              [
                -75.795,
                37.523
              ],
              [
                -75.79,
                37.531
              ],
              [
                -75.836,
                37.555
              ],
              [
                -75.848,
                37.555
              ],
              [
                -75.851,
                37.558
              ],
              [
                -75.871,
                37.561
              ],
              [
                -75.876,
                37.557
              ],
              [
                -75.916,
                37.566
              ],
              [
                -75.942,
                37.566
              ],
              [
                -75.929,
                37.586
              ],
              [
                -75.917,
                37.586
              ],
              [
                -75.902,
                37.576
              ],
              [
                -75.888,
                37.583
              ],
              [
                -75.906,
                37.589
              ],
              [
                -75.914,
                37.6
              ],
              [
                -75.924,
                37.595
              ],
              [
                -75.928,
                37.607
              ],
              [
                -75.91,
                37.619
              ],
              [
                -75.897,
                37.61
              ],
              [
                -75.885,
                37.609
              ],
              [
                -75.873,
                37.601
              ],
              [
                -75.865,
                37.616
              ],
              [
                -75.867,
                37.622
              ],
              [
                -75.857,
                37.627
              ],
              [
                -75.842,
                37.628
              ],
              [
                -75.843,
                37.637
              ],
              [
                -75.876,
                37.627
              ],
              [
                -75.88,
                37.635
              ],
              [
                -75.895,
                37.645
              ],
              [
                -75.891,
                37.658
              ],
              [
                -75.873,
                37.652
              ],
              [
                -75.877,
                37.663
              ],
              [
                -75.871,
                37.669
              ],
              [
                -75.845,
                37.67
              ],
              [
                -75.832,
                37.666
              ],
              [
                -75.83,
                37.656
              ],
              [
                -75.817,
                37.653
              ],
              [
                -75.815,
                37.667
              ],
              [
                -75.825,
                37.68
              ],
              [
                -75.848,
                37.68
              ],
              [
                -75.848,
                37.698
              ],
              [
                -75.838,
                37.704
              ],
              [
                -75.835,
                37.718
              ],
              [
                -75.825,
                37.718
              ],
              [
                -75.808,
                37.71
              ],
              [
                -75.8,
                37.716
              ],
              [
                -75.774,
                37.712
              ],
              [
                -75.773,
                37.704
              ],
              [
                -75.761,
                37.708
              ],
              [
                -75.758,
                37.714
              ],
              [
                -75.776,
                37.721
              ],
              [
                -75.796,
                37.734
              ],
              [
                -75.829,
                37.736
              ],
              [
                -75.813,
                37.752
              ],
              [
                -75.797,
                37.753
              ],
              [
                -75.78,
                37.76
              ],
              [
                -75.778,
                37.752
              ],
              [
                -75.766,
                37.755
              ],
              [
                -75.771,
                37.764
              ],
              [
                -75.763,
                37.769
              ],
              [
                -75.786,
                37.787
              ],
              [
                -75.805,
                37.786
              ],
              [
                -75.815,
                37.793
              ],
              [
                -75.788,
                37.806
              ],
              [
                -75.783,
                37.811
              ],
              [
                -75.765,
                37.802
              ],
              [
                -75.778,
                37.799
              ],
              [
                -75.767,
                37.79
              ],
              [
                -75.755,
                37.799
              ],
              [
                -75.744,
                37.787
              ],
              [
                -75.732,
                37.787
              ],
              [
                -75.72,
                37.798
              ],
              [
                -75.708,
                37.786
              ],
              [
                -75.702,
                37.792
              ],
              [
                -75.707,
                37.799
              ],
              [
                -75.699,
                37.804
              ],
              [
                -75.702,
                37.811
              ],
              [
                -75.722,
                37.808
              ],
              [
                -75.718,
                37.82
              ],
              [
                -75.707,
                37.82
              ],
              [
                -75.711,
                37.833
              ],
              [
                -75.706,
                37.848
              ],
              [
                -75.695,
                37.848
              ],
              [
                -75.68,
                37.838
              ],
              [
                -75.662,
                37.834
              ],
              [
                -75.661,
                37.839
              ],
              [
                -75.674,
                37.852
              ],
              [
                -75.653,
                37.861
              ],
              [
                -75.663,
                37.866
              ],
              [
                -75.685,
                37.86
              ],
              [
                -75.689,
                37.865
              ],
              [
                -75.68,
                37.884
              ],
              [
                -75.665,
                37.883
              ],
              [
                -75.686,
                37.896
              ],
              [
                -75.674,
                37.909
              ],
              [
                -75.69,
                37.911
              ],
              [
                -75.708,
                37.903
              ],
              [
                -75.716,
                37.914
              ],
              [
                -75.725,
                37.902
              ],
              [
                -75.747,
                37.899
              ],
              [
                -75.76,
                37.9
              ],
              [
                -75.76,
                37.908
              ],
              [
                -75.743,
                37.909
              ],
              [
                -75.745,
                37.916
              ],
              [
                -75.729,
                37.926
              ],
              [
                -75.719,
                37.939
              ],
              [
                -75.702,
                37.931
              ],
              [
                -75.692,
                37.935
              ],
              [
                -75.681,
                37.945
              ],
              [
                -75.667,
                37.94
              ],
              [
                -75.65,
                37.938
              ],
              [
                -75.637,
                37.95
              ],
              [
                -75.647,
                37.974
              ],
              [
                -75.624,
                37.995
              ],
              [
                -75.53,
                38.005
              ],
              [
                -75.377,
                38.018
              ],
              [
                -75.379,
                38.009
              ],
              [
                -75.39,
                38.008
              ],
              [
                -75.403,
                37.996
              ],
              [
                -75.4,
                37.988
              ],
              [
                -75.423,
                37.99
              ],
              [
                -75.433,
                37.96
              ],
              [
                -75.422,
                37.954
              ],
              [
                -75.422,
                37.943
              ],
              [
                -75.428,
                37.939
              ],
              [
                -75.443,
                37.94
              ],
              [
                -75.447,
                37.932
              ],
              [
                -75.441,
                37.916
              ],
              [
                -75.449,
                37.898
              ],
              [
                -75.463,
                37.885
              ],
              [
                -75.479,
                37.885
              ],
              [
                -75.47,
                37.896
              ],
              [
                -75.464,
                37.908
              ],
              [
                -75.452,
                37.915
              ],
              [
                -75.46,
                37.922
              ],
              [
                -75.473,
                37.918
              ],
              [
                -75.488,
                37.892
              ],
              [
                -75.499,
                37.878
              ],
              [
                -75.498,
                37.872
              ],
              [
                -75.472,
                37.869
              ],
              [
                -75.495,
                37.848
              ],
              [
                -75.507,
                37.855
              ],
              [
                -75.511,
                37.83
              ],
              [
                -75.521,
                37.828
              ],
              [
                -75.532,
                37.819
              ],
              [
                -75.537,
                37.792
              ],
              [
                -75.534,
                37.782
              ],
              [
                -75.541,
                37.768
              ],
              [
                -75.552,
                37.767
              ],
              [
                -75.552,
                37.778
              ],
              [
                -75.559,
                37.781
              ],
              [
                -75.579,
                37.742
              ],
              [
                -75.588,
                37.733
              ],
              [
                -75.598,
                37.728
              ],
              [
                -75.605,
                37.713
              ],
              [
                -75.617,
                37.697
              ],
              [
                -75.616,
                37.694
              ],
              [
                -75.596,
                37.687
              ],
              [
                -75.589,
                37.677
              ],
              [
                -75.598,
                37.668
              ],
              [
                -75.611,
                37.667
              ],
              [
                -75.62,
                37.669
              ],
              [
                -75.628,
                37.658
              ],
              [
                -75.645,
                37.656
              ],
              [
                -75.658,
                37.633
              ],
              [
                -75.671,
                37.62
              ],
              [
                -75.665,
                37.612
              ],
              [
                -75.675,
                37.601
              ],
              [
                -75.689,
                37.601
              ],
              [
                -75.699,
                37.59
              ],
              [
                -75.697,
                37.576
              ],
              [
                -75.675,
                37.572
              ],
              [
                -75.647,
                37.573
              ],
              [
                -75.65,
                37.56
              ],
              [
                -75.657,
                37.559
              ],
              [
                -75.665,
                37.568
              ],
              [
                -75.681,
                37.561
              ],
              [
                -75.673,
                37.542
              ],
              [
                -75.692,
                37.544
              ],
              [
                -75.711,
                37.563
              ],
              [
                -75.73,
                37.557
              ],
              [
                -75.756,
                37.517
              ],
              [
                -75.756,
                37.511
              ],
              [
                -75.736,
                37.51
              ],
              [
                -75.72,
                37.495
              ],
              [
                -75.721,
                37.485
              ],
              [
                -75.734,
                37.489
              ],
              [
                -75.74,
                37.48
              ],
              [
                -75.747,
                37.481
              ],
              [
                -75.746,
                37.493
              ],
              [
                -75.772,
                37.497
              ],
              [
                -75.786,
                37.487
              ],
              [
                -75.797,
                37.482
              ],
              [
                -75.812,
                37.47
              ]
            ]
          ],
          [
            [
              [
                -75.265,
                37.997
              ],
              [
                -75.282,
                37.977
              ],
              [
                -75.3,
                37.961
              ],
              [
                -75.33,
                37.907
              ],
              [
                -75.339,
                37.887
              ],
              [
                -75.36,
                37.87
              ],
              [
                -75.372,
                37.866
              ],
              [
                -75.384,
                37.87
              ],
              [
                -75.392,
                37.88
              ],
              [
                -75.382,
                37.883
              ],
              [
                -75.363,
                37.879
              ],
              [
                -75.349,
                37.888
              ],
              [
                -75.357,
                37.897
              ],
              [
                -75.37,
                37.9
              ],
              [
                -75.373,
                37.914
              ],
              [
                -75.368,
                37.918
              ],
              [
                -75.347,
                37.918
              ],
              [
                -75.341,
                37.929
              ],
              [
                -75.334,
                37.929
              ],
              [
                -75.326,
                37.938
              ],
              [
                -75.319,
                37.956
              ],
              [
                -75.306,
                37.977
              ],
              [
                -75.306,
                37.99
              ],
              [
                -75.302,
                37.997
              ],
              [
                -75.286,
                38
              ],
              [
                -75.27,
                38.016
              ],
              [
                -75.273,
                38.026
              ],
              [
                -75.241,
                38.029
              ],
              [
                -75.252,
                38.019
              ],
              [
                -75.265,
                37.997
              ]
            ]
          ]
        ]
      },
      "properties": {
        "name": "Accomack County",
        "id": "51001",
        "STATE": "VA",
        "TYPE": "County",
        "CNTRY": "USA"
      },
      "id": "51001"
    }
  ],
  "style": {
    "stroke": "#000000",
    "fill": "#3498DB",
    "stroke-width": 1,
    "fill-opacity": 0.8
  }
}
